/**
 * AUTO-GENERATED — do not edit.
 * Source: docs/reference/api-contract-manifest.json
 * Regenerate: cd api/dashboard && npm run gen:contract
 */
export const CONTRACT_VERSION = 1;
export const CONTRACT_GENERATED_AT = "2026-10-06T16:01:56Z";
export const CONTRACT_OPERATION_COUNT = 809;

/** @type {Record<string, import("./contract-client.js").ContractOperation>} */
export const CONTRACT_BY_ID = {
  "get__activate_status": {
    "operation_id": "get__activate_status",
    "method": "GET",
    "path": "/activate/status",
    "public_path": "/api/activate/status",
    "auth": "session_csrf",
    "path_template": "/activate/status",
    "domain": "activate"
  },
  "get__activity_records": {
    "operation_id": "get__activity_records",
    "method": "GET",
    "path": "/activity/records",
    "public_path": "/api/activity/records",
    "auth": "session_csrf",
    "path_template": "/activity/records",
    "domain": "activity"
  },
  "post__activity_scope-token_mint": {
    "operation_id": "post__activity_scope-token_mint",
    "method": "POST",
    "path": "/activity/scope-token/mint",
    "public_path": "/api/activity/scope-token/mint",
    "auth": "session_csrf",
    "path_template": "/activity/scope-token/mint",
    "domain": "activity"
  },
  "post__activity_scope-token_verify": {
    "operation_id": "post__activity_scope-token_verify",
    "method": "POST",
    "path": "/activity/scope-token/verify",
    "public_path": "/api/activity/scope-token/verify",
    "auth": "session_csrf",
    "path_template": "/activity/scope-token/verify",
    "domain": "activity"
  },
  "get__activity_signals": {
    "operation_id": "get__activity_signals",
    "method": "GET",
    "path": "/activity/signals",
    "public_path": "/api/activity/signals",
    "auth": "session_csrf",
    "path_template": "/activity/signals",
    "domain": "activity"
  },
  "get__actuators_resources": {
    "operation_id": "get__actuators_resources",
    "method": "GET",
    "path": "/actuators/resources",
    "public_path": "/api/actuators/resources",
    "auth": "session_csrf",
    "path_template": "/actuators/resources",
    "domain": "actuators"
  },
  "post__actuators_resources_select": {
    "operation_id": "post__actuators_resources_select",
    "method": "POST",
    "path": "/actuators/resources/select",
    "public_path": "/api/actuators/resources/select",
    "auth": "session_csrf",
    "path_template": "/actuators/resources/select",
    "domain": "actuators"
  },
  "get__actuators_resources_p": {
    "operation_id": "get__actuators_resources_p",
    "method": "GET",
    "path": "/actuators/resources/{kind}",
    "public_path": "/api/actuators/resources/{kind}",
    "auth": "session_csrf",
    "path_template": "/actuators/resources/{param}",
    "domain": "actuators"
  },
  "patch__actuators_resources_p_catalog": {
    "operation_id": "patch__actuators_resources_p_catalog",
    "method": "PATCH",
    "path": "/actuators/resources/{kind}/catalog",
    "public_path": "/api/actuators/resources/{kind}/catalog",
    "auth": "session_csrf",
    "path_template": "/actuators/resources/{param}/catalog",
    "domain": "actuators"
  },
  "get__admin_alert-recipients": {
    "operation_id": "get__admin_alert-recipients",
    "method": "GET",
    "path": "/admin/alert-recipients",
    "public_path": "/api/admin/alert-recipients",
    "auth": "session_csrf",
    "path_template": "/admin/alert-recipients",
    "domain": "admin"
  },
  "post__admin_alert-recipients": {
    "operation_id": "post__admin_alert-recipients",
    "method": "POST",
    "path": "/admin/alert-recipients",
    "public_path": "/api/admin/alert-recipients",
    "auth": "session_csrf",
    "path_template": "/admin/alert-recipients",
    "domain": "admin"
  },
  "post__admin_alert-recipients_request-verify": {
    "operation_id": "post__admin_alert-recipients_request-verify",
    "method": "POST",
    "path": "/admin/alert-recipients/request-verify",
    "public_path": "/api/admin/alert-recipients/request-verify",
    "auth": "session_csrf",
    "path_template": "/admin/alert-recipients/request-verify",
    "domain": "admin"
  },
  "delete__admin_alert-recipients_p": {
    "operation_id": "delete__admin_alert-recipients_p",
    "method": "DELETE",
    "path": "/admin/alert-recipients/{rid}",
    "public_path": "/api/admin/alert-recipients/{rid}",
    "auth": "session_csrf",
    "path_template": "/admin/alert-recipients/{param}",
    "domain": "admin"
  },
  "patch__admin_alert-recipients_p": {
    "operation_id": "patch__admin_alert-recipients_p",
    "method": "PATCH",
    "path": "/admin/alert-recipients/{rid}",
    "public_path": "/api/admin/alert-recipients/{rid}",
    "auth": "session_csrf",
    "path_template": "/admin/alert-recipients/{param}",
    "domain": "admin"
  },
  "get__admin_backup_export": {
    "operation_id": "get__admin_backup_export",
    "method": "GET",
    "path": "/admin/backup/export",
    "public_path": "/api/admin/backup/export",
    "auth": "session_csrf",
    "path_template": "/admin/backup/export",
    "domain": "admin"
  },
  "post__admin_backup_import": {
    "operation_id": "post__admin_backup_import",
    "method": "POST",
    "path": "/admin/backup/import",
    "public_path": "/api/admin/backup/import",
    "auth": "session_csrf",
    "path_template": "/admin/backup/import",
    "domain": "admin"
  },
  "post__admin_backup_restore-drill": {
    "operation_id": "post__admin_backup_restore-drill",
    "method": "POST",
    "path": "/admin/backup/restore-drill",
    "public_path": "/api/admin/backup/restore-drill",
    "auth": "session_csrf",
    "path_template": "/admin/backup/restore-drill",
    "domain": "admin"
  },
  "get__admin_backup_schedule": {
    "operation_id": "get__admin_backup_schedule",
    "method": "GET",
    "path": "/admin/backup/schedule",
    "public_path": "/api/admin/backup/schedule",
    "auth": "session_csrf",
    "path_template": "/admin/backup/schedule",
    "domain": "admin"
  },
  "get__admin_backup_status": {
    "operation_id": "get__admin_backup_status",
    "method": "GET",
    "path": "/admin/backup/status",
    "public_path": "/api/admin/backup/status",
    "auth": "session_csrf",
    "path_template": "/admin/backup/status",
    "domain": "admin"
  },
  "get__admin_camera-snapshots": {
    "operation_id": "get__admin_camera-snapshots",
    "method": "GET",
    "path": "/admin/camera-snapshots",
    "public_path": "/api/admin/camera-snapshots",
    "auth": "session_csrf",
    "path_template": "/admin/camera-snapshots",
    "domain": "admin"
  },
  "post__admin_camera-snapshots_live-capture": {
    "operation_id": "post__admin_camera-snapshots_live-capture",
    "method": "POST",
    "path": "/admin/camera-snapshots/live-capture",
    "public_path": "/api/admin/camera-snapshots/live-capture",
    "auth": "session_csrf",
    "path_template": "/admin/camera-snapshots/live-capture",
    "domain": "admin"
  },
  "post__admin_camera-snapshots_live-frame": {
    "operation_id": "post__admin_camera-snapshots_live-frame",
    "method": "POST",
    "path": "/admin/camera-snapshots/live-frame",
    "public_path": "/api/admin/camera-snapshots/live-frame",
    "auth": "session_csrf",
    "path_template": "/admin/camera-snapshots/live-frame",
    "domain": "admin"
  },
  "get__admin_camera-snapshots_p_image": {
    "operation_id": "get__admin_camera-snapshots_p_image",
    "method": "GET",
    "path": "/admin/camera-snapshots/{snapshot_id}/image",
    "public_path": "/api/admin/camera-snapshots/{snapshot_id}/image",
    "auth": "session_csrf",
    "path_template": "/admin/camera-snapshots/{param}/image",
    "domain": "admin"
  },
  "post__admin_camera-snapshots_p_send-email": {
    "operation_id": "post__admin_camera-snapshots_p_send-email",
    "method": "POST",
    "path": "/admin/camera-snapshots/{snapshot_id}/send-email",
    "public_path": "/api/admin/camera-snapshots/{snapshot_id}/send-email",
    "auth": "session_csrf",
    "path_template": "/admin/camera-snapshots/{param}/send-email",
    "domain": "admin"
  },
  "get__admin_cameras": {
    "operation_id": "get__admin_cameras",
    "method": "GET",
    "path": "/admin/cameras",
    "public_path": "/api/admin/cameras",
    "auth": "session_csrf",
    "path_template": "/admin/cameras",
    "domain": "admin"
  },
  "post__admin_cameras": {
    "operation_id": "post__admin_cameras",
    "method": "POST",
    "path": "/admin/cameras",
    "public_path": "/api/admin/cameras",
    "auth": "session_csrf",
    "path_template": "/admin/cameras",
    "domain": "admin"
  },
  "post__admin_cameras_lan-scan": {
    "operation_id": "post__admin_cameras_lan-scan",
    "method": "POST",
    "path": "/admin/cameras/lan-scan",
    "public_path": "/api/admin/cameras/lan-scan",
    "auth": "session_csrf",
    "path_template": "/admin/cameras/lan-scan",
    "domain": "admin"
  },
  "post__admin_cameras_probe-test": {
    "operation_id": "post__admin_cameras_probe-test",
    "method": "POST",
    "path": "/admin/cameras/probe-test",
    "public_path": "/api/admin/cameras/probe-test",
    "auth": "session_csrf",
    "path_template": "/admin/cameras/probe-test",
    "domain": "admin"
  },
  "post__admin_cameras_test-capture": {
    "operation_id": "post__admin_cameras_test-capture",
    "method": "POST",
    "path": "/admin/cameras/test-capture",
    "public_path": "/api/admin/cameras/test-capture",
    "auth": "session_csrf",
    "path_template": "/admin/cameras/test-capture",
    "domain": "admin"
  },
  "delete__admin_cameras_p": {
    "operation_id": "delete__admin_cameras_p",
    "method": "DELETE",
    "path": "/admin/cameras/{camera_id}",
    "public_path": "/api/admin/cameras/{camera_id}",
    "auth": "session_csrf",
    "path_template": "/admin/cameras/{param}",
    "domain": "admin"
  },
  "post__admin_cameras_p_health-probe": {
    "operation_id": "post__admin_cameras_p_health-probe",
    "method": "POST",
    "path": "/admin/cameras/{camera_id}/health-probe",
    "public_path": "/api/admin/cameras/{camera_id}/health-probe",
    "auth": "session_csrf",
    "path_template": "/admin/cameras/{param}/health-probe",
    "domain": "admin"
  },
  "get__admin_devices_p_camera-bindings": {
    "operation_id": "get__admin_devices_p_camera-bindings",
    "method": "GET",
    "path": "/admin/devices/{device_id}/camera-bindings",
    "public_path": "/api/admin/devices/{device_id}/camera-bindings",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-bindings",
    "domain": "admin"
  },
  "post__admin_devices_p_camera-bindings": {
    "operation_id": "post__admin_devices_p_camera-bindings",
    "method": "POST",
    "path": "/admin/devices/{device_id}/camera-bindings",
    "public_path": "/api/admin/devices/{device_id}/camera-bindings",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-bindings",
    "domain": "admin"
  },
  "delete__admin_devices_p_camera-bindings_p": {
    "operation_id": "delete__admin_devices_p_camera-bindings_p",
    "method": "DELETE",
    "path": "/admin/devices/{device_id}/camera-bindings/{binding_id}",
    "public_path": "/api/admin/devices/{device_id}/camera-bindings/{binding_id}",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-bindings/{param}",
    "domain": "admin"
  },
  "get__admin_devices_p_camera-discovery": {
    "operation_id": "get__admin_devices_p_camera-discovery",
    "method": "GET",
    "path": "/admin/devices/{device_id}/camera-discovery",
    "public_path": "/api/admin/devices/{device_id}/camera-discovery",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-discovery",
    "domain": "admin"
  },
  "post__admin_devices_p_camera-discovery": {
    "operation_id": "post__admin_devices_p_camera-discovery",
    "method": "POST",
    "path": "/admin/devices/{device_id}/camera-discovery",
    "public_path": "/api/admin/devices/{device_id}/camera-discovery",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-discovery",
    "domain": "admin"
  },
  "post__admin_devices_p_camera-snapshots_enqueue": {
    "operation_id": "post__admin_devices_p_camera-snapshots_enqueue",
    "method": "POST",
    "path": "/admin/devices/{device_id}/camera-snapshots/enqueue",
    "public_path": "/api/admin/devices/{device_id}/camera-snapshots/enqueue",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/camera-snapshots/enqueue",
    "domain": "admin"
  },
  "post__admin_devices_p_share": {
    "operation_id": "post__admin_devices_p_share",
    "method": "POST",
    "path": "/admin/devices/{device_id}/share",
    "public_path": "/api/admin/devices/{device_id}/share",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/share",
    "domain": "admin"
  },
  "delete__admin_devices_p_share_p": {
    "operation_id": "delete__admin_devices_p_share_p",
    "method": "DELETE",
    "path": "/admin/devices/{device_id}/share/{grantee_username}",
    "public_path": "/api/admin/devices/{device_id}/share/{grantee_username}",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/share/{param}",
    "domain": "admin"
  },
  "get__admin_devices_p_shares": {
    "operation_id": "get__admin_devices_p_shares",
    "method": "GET",
    "path": "/admin/devices/{device_id}/shares",
    "public_path": "/api/admin/devices/{device_id}/shares",
    "auth": "session_csrf",
    "path_template": "/admin/devices/{param}/shares",
    "domain": "admin"
  },
  "get__admin_fcm_status": {
    "operation_id": "get__admin_fcm_status",
    "method": "GET",
    "path": "/admin/fcm/status",
    "public_path": "/api/admin/fcm/status",
    "auth": "session_csrf",
    "path_template": "/admin/fcm/status",
    "domain": "admin"
  },
  "post__admin_fcm_test": {
    "operation_id": "post__admin_fcm_test",
    "method": "POST",
    "path": "/admin/fcm/test",
    "public_path": "/api/admin/fcm/test",
    "auth": "session_csrf",
    "path_template": "/admin/fcm/test",
    "domain": "admin"
  },
  "get__admin_fcm_topic-migration-health": {
    "operation_id": "get__admin_fcm_topic-migration-health",
    "method": "GET",
    "path": "/admin/fcm/topic-migration-health",
    "public_path": "/api/admin/fcm/topic-migration-health",
    "auth": "session_csrf",
    "path_template": "/admin/fcm/topic-migration-health",
    "domain": "admin"
  },
  "get__admin_grantee-alert-recipients": {
    "operation_id": "get__admin_grantee-alert-recipients",
    "method": "GET",
    "path": "/admin/grantee-alert-recipients",
    "public_path": "/api/admin/grantee-alert-recipients",
    "auth": "session_csrf",
    "path_template": "/admin/grantee-alert-recipients",
    "domain": "admin"
  },
  "post__admin_grantee-alert-recipients": {
    "operation_id": "post__admin_grantee-alert-recipients",
    "method": "POST",
    "path": "/admin/grantee-alert-recipients",
    "public_path": "/api/admin/grantee-alert-recipients",
    "auth": "session_csrf",
    "path_template": "/admin/grantee-alert-recipients",
    "domain": "admin"
  },
  "post__admin_grantee-alert-recipients_request-verify": {
    "operation_id": "post__admin_grantee-alert-recipients_request-verify",
    "method": "POST",
    "path": "/admin/grantee-alert-recipients/request-verify",
    "public_path": "/api/admin/grantee-alert-recipients/request-verify",
    "auth": "session_csrf",
    "path_template": "/admin/grantee-alert-recipients/request-verify",
    "domain": "admin"
  },
  "delete__admin_grantee_p_alert-recipients_p": {
    "operation_id": "delete__admin_grantee_p_alert-recipients_p",
    "method": "DELETE",
    "path": "/admin/grantee/{grantee_username}/alert-recipients/{rid}",
    "public_path": "/api/admin/grantee/{grantee_username}/alert-recipients/{rid}",
    "auth": "session_csrf",
    "path_template": "/admin/grantee/{param}/alert-recipients/{param}",
    "domain": "admin"
  },
  "get__admin_groups-hub_summary": {
    "operation_id": "get__admin_groups-hub_summary",
    "method": "GET",
    "path": "/admin/groups-hub/summary",
    "public_path": "/api/admin/groups-hub/summary",
    "auth": "session_csrf",
    "path_template": "/admin/groups-hub/summary",
    "domain": "admin"
  },
  "delete__admin_notification-groups_share": {
    "operation_id": "delete__admin_notification-groups_share",
    "method": "DELETE",
    "path": "/admin/notification-groups/share",
    "public_path": "/api/admin/notification-groups/share",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/share",
    "domain": "admin"
  },
  "post__admin_notification-groups_share": {
    "operation_id": "post__admin_notification-groups_share",
    "method": "POST",
    "path": "/admin/notification-groups/share",
    "public_path": "/api/admin/notification-groups/share",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/share",
    "domain": "admin"
  },
  "post__admin_notification-groups_share-label": {
    "operation_id": "post__admin_notification-groups_share-label",
    "method": "POST",
    "path": "/admin/notification-groups/share-label",
    "public_path": "/api/admin/notification-groups/share-label",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/share-label",
    "domain": "admin"
  },
  "get__admin_notification-groups_share-preview": {
    "operation_id": "get__admin_notification-groups_share-preview",
    "method": "GET",
    "path": "/admin/notification-groups/share-preview",
    "public_path": "/api/admin/notification-groups/share-preview",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/share-preview",
    "domain": "admin"
  },
  "post__admin_notification-groups_share-reconcile": {
    "operation_id": "post__admin_notification-groups_share-reconcile",
    "method": "POST",
    "path": "/admin/notification-groups/share-reconcile",
    "public_path": "/api/admin/notification-groups/share-reconcile",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/share-reconcile",
    "domain": "admin"
  },
  "get__admin_notification-groups_shares": {
    "operation_id": "get__admin_notification-groups_shares",
    "method": "GET",
    "path": "/admin/notification-groups/shares",
    "public_path": "/api/admin/notification-groups/shares",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/shares",
    "domain": "admin"
  },
  "post__admin_notification-groups_shares_cleanup-orphans": {
    "operation_id": "post__admin_notification-groups_shares_cleanup-orphans",
    "method": "POST",
    "path": "/admin/notification-groups/shares/cleanup-orphans",
    "public_path": "/api/admin/notification-groups/shares/cleanup-orphans",
    "auth": "session_csrf",
    "path_template": "/admin/notification-groups/shares/cleanup-orphans",
    "domain": "admin"
  },
  "get__admin_ops_global-metrics": {
    "operation_id": "get__admin_ops_global-metrics",
    "method": "GET",
    "path": "/admin/ops/global-metrics",
    "public_path": "/api/admin/ops/global-metrics",
    "auth": "session_csrf",
    "path_template": "/admin/ops/global-metrics",
    "domain": "admin"
  },
  "get__admin_ops_global-metrics_stream": {
    "operation_id": "get__admin_ops_global-metrics_stream",
    "method": "GET",
    "path": "/admin/ops/global-metrics/stream",
    "public_path": "/api/admin/ops/global-metrics/stream",
    "auth": "session_csrf",
    "path_template": "/admin/ops/global-metrics/stream",
    "domain": "admin"
  },
  "get__admin_pg-backup_status": {
    "operation_id": "get__admin_pg-backup_status",
    "method": "GET",
    "path": "/admin/pg-backup/status",
    "public_path": "/api/admin/pg-backup/status",
    "auth": "session_csrf",
    "path_template": "/admin/pg-backup/status",
    "domain": "admin"
  },
  "get__admin_presence-probes": {
    "operation_id": "get__admin_presence-probes",
    "method": "GET",
    "path": "/admin/presence-probes",
    "public_path": "/api/admin/presence-probes",
    "auth": "session_csrf",
    "path_template": "/admin/presence-probes",
    "domain": "admin"
  },
  "get__admin_roles": {
    "operation_id": "get__admin_roles",
    "method": "GET",
    "path": "/admin/roles",
    "public_path": "/api/admin/roles",
    "auth": "session_csrf",
    "path_template": "/admin/roles",
    "domain": "admin"
  },
  "get__admin_security_audit": {
    "operation_id": "get__admin_security_audit",
    "method": "GET",
    "path": "/admin/security/audit",
    "public_path": "/api/admin/security/audit",
    "auth": "session_csrf",
    "path_template": "/admin/security/audit",
    "domain": "admin"
  },
  "get__admin_security_csrf-token": {
    "operation_id": "get__admin_security_csrf-token",
    "method": "GET",
    "path": "/admin/security/csrf-token",
    "public_path": "/api/admin/security/csrf-token",
    "auth": "session_csrf",
    "path_template": "/admin/security/csrf-token",
    "domain": "admin"
  },
  "post__admin_security_rotate-cmd-key": {
    "operation_id": "post__admin_security_rotate-cmd-key",
    "method": "POST",
    "path": "/admin/security/rotate-cmd-key",
    "public_path": "/api/admin/security/rotate-cmd-key",
    "auth": "session_csrf",
    "path_template": "/admin/security/rotate-cmd-key",
    "domain": "admin"
  },
  "get__admin_shares": {
    "operation_id": "get__admin_shares",
    "method": "GET",
    "path": "/admin/shares",
    "public_path": "/api/admin/shares",
    "auth": "session_csrf",
    "path_template": "/admin/shares",
    "domain": "admin"
  },
  "get__admin_smtp_status": {
    "operation_id": "get__admin_smtp_status",
    "method": "GET",
    "path": "/admin/smtp/status",
    "public_path": "/api/admin/smtp/status",
    "auth": "session_csrf",
    "path_template": "/admin/smtp/status",
    "domain": "admin"
  },
  "post__admin_smtp_test": {
    "operation_id": "post__admin_smtp_test",
    "method": "POST",
    "path": "/admin/smtp/test",
    "public_path": "/api/admin/smtp/test",
    "auth": "session_csrf",
    "path_template": "/admin/smtp/test",
    "domain": "admin"
  },
  "post__admin_sub-admins": {
    "operation_id": "post__admin_sub-admins",
    "method": "POST",
    "path": "/admin/sub-admins",
    "public_path": "/api/admin/sub-admins",
    "auth": "session_csrf",
    "path_template": "/admin/sub-admins",
    "domain": "admin"
  },
  "post__admin_telegram_bind-self": {
    "operation_id": "post__admin_telegram_bind-self",
    "method": "POST",
    "path": "/admin/telegram/bind-self",
    "public_path": "/api/admin/telegram/bind-self",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/bind-self",
    "domain": "admin"
  },
  "get__admin_telegram_bindings": {
    "operation_id": "get__admin_telegram_bindings",
    "method": "GET",
    "path": "/admin/telegram/bindings",
    "public_path": "/api/admin/telegram/bindings",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/bindings",
    "domain": "admin"
  },
  "delete__admin_telegram_bindings_p": {
    "operation_id": "delete__admin_telegram_bindings_p",
    "method": "DELETE",
    "path": "/admin/telegram/bindings/{chat_id}",
    "public_path": "/api/admin/telegram/bindings/{chat_id}",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/bindings/{param}",
    "domain": "admin"
  },
  "patch__admin_telegram_bindings_p_enabled": {
    "operation_id": "patch__admin_telegram_bindings_p_enabled",
    "method": "PATCH",
    "path": "/admin/telegram/bindings/{chat_id}/enabled",
    "public_path": "/api/admin/telegram/bindings/{chat_id}/enabled",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/bindings/{param}/enabled",
    "domain": "admin"
  },
  "get__admin_telegram_status": {
    "operation_id": "get__admin_telegram_status",
    "method": "GET",
    "path": "/admin/telegram/status",
    "public_path": "/api/admin/telegram/status",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/status",
    "domain": "admin"
  },
  "post__admin_telegram_test": {
    "operation_id": "post__admin_telegram_test",
    "method": "POST",
    "path": "/admin/telegram/test",
    "public_path": "/api/admin/telegram/test",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/test",
    "domain": "admin"
  },
  "get__admin_telegram_webhook-info": {
    "operation_id": "get__admin_telegram_webhook-info",
    "method": "GET",
    "path": "/admin/telegram/webhook-info",
    "public_path": "/api/admin/telegram/webhook-info",
    "auth": "session_csrf",
    "path_template": "/admin/telegram/webhook-info",
    "domain": "admin"
  },
  "get__admin_tenant-delegations": {
    "operation_id": "get__admin_tenant-delegations",
    "method": "GET",
    "path": "/admin/tenant-delegations",
    "public_path": "/api/admin/tenant-delegations",
    "auth": "session_csrf",
    "path_template": "/admin/tenant-delegations",
    "domain": "admin"
  },
  "post__admin_tenant-delegations": {
    "operation_id": "post__admin_tenant-delegations",
    "method": "POST",
    "path": "/admin/tenant-delegations",
    "public_path": "/api/admin/tenant-delegations",
    "auth": "session_csrf",
    "path_template": "/admin/tenant-delegations",
    "domain": "admin"
  },
  "delete__admin_tenant-delegations_p": {
    "operation_id": "delete__admin_tenant-delegations_p",
    "method": "DELETE",
    "path": "/admin/tenant-delegations/{grantee_username}",
    "public_path": "/api/admin/tenant-delegations/{grantee_username}",
    "auth": "session_csrf",
    "path_template": "/admin/tenant-delegations/{param}",
    "domain": "admin"
  },
  "get__admin_user-scopes-children": {
    "operation_id": "get__admin_user-scopes-children",
    "method": "GET",
    "path": "/admin/user-scopes-children",
    "public_path": "/api/admin/user-scopes-children",
    "auth": "session_csrf",
    "path_template": "/admin/user-scopes-children",
    "domain": "admin"
  },
  "get__admin_user-scopes_me": {
    "operation_id": "get__admin_user-scopes_me",
    "method": "GET",
    "path": "/admin/user-scopes/me",
    "public_path": "/api/admin/user-scopes/me",
    "auth": "session_csrf",
    "path_template": "/admin/user-scopes/me",
    "domain": "admin"
  },
  "get__admin_user-scopes_p": {
    "operation_id": "get__admin_user-scopes_p",
    "method": "GET",
    "path": "/admin/user-scopes/{sub_admin_username}",
    "public_path": "/api/admin/user-scopes/{sub_admin_username}",
    "auth": "session_csrf",
    "path_template": "/admin/user-scopes/{param}",
    "domain": "admin"
  },
  "delete__admin_user-scopes_p_p": {
    "operation_id": "delete__admin_user-scopes_p_p",
    "method": "DELETE",
    "path": "/admin/user-scopes/{sub_admin_username}/{user_username}",
    "public_path": "/api/admin/user-scopes/{sub_admin_username}/{user_username}",
    "auth": "session_csrf",
    "path_template": "/admin/user-scopes/{param}/{param}",
    "domain": "admin"
  },
  "post__admin_user-scopes_p_p": {
    "operation_id": "post__admin_user-scopes_p_p",
    "method": "POST",
    "path": "/admin/user-scopes/{sub_admin_username}/{user_username}",
    "public_path": "/api/admin/user-scopes/{sub_admin_username}/{user_username}",
    "auth": "session_csrf",
    "path_template": "/admin/user-scopes/{param}/{param}",
    "domain": "admin"
  },
  "get__admin_users": {
    "operation_id": "get__admin_users",
    "method": "GET",
    "path": "/admin/users",
    "public_path": "/api/admin/users",
    "auth": "session_csrf",
    "path_template": "/admin/users",
    "domain": "admin"
  },
  "get__admin_voice_templates": {
    "operation_id": "get__admin_voice_templates",
    "method": "GET",
    "path": "/admin/voice/templates",
    "public_path": "/api/admin/voice/templates",
    "auth": "session_csrf",
    "path_template": "/admin/voice/templates",
    "domain": "admin"
  },
  "put__admin_voice_templates_p": {
    "operation_id": "put__admin_voice_templates_p",
    "method": "PUT",
    "path": "/admin/voice/templates/{name}",
    "public_path": "/api/admin/voice/templates/{name}",
    "auth": "session_csrf",
    "path_template": "/admin/voice/templates/{param}",
    "domain": "admin"
  },
  "post__admin_voice_test-call": {
    "operation_id": "post__admin_voice_test-call",
    "method": "POST",
    "path": "/admin/voice/test-call",
    "public_path": "/api/admin/voice/test-call",
    "auth": "session_csrf",
    "path_template": "/admin/voice/test-call",
    "domain": "admin"
  },
  "post__ai_analyze": {
    "operation_id": "post__ai_analyze",
    "method": "POST",
    "path": "/ai/analyze",
    "public_path": "/api/ai/analyze",
    "auth": "session_csrf",
    "path_template": "/ai/analyze",
    "domain": "ai"
  },
  "get__ai_autonomy_control-grants": {
    "operation_id": "get__ai_autonomy_control-grants",
    "method": "GET",
    "path": "/ai/autonomy/control-grants",
    "public_path": "/api/ai/autonomy/control-grants",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/control-grants",
    "domain": "ai"
  },
  "put__ai_autonomy_control-grants": {
    "operation_id": "put__ai_autonomy_control-grants",
    "method": "PUT",
    "path": "/ai/autonomy/control-grants",
    "public_path": "/api/ai/autonomy/control-grants",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/control-grants",
    "domain": "ai"
  },
  "get__ai_autonomy_egress-status": {
    "operation_id": "get__ai_autonomy_egress-status",
    "method": "GET",
    "path": "/ai/autonomy/egress-status",
    "public_path": "/api/ai/autonomy/egress-status",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/egress-status",
    "domain": "ai"
  },
  "get__ai_autonomy_policy": {
    "operation_id": "get__ai_autonomy_policy",
    "method": "GET",
    "path": "/ai/autonomy/policy",
    "public_path": "/api/ai/autonomy/policy",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/policy",
    "domain": "ai"
  },
  "patch__ai_autonomy_policy": {
    "operation_id": "patch__ai_autonomy_policy",
    "method": "PATCH",
    "path": "/ai/autonomy/policy",
    "public_path": "/api/ai/autonomy/policy",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/policy",
    "domain": "ai"
  },
  "get__ai_autonomy_policy_effective": {
    "operation_id": "get__ai_autonomy_policy_effective",
    "method": "GET",
    "path": "/ai/autonomy/policy/effective",
    "public_path": "/api/ai/autonomy/policy/effective",
    "auth": "session_csrf",
    "path_template": "/ai/autonomy/policy/effective",
    "domain": "ai"
  },
  "get__ai_decision-evals_status": {
    "operation_id": "get__ai_decision-evals_status",
    "method": "GET",
    "path": "/ai/decision-evals/status",
    "public_path": "/api/ai/decision-evals/status",
    "auth": "session_csrf",
    "path_template": "/ai/decision-evals/status",
    "domain": "ai"
  },
  "get__ai_edge_leases": {
    "operation_id": "get__ai_edge_leases",
    "method": "GET",
    "path": "/ai/edge/leases",
    "public_path": "/api/ai/edge/leases",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases",
    "domain": "ai"
  },
  "post__ai_edge_leases": {
    "operation_id": "post__ai_edge_leases",
    "method": "POST",
    "path": "/ai/edge/leases",
    "public_path": "/api/ai/edge/leases",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases",
    "domain": "ai"
  },
  "get__ai_edge_leases_p": {
    "operation_id": "get__ai_edge_leases_p",
    "method": "GET",
    "path": "/ai/edge/leases/{lease_id}",
    "public_path": "/api/ai/edge/leases/{lease_id}",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases/{param}",
    "domain": "ai"
  },
  "post__ai_edge_leases_p_consume": {
    "operation_id": "post__ai_edge_leases_p_consume",
    "method": "POST",
    "path": "/ai/edge/leases/{lease_id}/consume",
    "public_path": "/api/ai/edge/leases/{lease_id}/consume",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases/{param}/consume",
    "domain": "ai"
  },
  "post__ai_edge_leases_p_proof": {
    "operation_id": "post__ai_edge_leases_p_proof",
    "method": "POST",
    "path": "/ai/edge/leases/{lease_id}/proof",
    "public_path": "/api/ai/edge/leases/{lease_id}/proof",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases/{param}/proof",
    "domain": "ai"
  },
  "post__ai_edge_leases_p_reconcile": {
    "operation_id": "post__ai_edge_leases_p_reconcile",
    "method": "POST",
    "path": "/ai/edge/leases/{lease_id}/reconcile",
    "public_path": "/api/ai/edge/leases/{lease_id}/reconcile",
    "auth": "session_csrf",
    "path_template": "/ai/edge/leases/{param}/reconcile",
    "domain": "ai"
  },
  "get__ai_fabric_acceptance": {
    "operation_id": "get__ai_fabric_acceptance",
    "method": "GET",
    "path": "/ai/fabric/acceptance",
    "public_path": "/api/ai/fabric/acceptance",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/acceptance",
    "domain": "ai"
  },
  "get__ai_fabric_activations_p": {
    "operation_id": "get__ai_fabric_activations_p",
    "method": "GET",
    "path": "/ai/fabric/activations/{pack_id}",
    "public_path": "/api/ai/fabric/activations/{pack_id}",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/activations/{param}",
    "domain": "ai"
  },
  "get__ai_fabric_artifacts_p": {
    "operation_id": "get__ai_fabric_artifacts_p",
    "method": "GET",
    "path": "/ai/fabric/artifacts/{artifact_id}",
    "public_path": "/api/ai/fabric/artifacts/{artifact_id}",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/artifacts/{param}",
    "domain": "ai"
  },
  "post__ai_fabric_gateway_bind": {
    "operation_id": "post__ai_fabric_gateway_bind",
    "method": "POST",
    "path": "/ai/fabric/gateway/bind",
    "public_path": "/api/ai/fabric/gateway/bind",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/gateway/bind",
    "domain": "ai"
  },
  "post__ai_fabric_intent_submit": {
    "operation_id": "post__ai_fabric_intent_submit",
    "method": "POST",
    "path": "/ai/fabric/intent/submit",
    "public_path": "/api/ai/fabric/intent/submit",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/intent/submit",
    "domain": "ai"
  },
  "get__ai_fabric_leases_p": {
    "operation_id": "get__ai_fabric_leases_p",
    "method": "GET",
    "path": "/ai/fabric/leases/{lease_id}",
    "public_path": "/api/ai/fabric/leases/{lease_id}",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/leases/{param}",
    "domain": "ai"
  },
  "get__ai_fabric_soft-canaries_p": {
    "operation_id": "get__ai_fabric_soft-canaries_p",
    "method": "GET",
    "path": "/ai/fabric/soft-canaries/{canary_id}",
    "public_path": "/api/ai/fabric/soft-canaries/{canary_id}",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/soft-canaries/{param}",
    "domain": "ai"
  },
  "post__ai_fabric_soft-canary": {
    "operation_id": "post__ai_fabric_soft-canary",
    "method": "POST",
    "path": "/ai/fabric/soft-canary",
    "public_path": "/api/ai/fabric/soft-canary",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/soft-canary",
    "domain": "ai"
  },
  "get__ai_fabric_status": {
    "operation_id": "get__ai_fabric_status",
    "method": "GET",
    "path": "/ai/fabric/status",
    "public_path": "/api/ai/fabric/status",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/status",
    "domain": "ai"
  },
  "post__ai_fabric_tool_observe": {
    "operation_id": "post__ai_fabric_tool_observe",
    "method": "POST",
    "path": "/ai/fabric/tool/observe",
    "public_path": "/api/ai/fabric/tool/observe",
    "auth": "session_csrf",
    "path_template": "/ai/fabric/tool/observe",
    "domain": "ai"
  },
  "get__ai_gateway_cutover-status": {
    "operation_id": "get__ai_gateway_cutover-status",
    "method": "GET",
    "path": "/ai/gateway/cutover-status",
    "public_path": "/api/ai/gateway/cutover-status",
    "auth": "session_csrf",
    "path_template": "/ai/gateway/cutover-status",
    "domain": "ai"
  },
  "get__ai_home-context": {
    "operation_id": "get__ai_home-context",
    "method": "GET",
    "path": "/ai/home-context",
    "public_path": "/api/ai/home-context",
    "auth": "session_csrf",
    "path_template": "/ai/home-context",
    "domain": "ai"
  },
  "get__ai_incidents": {
    "operation_id": "get__ai_incidents",
    "method": "GET",
    "path": "/ai/incidents",
    "public_path": "/api/ai/incidents",
    "auth": "session_csrf",
    "path_template": "/ai/incidents",
    "domain": "ai"
  },
  "post__ai_incidents_p_approve": {
    "operation_id": "post__ai_incidents_p_approve",
    "method": "POST",
    "path": "/ai/incidents/{incident_id}/approve",
    "public_path": "/api/ai/incidents/{incident_id}/approve",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}/approve",
    "domain": "ai"
  },
  "post__ai_incidents_p_escalate": {
    "operation_id": "post__ai_incidents_p_escalate",
    "method": "POST",
    "path": "/ai/incidents/{incident_id}/escalate",
    "public_path": "/api/ai/incidents/{incident_id}/escalate",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}/escalate",
    "domain": "ai"
  },
  "post__ai_incidents_p_request-evidence": {
    "operation_id": "post__ai_incidents_p_request-evidence",
    "method": "POST",
    "path": "/ai/incidents/{incident_id}/request-evidence",
    "public_path": "/api/ai/incidents/{incident_id}/request-evidence",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}/request-evidence",
    "domain": "ai"
  },
  "post__ai_incidents_p_vision_ask": {
    "operation_id": "post__ai_incidents_p_vision_ask",
    "method": "POST",
    "path": "/ai/incidents/{incident_id}/vision/ask",
    "public_path": "/api/ai/incidents/{incident_id}/vision/ask",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}/vision/ask",
    "domain": "ai"
  },
  "post__ai_incidents_p_vision_refresh": {
    "operation_id": "post__ai_incidents_p_vision_refresh",
    "method": "POST",
    "path": "/ai/incidents/{incident_id}/vision/refresh",
    "public_path": "/api/ai/incidents/{incident_id}/vision/refresh",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}/vision/refresh",
    "domain": "ai"
  },
  "get__ai_incidents_p": {
    "operation_id": "get__ai_incidents_p",
    "method": "GET",
    "path": "/ai/incidents/{item_id}",
    "public_path": "/api/ai/incidents/{item_id}",
    "auth": "session_csrf",
    "path_template": "/ai/incidents/{param}",
    "domain": "ai"
  },
  "get__ai_models_byok-policy_platform": {
    "operation_id": "get__ai_models_byok-policy_platform",
    "method": "GET",
    "path": "/ai/models/byok-policy/platform",
    "public_path": "/api/ai/models/byok-policy/platform",
    "auth": "session_csrf",
    "path_template": "/ai/models/byok-policy/platform",
    "domain": "ai"
  },
  "put__ai_models_byok-policy_platform": {
    "operation_id": "put__ai_models_byok-policy_platform",
    "method": "PUT",
    "path": "/ai/models/byok-policy/platform",
    "public_path": "/api/ai/models/byok-policy/platform",
    "auth": "session_csrf",
    "path_template": "/ai/models/byok-policy/platform",
    "domain": "ai"
  },
  "get__ai_models_byok-policy_tenant": {
    "operation_id": "get__ai_models_byok-policy_tenant",
    "method": "GET",
    "path": "/ai/models/byok-policy/tenant",
    "public_path": "/api/ai/models/byok-policy/tenant",
    "auth": "session_csrf",
    "path_template": "/ai/models/byok-policy/tenant",
    "domain": "ai"
  },
  "put__ai_models_byok-policy_tenant": {
    "operation_id": "put__ai_models_byok-policy_tenant",
    "method": "PUT",
    "path": "/ai/models/byok-policy/tenant",
    "public_path": "/api/ai/models/byok-policy/tenant",
    "auth": "session_csrf",
    "path_template": "/ai/models/byok-policy/tenant",
    "domain": "ai"
  },
  "get__ai_models_local-pull_jobs": {
    "operation_id": "get__ai_models_local-pull_jobs",
    "method": "GET",
    "path": "/ai/models/local-pull/jobs",
    "public_path": "/api/ai/models/local-pull/jobs",
    "auth": "session_csrf",
    "path_template": "/ai/models/local-pull/jobs",
    "domain": "ai"
  },
  "post__ai_models_local-pull_jobs": {
    "operation_id": "post__ai_models_local-pull_jobs",
    "method": "POST",
    "path": "/ai/models/local-pull/jobs",
    "public_path": "/api/ai/models/local-pull/jobs",
    "auth": "session_csrf",
    "path_template": "/ai/models/local-pull/jobs",
    "domain": "ai"
  },
  "get__ai_models_local-pull_jobs_p": {
    "operation_id": "get__ai_models_local-pull_jobs_p",
    "method": "GET",
    "path": "/ai/models/local-pull/jobs/{job_id}",
    "public_path": "/api/ai/models/local-pull/jobs/{job_id}",
    "auth": "session_csrf",
    "path_template": "/ai/models/local-pull/jobs/{param}",
    "domain": "ai"
  },
  "get__ai_models_local-pull_plan": {
    "operation_id": "get__ai_models_local-pull_plan",
    "method": "GET",
    "path": "/ai/models/local-pull/plan",
    "public_path": "/api/ai/models/local-pull/plan",
    "auth": "session_csrf",
    "path_template": "/ai/models/local-pull/plan",
    "domain": "ai"
  },
  "post__ai_models_local-runtime_tags": {
    "operation_id": "post__ai_models_local-runtime_tags",
    "method": "POST",
    "path": "/ai/models/local-runtime/tags",
    "public_path": "/api/ai/models/local-runtime/tags",
    "auth": "session_csrf",
    "path_template": "/ai/models/local-runtime/tags",
    "domain": "ai"
  },
  "get__ai_models_mine": {
    "operation_id": "get__ai_models_mine",
    "method": "GET",
    "path": "/ai/models/mine",
    "public_path": "/api/ai/models/mine",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine",
    "domain": "ai"
  },
  "get__ai_models_mine_effective": {
    "operation_id": "get__ai_models_mine_effective",
    "method": "GET",
    "path": "/ai/models/mine/effective",
    "public_path": "/api/ai/models/mine/effective",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine/effective",
    "domain": "ai"
  },
  "delete__ai_models_mine_key": {
    "operation_id": "delete__ai_models_mine_key",
    "method": "DELETE",
    "path": "/ai/models/mine/key",
    "public_path": "/api/ai/models/mine/key",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine/key",
    "domain": "ai"
  },
  "get__ai_models_mine_key": {
    "operation_id": "get__ai_models_mine_key",
    "method": "GET",
    "path": "/ai/models/mine/key",
    "public_path": "/api/ai/models/mine/key",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine/key",
    "domain": "ai"
  },
  "put__ai_models_mine_key": {
    "operation_id": "put__ai_models_mine_key",
    "method": "PUT",
    "path": "/ai/models/mine/key",
    "public_path": "/api/ai/models/mine/key",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine/key",
    "domain": "ai"
  },
  "put__ai_models_mine_preference": {
    "operation_id": "put__ai_models_mine_preference",
    "method": "PUT",
    "path": "/ai/models/mine/preference",
    "public_path": "/api/ai/models/mine/preference",
    "auth": "session_csrf",
    "path_template": "/ai/models/mine/preference",
    "domain": "ai"
  },
  "get__ai_models_platform": {
    "operation_id": "get__ai_models_platform",
    "method": "GET",
    "path": "/ai/models/platform",
    "public_path": "/api/ai/models/platform",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform",
    "domain": "ai"
  },
  "put__ai_models_platform": {
    "operation_id": "put__ai_models_platform",
    "method": "PUT",
    "path": "/ai/models/platform",
    "public_path": "/api/ai/models/platform",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform",
    "domain": "ai"
  },
  "delete__ai_models_platform_p": {
    "operation_id": "delete__ai_models_platform_p",
    "method": "DELETE",
    "path": "/ai/models/platform/{model_id}",
    "public_path": "/api/ai/models/platform/{model_id}",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform/{param}",
    "domain": "ai"
  },
  "get__ai_models_platform_p_grants": {
    "operation_id": "get__ai_models_platform_p_grants",
    "method": "GET",
    "path": "/ai/models/platform/{model_id}/grants",
    "public_path": "/api/ai/models/platform/{model_id}/grants",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform/{param}/grants",
    "domain": "ai"
  },
  "post__ai_models_platform_p_grants": {
    "operation_id": "post__ai_models_platform_p_grants",
    "method": "POST",
    "path": "/ai/models/platform/{model_id}/grants",
    "public_path": "/api/ai/models/platform/{model_id}/grants",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform/{param}/grants",
    "domain": "ai"
  },
  "delete__ai_models_platform_p_grants_p": {
    "operation_id": "delete__ai_models_platform_p_grants_p",
    "method": "DELETE",
    "path": "/ai/models/platform/{model_id}/grants/{grant_id}",
    "public_path": "/api/ai/models/platform/{model_id}/grants/{grant_id}",
    "auth": "session_csrf",
    "path_template": "/ai/models/platform/{param}/grants/{param}",
    "domain": "ai"
  },
  "get__ai_models_status": {
    "operation_id": "get__ai_models_status",
    "method": "GET",
    "path": "/ai/models/status",
    "public_path": "/api/ai/models/status",
    "auth": "session_csrf",
    "path_template": "/ai/models/status",
    "domain": "ai"
  },
  "get__ai_models_tenant": {
    "operation_id": "get__ai_models_tenant",
    "method": "GET",
    "path": "/ai/models/tenant",
    "public_path": "/api/ai/models/tenant",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant",
    "domain": "ai"
  },
  "put__ai_models_tenant": {
    "operation_id": "put__ai_models_tenant",
    "method": "PUT",
    "path": "/ai/models/tenant",
    "public_path": "/api/ai/models/tenant",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant",
    "domain": "ai"
  },
  "delete__ai_models_tenant_p": {
    "operation_id": "delete__ai_models_tenant_p",
    "method": "DELETE",
    "path": "/ai/models/tenant/{model_id}",
    "public_path": "/api/ai/models/tenant/{model_id}",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}",
    "domain": "ai"
  },
  "get__ai_models_tenant_p_grants": {
    "operation_id": "get__ai_models_tenant_p_grants",
    "method": "GET",
    "path": "/ai/models/tenant/{model_id}/grants",
    "public_path": "/api/ai/models/tenant/{model_id}/grants",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}/grants",
    "domain": "ai"
  },
  "post__ai_models_tenant_p_grants": {
    "operation_id": "post__ai_models_tenant_p_grants",
    "method": "POST",
    "path": "/ai/models/tenant/{model_id}/grants",
    "public_path": "/api/ai/models/tenant/{model_id}/grants",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}/grants",
    "domain": "ai"
  },
  "delete__ai_models_tenant_p_grants_p": {
    "operation_id": "delete__ai_models_tenant_p_grants_p",
    "method": "DELETE",
    "path": "/ai/models/tenant/{model_id}/grants/{grant_id}",
    "public_path": "/api/ai/models/tenant/{model_id}/grants/{grant_id}",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}/grants/{param}",
    "domain": "ai"
  },
  "post__ai_models_tenant_p_probe": {
    "operation_id": "post__ai_models_tenant_p_probe",
    "method": "POST",
    "path": "/ai/models/tenant/{model_id}/probe",
    "public_path": "/api/ai/models/tenant/{model_id}/probe",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}/probe",
    "domain": "ai"
  },
  "get__ai_models_tenant_p_tags": {
    "operation_id": "get__ai_models_tenant_p_tags",
    "method": "GET",
    "path": "/ai/models/tenant/{model_id}/tags",
    "public_path": "/api/ai/models/tenant/{model_id}/tags",
    "auth": "session_csrf",
    "path_template": "/ai/models/tenant/{param}/tags",
    "domain": "ai"
  },
  "get__ai_needs-you": {
    "operation_id": "get__ai_needs-you",
    "method": "GET",
    "path": "/ai/needs-you",
    "public_path": "/api/ai/needs-you",
    "auth": "session_csrf",
    "path_template": "/ai/needs-you",
    "domain": "ai"
  },
  "post__ai_needs-you_approval-token": {
    "operation_id": "post__ai_needs-you_approval-token",
    "method": "POST",
    "path": "/ai/needs-you/approval-token",
    "public_path": "/api/ai/needs-you/approval-token",
    "auth": "session_csrf",
    "path_template": "/ai/needs-you/approval-token",
    "domain": "ai"
  },
  "post__ai_needs-you_p_resolve": {
    "operation_id": "post__ai_needs-you_p_resolve",
    "method": "POST",
    "path": "/ai/needs-you/{needs_you_id}/resolve",
    "public_path": "/api/ai/needs-you/{needs_you_id}/resolve",
    "auth": "session_csrf",
    "path_template": "/ai/needs-you/{param}/resolve",
    "domain": "ai"
  },
  "get__ai_oncr_catalogue": {
    "operation_id": "get__ai_oncr_catalogue",
    "method": "GET",
    "path": "/ai/oncr/catalogue",
    "public_path": "/api/ai/oncr/catalogue",
    "auth": "session_csrf",
    "path_template": "/ai/oncr/catalogue",
    "domain": "ai"
  },
  "get__ai_oncr_incidents_p": {
    "operation_id": "get__ai_oncr_incidents_p",
    "method": "GET",
    "path": "/ai/oncr/incidents/{incident_id}",
    "public_path": "/api/ai/oncr/incidents/{incident_id}",
    "auth": "session_csrf",
    "path_template": "/ai/oncr/incidents/{param}",
    "domain": "ai"
  },
  "get__ai_platform_mcp-invokes_p": {
    "operation_id": "get__ai_platform_mcp-invokes_p",
    "method": "GET",
    "path": "/ai/platform/mcp-invokes/{invoke_id}",
    "public_path": "/api/ai/platform/mcp-invokes/{invoke_id}",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-invokes/{param}",
    "domain": "ai"
  },
  "get__ai_platform_mcp-servers": {
    "operation_id": "get__ai_platform_mcp-servers",
    "method": "GET",
    "path": "/ai/platform/mcp-servers",
    "public_path": "/api/ai/platform/mcp-servers",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers",
    "domain": "ai"
  },
  "put__ai_platform_mcp-servers": {
    "operation_id": "put__ai_platform_mcp-servers",
    "method": "PUT",
    "path": "/ai/platform/mcp-servers",
    "public_path": "/api/ai/platform/mcp-servers",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers",
    "domain": "ai"
  },
  "put__ai_platform_mcp-servers_p_allowed-tools": {
    "operation_id": "put__ai_platform_mcp-servers_p_allowed-tools",
    "method": "PUT",
    "path": "/ai/platform/mcp-servers/{mcp_id}/allowed-tools",
    "public_path": "/api/ai/platform/mcp-servers/{mcp_id}/allowed-tools",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers/{param}/allowed-tools",
    "domain": "ai"
  },
  "get__ai_platform_mcp-servers_p_invokes": {
    "operation_id": "get__ai_platform_mcp-servers_p_invokes",
    "method": "GET",
    "path": "/ai/platform/mcp-servers/{mcp_id}/invokes",
    "public_path": "/api/ai/platform/mcp-servers/{mcp_id}/invokes",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers/{param}/invokes",
    "domain": "ai"
  },
  "post__ai_platform_mcp-servers_p_tools_call": {
    "operation_id": "post__ai_platform_mcp-servers_p_tools_call",
    "method": "POST",
    "path": "/ai/platform/mcp-servers/{mcp_id}/tools/call",
    "public_path": "/api/ai/platform/mcp-servers/{mcp_id}/tools/call",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers/{param}/tools/call",
    "domain": "ai"
  },
  "post__ai_platform_mcp-servers_p_tools_list": {
    "operation_id": "post__ai_platform_mcp-servers_p_tools_list",
    "method": "POST",
    "path": "/ai/platform/mcp-servers/{mcp_id}/tools/list",
    "public_path": "/api/ai/platform/mcp-servers/{mcp_id}/tools/list",
    "auth": "session_csrf",
    "path_template": "/ai/platform/mcp-servers/{param}/tools/list",
    "domain": "ai"
  },
  "get__ai_platform_skills": {
    "operation_id": "get__ai_platform_skills",
    "method": "GET",
    "path": "/ai/platform/skills",
    "public_path": "/api/ai/platform/skills",
    "auth": "session_csrf",
    "path_template": "/ai/platform/skills",
    "domain": "ai"
  },
  "put__ai_platform_skills": {
    "operation_id": "put__ai_platform_skills",
    "method": "PUT",
    "path": "/ai/platform/skills",
    "public_path": "/api/ai/platform/skills",
    "auth": "session_csrf",
    "path_template": "/ai/platform/skills",
    "domain": "ai"
  },
  "post__ai_platform_skills_p_run": {
    "operation_id": "post__ai_platform_skills_p_run",
    "method": "POST",
    "path": "/ai/platform/skills/{skill_id}/run",
    "public_path": "/api/ai/platform/skills/{skill_id}/run",
    "auth": "session_csrf",
    "path_template": "/ai/platform/skills/{param}/run",
    "domain": "ai"
  },
  "get__ai_platform_tool-effect-audit": {
    "operation_id": "get__ai_platform_tool-effect-audit",
    "method": "GET",
    "path": "/ai/platform/tool-effect-audit",
    "public_path": "/api/ai/platform/tool-effect-audit",
    "auth": "session_csrf",
    "path_template": "/ai/platform/tool-effect-audit",
    "domain": "ai"
  },
  "get__ai_playbook": {
    "operation_id": "get__ai_playbook",
    "method": "GET",
    "path": "/ai/playbook",
    "public_path": "/api/ai/playbook",
    "auth": "session_csrf",
    "path_template": "/ai/playbook",
    "domain": "ai"
  },
  "post__ai_playbook_apply": {
    "operation_id": "post__ai_playbook_apply",
    "method": "POST",
    "path": "/ai/playbook/apply",
    "public_path": "/api/ai/playbook/apply",
    "auth": "session_csrf",
    "path_template": "/ai/playbook/apply",
    "domain": "ai"
  },
  "post__ai_playbook_revisions": {
    "operation_id": "post__ai_playbook_revisions",
    "method": "POST",
    "path": "/ai/playbook/revisions",
    "public_path": "/api/ai/playbook/revisions",
    "auth": "session_csrf",
    "path_template": "/ai/playbook/revisions",
    "domain": "ai"
  },
  "post__ai_playbook_simulate": {
    "operation_id": "post__ai_playbook_simulate",
    "method": "POST",
    "path": "/ai/playbook/simulate",
    "public_path": "/api/ai/playbook/simulate",
    "auth": "session_csrf",
    "path_template": "/ai/playbook/simulate",
    "domain": "ai"
  },
  "get__ai_playbook_status": {
    "operation_id": "get__ai_playbook_status",
    "method": "GET",
    "path": "/ai/playbook/status",
    "public_path": "/api/ai/playbook/status",
    "auth": "session_csrf",
    "path_template": "/ai/playbook/status",
    "domain": "ai"
  },
  "post__ai_qa-mcp_p": {
    "operation_id": "post__ai_qa-mcp_p",
    "method": "POST",
    "path": "/ai/qa-mcp/{token}",
    "public_path": "/api/ai/qa-mcp/{token}",
    "auth": "session_csrf",
    "path_template": "/ai/qa-mcp/{param}",
    "domain": "ai"
  },
  "post__ai_qa-sink_ingest_p": {
    "operation_id": "post__ai_qa-sink_ingest_p",
    "method": "POST",
    "path": "/ai/qa-sink/ingest/{token}",
    "public_path": "/api/ai/qa-sink/ingest/{token}",
    "auth": "session_csrf",
    "path_template": "/ai/qa-sink/ingest/{param}",
    "domain": "ai"
  },
  "get__ai_qa-sink_receipts_p": {
    "operation_id": "get__ai_qa-sink_receipts_p",
    "method": "GET",
    "path": "/ai/qa-sink/receipts/{idempotency_key}",
    "public_path": "/api/ai/qa-sink/receipts/{idempotency_key}",
    "auth": "session_csrf",
    "path_template": "/ai/qa-sink/receipts/{param}",
    "domain": "ai"
  },
  "get__ai_qa-sink_snapshot.jpg": {
    "operation_id": "get__ai_qa-sink_snapshot.jpg",
    "method": "GET",
    "path": "/ai/qa-sink/snapshot.jpg",
    "public_path": "/api/ai/qa-sink/snapshot.jpg",
    "auth": "session_csrf",
    "path_template": "/ai/qa-sink/snapshot.jpg",
    "domain": "ai"
  },
  "get__ai_qa-sink_status": {
    "operation_id": "get__ai_qa-sink_status",
    "method": "GET",
    "path": "/ai/qa-sink/status",
    "public_path": "/api/ai/qa-sink/status",
    "auth": "session_csrf",
    "path_template": "/ai/qa-sink/status",
    "domain": "ai"
  },
  "post__ai_safety_conditions": {
    "operation_id": "post__ai_safety_conditions",
    "method": "POST",
    "path": "/ai/safety/conditions",
    "public_path": "/api/ai/safety/conditions",
    "auth": "session_csrf",
    "path_template": "/ai/safety/conditions",
    "domain": "ai"
  },
  "get__ai_safety_reflex": {
    "operation_id": "get__ai_safety_reflex",
    "method": "GET",
    "path": "/ai/safety/reflex",
    "public_path": "/api/ai/safety/reflex",
    "auth": "session_csrf",
    "path_template": "/ai/safety/reflex",
    "domain": "ai"
  },
  "post__ai_safety_reflex": {
    "operation_id": "post__ai_safety_reflex",
    "method": "POST",
    "path": "/ai/safety/reflex",
    "public_path": "/api/ai/safety/reflex",
    "auth": "session_csrf",
    "path_template": "/ai/safety/reflex",
    "domain": "ai"
  },
  "get__ai_safety_reflex_p_effective": {
    "operation_id": "get__ai_safety_reflex_p_effective",
    "method": "GET",
    "path": "/ai/safety/reflex/{reflex_id}/effective",
    "public_path": "/api/ai/safety/reflex/{reflex_id}/effective",
    "auth": "session_csrf",
    "path_template": "/ai/safety/reflex/{param}/effective",
    "domain": "ai"
  },
  "get__ai_settings": {
    "operation_id": "get__ai_settings",
    "method": "GET",
    "path": "/ai/settings",
    "public_path": "/api/ai/settings",
    "auth": "session_csrf",
    "path_template": "/ai/settings",
    "domain": "ai"
  },
  "patch__ai_settings": {
    "operation_id": "patch__ai_settings",
    "method": "PATCH",
    "path": "/ai/settings",
    "public_path": "/api/ai/settings",
    "auth": "session_csrf",
    "path_template": "/ai/settings",
    "domain": "ai"
  },
  "get__ai_settings_status": {
    "operation_id": "get__ai_settings_status",
    "method": "GET",
    "path": "/ai/settings/status",
    "public_path": "/api/ai/settings/status",
    "auth": "session_csrf",
    "path_template": "/ai/settings/status",
    "domain": "ai"
  },
  "get__ai_soft-lanes": {
    "operation_id": "get__ai_soft-lanes",
    "method": "GET",
    "path": "/ai/soft-lanes",
    "public_path": "/api/ai/soft-lanes",
    "auth": "session_csrf",
    "path_template": "/ai/soft-lanes",
    "domain": "ai"
  },
  "get__ai_system-charter": {
    "operation_id": "get__ai_system-charter",
    "method": "GET",
    "path": "/ai/system-charter",
    "public_path": "/api/ai/system-charter",
    "auth": "session_csrf",
    "path_template": "/ai/system-charter",
    "domain": "ai"
  },
  "patch__ai_system-charter": {
    "operation_id": "patch__ai_system-charter",
    "method": "PATCH",
    "path": "/ai/system-charter",
    "public_path": "/api/ai/system-charter",
    "auth": "session_csrf",
    "path_template": "/ai/system-charter",
    "domain": "ai"
  },
  "get__ai_team_incidents_p_map-ops": {
    "operation_id": "get__ai_team_incidents_p_map-ops",
    "method": "GET",
    "path": "/ai/team/incidents/{incident_id}/map-ops",
    "public_path": "/api/ai/team/incidents/{incident_id}/map-ops",
    "auth": "session_csrf",
    "path_template": "/ai/team/incidents/{param}/map-ops",
    "domain": "ai"
  },
  "get__ai_team_incidents_p_run": {
    "operation_id": "get__ai_team_incidents_p_run",
    "method": "GET",
    "path": "/ai/team/incidents/{incident_id}/run",
    "public_path": "/api/ai/team/incidents/{incident_id}/run",
    "auth": "session_csrf",
    "path_template": "/ai/team/incidents/{param}/run",
    "domain": "ai"
  },
  "get__ai_team_prompt-roles": {
    "operation_id": "get__ai_team_prompt-roles",
    "method": "GET",
    "path": "/ai/team/prompt-roles",
    "public_path": "/api/ai/team/prompt-roles",
    "auth": "session_csrf",
    "path_template": "/ai/team/prompt-roles",
    "domain": "ai"
  },
  "put__ai_team_prompt-roles_p": {
    "operation_id": "put__ai_team_prompt-roles_p",
    "method": "PUT",
    "path": "/ai/team/prompt-roles/{role_id}",
    "public_path": "/api/ai/team/prompt-roles/{role_id}",
    "auth": "session_csrf",
    "path_template": "/ai/team/prompt-roles/{param}",
    "domain": "ai"
  },
  "post__ai_team_runs": {
    "operation_id": "post__ai_team_runs",
    "method": "POST",
    "path": "/ai/team/runs",
    "public_path": "/api/ai/team/runs",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs",
    "domain": "ai"
  },
  "get__ai_team_runs_p": {
    "operation_id": "get__ai_team_runs_p",
    "method": "GET",
    "path": "/ai/team/runs/{team_run_id}",
    "public_path": "/api/ai/team/runs/{team_run_id}",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}",
    "domain": "ai"
  },
  "post__ai_team_runs_p_continue": {
    "operation_id": "post__ai_team_runs_p_continue",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/continue",
    "public_path": "/api/ai/team/runs/{team_run_id}/continue",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/continue",
    "domain": "ai"
  },
  "post__ai_team_runs_p_estop": {
    "operation_id": "post__ai_team_runs_p_estop",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/estop",
    "public_path": "/api/ai/team/runs/{team_run_id}/estop",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/estop",
    "domain": "ai"
  },
  "post__ai_team_runs_p_estop_release": {
    "operation_id": "post__ai_team_runs_p_estop_release",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/estop/release",
    "public_path": "/api/ai/team/runs/{team_run_id}/estop/release",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/estop/release",
    "domain": "ai"
  },
  "post__ai_team_runs_p_hold": {
    "operation_id": "post__ai_team_runs_p_hold",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/hold",
    "public_path": "/api/ai/team/runs/{team_run_id}/hold",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/hold",
    "domain": "ai"
  },
  "post__ai_team_runs_p_intervene": {
    "operation_id": "post__ai_team_runs_p_intervene",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/intervene",
    "public_path": "/api/ai/team/runs/{team_run_id}/intervene",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/intervene",
    "domain": "ai"
  },
  "post__ai_team_runs_p_release": {
    "operation_id": "post__ai_team_runs_p_release",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/release",
    "public_path": "/api/ai/team/runs/{team_run_id}/release",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/release",
    "domain": "ai"
  },
  "post__ai_team_runs_p_takeover": {
    "operation_id": "post__ai_team_runs_p_takeover",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/takeover",
    "public_path": "/api/ai/team/runs/{team_run_id}/takeover",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/takeover",
    "domain": "ai"
  },
  "post__ai_team_runs_p_tick": {
    "operation_id": "post__ai_team_runs_p_tick",
    "method": "POST",
    "path": "/ai/team/runs/{team_run_id}/tick",
    "public_path": "/api/ai/team/runs/{team_run_id}/tick",
    "auth": "session_csrf",
    "path_template": "/ai/team/runs/{param}/tick",
    "domain": "ai"
  },
  "get__ai_team_status": {
    "operation_id": "get__ai_team_status",
    "method": "GET",
    "path": "/ai/team/status",
    "public_path": "/api/ai/team/status",
    "auth": "session_csrf",
    "path_template": "/ai/team/status",
    "domain": "ai"
  },
  "get__alarms": {
    "operation_id": "get__alarms",
    "method": "GET",
    "path": "/alarms",
    "public_path": "/api/alarms",
    "auth": "session_csrf",
    "path_template": "/alarms",
    "domain": "alarms"
  },
  "get__alarms_summary": {
    "operation_id": "get__alarms_summary",
    "method": "GET",
    "path": "/alarms/summary",
    "public_path": "/api/alarms/summary",
    "auth": "session_csrf",
    "path_template": "/alarms/summary",
    "domain": "alarms"
  },
  "post__alerts": {
    "operation_id": "post__alerts",
    "method": "POST",
    "path": "/alerts",
    "public_path": "/api/alerts",
    "auth": "session_csrf",
    "path_template": "/alerts",
    "domain": "alerts"
  },
  "get__api_admin_groups-hub_summary": {
    "operation_id": "get__api_admin_groups-hub_summary",
    "method": "GET",
    "path": "/api/admin/groups-hub/summary",
    "public_path": "/api/admin/groups-hub/summary",
    "auth": "session_csrf",
    "path_template": "/api/admin/groups-hub/summary",
    "domain": "api-alias (device back-compat)"
  },
  "get__api_avatars_p": {
    "operation_id": "get__api_avatars_p",
    "method": "GET",
    "path": "/api/avatars/{name}",
    "public_path": "/api/avatars/{name}",
    "auth": "session_csrf",
    "path_template": "/api/avatars/{param}",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_board_report": {
    "operation_id": "post__api_device_board_report",
    "method": "POST",
    "path": "/api/device/board/report",
    "public_path": "/api/device/board/report",
    "auth": "device",
    "path_template": "/api/device/board/report",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_boot-sync": {
    "operation_id": "post__api_device_boot-sync",
    "method": "POST",
    "path": "/api/device/boot-sync",
    "public_path": "/api/device/boot-sync",
    "auth": "device",
    "path_template": "/api/device/boot-sync",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_commands_ack": {
    "operation_id": "post__api_device_commands_ack",
    "method": "POST",
    "path": "/api/device/commands/ack",
    "public_path": "/api/device/commands/ack",
    "auth": "device",
    "path_template": "/api/device/commands/ack",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_commands_pending": {
    "operation_id": "post__api_device_commands_pending",
    "method": "POST",
    "path": "/api/device/commands/pending",
    "public_path": "/api/device/commands/pending",
    "auth": "device",
    "path_template": "/api/device/commands/pending",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_events": {
    "operation_id": "post__api_device_events",
    "method": "POST",
    "path": "/api/device/events",
    "public_path": "/api/device/events",
    "auth": "device",
    "path_template": "/api/device/events",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_live-sessions_bridge": {
    "operation_id": "post__api_device_live-sessions_bridge",
    "method": "POST",
    "path": "/api/device/live-sessions/bridge",
    "public_path": "/api/device/live-sessions/bridge",
    "auth": "device",
    "path_template": "/api/device/live-sessions/bridge",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_live-sessions_report": {
    "operation_id": "post__api_device_live-sessions_report",
    "method": "POST",
    "path": "/api/device/live-sessions/report",
    "public_path": "/api/device/live-sessions/report",
    "auth": "device",
    "path_template": "/api/device/live-sessions/report",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_ota_report": {
    "operation_id": "post__api_device_ota_report",
    "method": "POST",
    "path": "/api/device/ota/report",
    "public_path": "/api/device/ota/report",
    "auth": "device",
    "path_template": "/api/device/ota/report",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_position_report": {
    "operation_id": "post__api_device_position_report",
    "method": "POST",
    "path": "/api/device/position/report",
    "public_path": "/api/device/position/report",
    "auth": "device",
    "path_template": "/api/device/position/report",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_device_snapshot_upload": {
    "operation_id": "post__api_device_snapshot_upload",
    "method": "POST",
    "path": "/api/device/snapshot/upload",
    "public_path": "/api/device/snapshot/upload",
    "auth": "device",
    "path_template": "/api/device/snapshot/upload",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_events": {
    "operation_id": "post__api_events",
    "method": "POST",
    "path": "/api/events",
    "public_path": "/api/events",
    "auth": "session_csrf",
    "path_template": "/api/events",
    "domain": "api-alias (device back-compat)"
  },
  "get__api_group-cards_settings": {
    "operation_id": "get__api_group-cards_settings",
    "method": "GET",
    "path": "/api/group-cards/settings",
    "public_path": "/api/group-cards/settings",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/settings",
    "domain": "api-alias (device back-compat)"
  },
  "delete__api_group-cards_p": {
    "operation_id": "delete__api_group-cards_p",
    "method": "DELETE",
    "path": "/api/group-cards/{group_key}",
    "public_path": "/api/group-cards/{group_key}",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/{param}",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_group-cards_p_apply": {
    "operation_id": "post__api_group-cards_p_apply",
    "method": "POST",
    "path": "/api/group-cards/{group_key}/apply",
    "public_path": "/api/group-cards/{group_key}/apply",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/{param}/apply",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_group-cards_p_delete": {
    "operation_id": "post__api_group-cards_p_delete",
    "method": "POST",
    "path": "/api/group-cards/{group_key}/delete",
    "public_path": "/api/group-cards/{group_key}/delete",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/{param}/delete",
    "domain": "api-alias (device back-compat)"
  },
  "get__api_group-cards_p_settings": {
    "operation_id": "get__api_group-cards_p_settings",
    "method": "GET",
    "path": "/api/group-cards/{group_key}/settings",
    "public_path": "/api/group-cards/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/{param}/settings",
    "domain": "api-alias (device back-compat)"
  },
  "put__api_group-cards_p_settings": {
    "operation_id": "put__api_group-cards_p_settings",
    "method": "PUT",
    "path": "/api/group-cards/{group_key}/settings",
    "public_path": "/api/group-cards/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/api/group-cards/{param}/settings",
    "domain": "api-alias (device back-compat)"
  },
  "delete__api_notification-groups_p": {
    "operation_id": "delete__api_notification-groups_p",
    "method": "DELETE",
    "path": "/api/notification-groups/{group_key}",
    "public_path": "/api/notification-groups/{group_key}",
    "auth": "session_csrf",
    "path_template": "/api/notification-groups/{param}",
    "domain": "api-alias (device back-compat)"
  },
  "post__api_notification-groups_p_delete": {
    "operation_id": "post__api_notification-groups_p_delete",
    "method": "POST",
    "path": "/api/notification-groups/{group_key}/delete",
    "public_path": "/api/notification-groups/{group_key}/delete",
    "auth": "session_csrf",
    "path_template": "/api/notification-groups/{param}/delete",
    "domain": "api-alias (device back-compat)"
  },
  "get__audit": {
    "operation_id": "get__audit",
    "method": "GET",
    "path": "/audit",
    "public_path": "/api/audit",
    "auth": "session_csrf",
    "path_template": "/audit",
    "domain": "audit"
  },
  "get__audit_events": {
    "operation_id": "get__audit_events",
    "method": "GET",
    "path": "/audit/events",
    "public_path": "/api/audit/events",
    "auth": "session_csrf",
    "path_template": "/audit/events",
    "domain": "audit"
  },
  "get__audit_events_p": {
    "operation_id": "get__audit_events_p",
    "method": "GET",
    "path": "/audit/events/{audit_id}",
    "public_path": "/api/audit/events/{audit_id}",
    "auth": "session_csrf",
    "path_template": "/audit/events/{param}",
    "domain": "audit"
  },
  "post__audit_export-async-cover.pdf": {
    "operation_id": "post__audit_export-async-cover.pdf",
    "method": "POST",
    "path": "/audit/export-async-cover.pdf",
    "public_path": "/api/audit/export-async-cover.pdf",
    "auth": "session_csrf",
    "path_template": "/audit/export-async-cover.pdf",
    "domain": "audit"
  },
  "get__audit_export-async-cover_p": {
    "operation_id": "get__audit_export-async-cover_p",
    "method": "GET",
    "path": "/audit/export-async-cover/{job_id}",
    "public_path": "/api/audit/export-async-cover/{job_id}",
    "auth": "session_csrf",
    "path_template": "/audit/export-async-cover/{param}",
    "domain": "audit"
  },
  "get__audit_export-async-cover_p_result.pdf": {
    "operation_id": "get__audit_export-async-cover_p_result.pdf",
    "method": "GET",
    "path": "/audit/export-async-cover/{job_id}/result.pdf",
    "public_path": "/api/audit/export-async-cover/{job_id}/result.pdf",
    "auth": "session_csrf",
    "path_template": "/audit/export-async-cover/{param}/result.pdf",
    "domain": "audit"
  },
  "post__audit_export-async.csv": {
    "operation_id": "post__audit_export-async.csv",
    "method": "POST",
    "path": "/audit/export-async.csv",
    "public_path": "/api/audit/export-async.csv",
    "auth": "session_csrf",
    "path_template": "/audit/export-async.csv",
    "domain": "audit"
  },
  "get__audit_export-async_p": {
    "operation_id": "get__audit_export-async_p",
    "method": "GET",
    "path": "/audit/export-async/{job_id}",
    "public_path": "/api/audit/export-async/{job_id}",
    "auth": "session_csrf",
    "path_template": "/audit/export-async/{param}",
    "domain": "audit"
  },
  "get__audit_export-async_p_result.csv": {
    "operation_id": "get__audit_export-async_p_result.csv",
    "method": "GET",
    "path": "/audit/export-async/{job_id}/result.csv",
    "public_path": "/api/audit/export-async/{job_id}/result.csv",
    "auth": "session_csrf",
    "path_template": "/audit/export-async/{param}/result.csv",
    "domain": "audit"
  },
  "get__audit_export-cover.pdf": {
    "operation_id": "get__audit_export-cover.pdf",
    "method": "GET",
    "path": "/audit/export-cover.pdf",
    "public_path": "/api/audit/export-cover.pdf",
    "auth": "session_csrf",
    "path_template": "/audit/export-cover.pdf",
    "domain": "audit"
  },
  "get__audit_export.csv": {
    "operation_id": "get__audit_export.csv",
    "method": "GET",
    "path": "/audit/export.csv",
    "public_path": "/api/audit/export.csv",
    "auth": "session_csrf",
    "path_template": "/audit/export.csv",
    "domain": "audit"
  },
  "get__audit_export.pdf": {
    "operation_id": "get__audit_export.pdf",
    "method": "GET",
    "path": "/audit/export.pdf",
    "public_path": "/api/audit/export.pdf",
    "auth": "session_csrf",
    "path_template": "/audit/export.pdf",
    "domain": "audit"
  },
  "get__audit_export_csv": {
    "operation_id": "get__audit_export_csv",
    "method": "GET",
    "path": "/audit/export/csv",
    "public_path": "/api/audit/export/csv",
    "auth": "session_csrf",
    "path_template": "/audit/export/csv",
    "domain": "audit"
  },
  "post__auth_activate": {
    "operation_id": "post__auth_activate",
    "method": "POST",
    "path": "/auth/activate",
    "public_path": "/api/auth/activate",
    "auth": "session_csrf",
    "path_template": "/auth/activate",
    "domain": "auth"
  },
  "get__auth_admins": {
    "operation_id": "get__auth_admins",
    "method": "GET",
    "path": "/auth/admins",
    "public_path": "/api/auth/admins",
    "auth": "session_csrf",
    "path_template": "/auth/admins",
    "domain": "auth"
  },
  "post__auth_admins_p_close": {
    "operation_id": "post__auth_admins_p_close",
    "method": "POST",
    "path": "/auth/admins/{username}/close",
    "public_path": "/api/auth/admins/{username}/close",
    "auth": "session_csrf",
    "path_template": "/auth/admins/{param}/close",
    "domain": "auth"
  },
  "post__auth_code_resend": {
    "operation_id": "post__auth_code_resend",
    "method": "POST",
    "path": "/auth/code/resend",
    "public_path": "/api/auth/code/resend",
    "auth": "session_csrf",
    "path_template": "/auth/code/resend",
    "domain": "auth"
  },
  "get__auth_csrf": {
    "operation_id": "get__auth_csrf",
    "method": "GET",
    "path": "/auth/csrf",
    "public_path": "/api/auth/csrf",
    "auth": "session_csrf",
    "path_template": "/auth/csrf",
    "domain": "auth"
  },
  "post__auth_forgot_complete": {
    "operation_id": "post__auth_forgot_complete",
    "method": "POST",
    "path": "/auth/forgot/complete",
    "public_path": "/api/auth/forgot/complete",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/complete",
    "domain": "auth"
  },
  "post__auth_forgot_email_check": {
    "operation_id": "post__auth_forgot_email_check",
    "method": "POST",
    "path": "/auth/forgot/email/check",
    "public_path": "/api/auth/forgot/email/check",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/email/check",
    "domain": "auth"
  },
  "post__auth_forgot_email_complete": {
    "operation_id": "post__auth_forgot_email_complete",
    "method": "POST",
    "path": "/auth/forgot/email/complete",
    "public_path": "/api/auth/forgot/email/complete",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/email/complete",
    "domain": "auth"
  },
  "get__auth_forgot_email_enabled": {
    "operation_id": "get__auth_forgot_email_enabled",
    "method": "GET",
    "path": "/auth/forgot/email/enabled",
    "public_path": "/api/auth/forgot/email/enabled",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/email/enabled",
    "domain": "auth"
  },
  "post__auth_forgot_email_start": {
    "operation_id": "post__auth_forgot_email_start",
    "method": "POST",
    "path": "/auth/forgot/email/start",
    "public_path": "/api/auth/forgot/email/start",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/email/start",
    "domain": "auth"
  },
  "get__auth_forgot_enabled": {
    "operation_id": "get__auth_forgot_enabled",
    "method": "GET",
    "path": "/auth/forgot/enabled",
    "public_path": "/api/auth/forgot/enabled",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/enabled",
    "domain": "auth"
  },
  "post__auth_forgot_start": {
    "operation_id": "post__auth_forgot_start",
    "method": "POST",
    "path": "/auth/forgot/start",
    "public_path": "/api/auth/forgot/start",
    "auth": "session_csrf",
    "path_template": "/auth/forgot/start",
    "domain": "auth"
  },
  "post__auth_login": {
    "operation_id": "post__auth_login",
    "method": "POST",
    "path": "/auth/login",
    "public_path": "/api/auth/login",
    "auth": "none",
    "path_template": "/auth/login",
    "domain": "auth"
  },
  "post__auth_login_email-second": {
    "operation_id": "post__auth_login_email-second",
    "method": "POST",
    "path": "/auth/login/email-second",
    "public_path": "/api/auth/login/email-second",
    "auth": "none",
    "path_template": "/auth/login/email-second",
    "domain": "auth"
  },
  "post__auth_logout": {
    "operation_id": "post__auth_logout",
    "method": "POST",
    "path": "/auth/logout",
    "public_path": "/api/auth/logout",
    "auth": "session_csrf",
    "path_template": "/auth/logout",
    "domain": "auth"
  },
  "delete__auth_me": {
    "operation_id": "delete__auth_me",
    "method": "DELETE",
    "path": "/auth/me",
    "public_path": "/api/auth/me",
    "auth": "session_csrf",
    "path_template": "/auth/me",
    "domain": "auth"
  },
  "get__auth_me": {
    "operation_id": "get__auth_me",
    "method": "GET",
    "path": "/auth/me",
    "public_path": "/api/auth/me",
    "auth": "session_csrf",
    "path_template": "/auth/me",
    "domain": "auth"
  },
  "get__auth_me_alert-recipients": {
    "operation_id": "get__auth_me_alert-recipients",
    "method": "GET",
    "path": "/auth/me/alert-recipients",
    "public_path": "/api/auth/me/alert-recipients",
    "auth": "session_csrf",
    "path_template": "/auth/me/alert-recipients",
    "domain": "auth"
  },
  "post__auth_me_alert-recipients": {
    "operation_id": "post__auth_me_alert-recipients",
    "method": "POST",
    "path": "/auth/me/alert-recipients",
    "public_path": "/api/auth/me/alert-recipients",
    "auth": "session_csrf",
    "path_template": "/auth/me/alert-recipients",
    "domain": "auth"
  },
  "post__auth_me_alert-recipients_request-verify": {
    "operation_id": "post__auth_me_alert-recipients_request-verify",
    "method": "POST",
    "path": "/auth/me/alert-recipients/request-verify",
    "public_path": "/api/auth/me/alert-recipients/request-verify",
    "auth": "session_csrf",
    "path_template": "/auth/me/alert-recipients/request-verify",
    "domain": "auth"
  },
  "delete__auth_me_alert-recipients_p": {
    "operation_id": "delete__auth_me_alert-recipients_p",
    "method": "DELETE",
    "path": "/auth/me/alert-recipients/{rid}",
    "public_path": "/api/auth/me/alert-recipients/{rid}",
    "auth": "session_csrf",
    "path_template": "/auth/me/alert-recipients/{param}",
    "domain": "auth"
  },
  "patch__auth_me_alert-recipients_p": {
    "operation_id": "patch__auth_me_alert-recipients_p",
    "method": "PATCH",
    "path": "/auth/me/alert-recipients/{rid}",
    "public_path": "/api/auth/me/alert-recipients/{rid}",
    "auth": "session_csrf",
    "path_template": "/auth/me/alert-recipients/{param}",
    "domain": "auth"
  },
  "get__auth_me_avatar": {
    "operation_id": "get__auth_me_avatar",
    "method": "GET",
    "path": "/auth/me/avatar",
    "public_path": "/api/auth/me/avatar",
    "auth": "session_csrf",
    "path_template": "/auth/me/avatar",
    "domain": "auth"
  },
  "post__auth_me_avatar_upload": {
    "operation_id": "post__auth_me_avatar_upload",
    "method": "POST",
    "path": "/auth/me/avatar/upload",
    "public_path": "/api/auth/me/avatar/upload",
    "auth": "session_csrf",
    "path_template": "/auth/me/avatar/upload",
    "domain": "auth"
  },
  "post__auth_me_delete": {
    "operation_id": "post__auth_me_delete",
    "method": "POST",
    "path": "/auth/me/delete",
    "public_path": "/api/auth/me/delete",
    "auth": "session_csrf",
    "path_template": "/auth/me/delete",
    "domain": "auth"
  },
  "delete__auth_me_fcm-token": {
    "operation_id": "delete__auth_me_fcm-token",
    "method": "DELETE",
    "path": "/auth/me/fcm-token",
    "public_path": "/api/auth/me/fcm-token",
    "auth": "session_csrf",
    "path_template": "/auth/me/fcm-token",
    "domain": "auth"
  },
  "post__auth_me_fcm-token": {
    "operation_id": "post__auth_me_fcm-token",
    "method": "POST",
    "path": "/auth/me/fcm-token",
    "public_path": "/api/auth/me/fcm-token",
    "auth": "session_csrf",
    "path_template": "/auth/me/fcm-token",
    "domain": "auth"
  },
  "post__auth_me_fcm-token_delete": {
    "operation_id": "post__auth_me_fcm-token_delete",
    "method": "POST",
    "path": "/auth/me/fcm-token/delete",
    "public_path": "/api/auth/me/fcm-token/delete",
    "auth": "session_csrf",
    "path_template": "/auth/me/fcm-token/delete",
    "domain": "auth"
  },
  "get__auth_me_notification-prefs": {
    "operation_id": "get__auth_me_notification-prefs",
    "method": "GET",
    "path": "/auth/me/notification-prefs",
    "public_path": "/api/auth/me/notification-prefs",
    "auth": "session_csrf",
    "path_template": "/auth/me/notification-prefs",
    "domain": "auth"
  },
  "patch__auth_me_notification-prefs": {
    "operation_id": "patch__auth_me_notification-prefs",
    "method": "PATCH",
    "path": "/auth/me/notification-prefs",
    "public_path": "/api/auth/me/notification-prefs",
    "auth": "session_csrf",
    "path_template": "/auth/me/notification-prefs",
    "domain": "auth"
  },
  "patch__auth_me_password": {
    "operation_id": "patch__auth_me_password",
    "method": "PATCH",
    "path": "/auth/me/password",
    "public_path": "/api/auth/me/password",
    "auth": "session_csrf",
    "path_template": "/auth/me/password",
    "domain": "auth"
  },
  "put__auth_me_phone": {
    "operation_id": "put__auth_me_phone",
    "method": "PUT",
    "path": "/auth/me/phone",
    "public_path": "/api/auth/me/phone",
    "auth": "session_csrf",
    "path_template": "/auth/me/phone",
    "domain": "auth"
  },
  "post__auth_me_phone_verify-call": {
    "operation_id": "post__auth_me_phone_verify-call",
    "method": "POST",
    "path": "/auth/me/phone/verify-call",
    "public_path": "/api/auth/me/phone/verify-call",
    "auth": "session_csrf",
    "path_template": "/auth/me/phone/verify-call",
    "domain": "auth"
  },
  "patch__auth_me_profile": {
    "operation_id": "patch__auth_me_profile",
    "method": "PATCH",
    "path": "/auth/me/profile",
    "public_path": "/api/auth/me/profile",
    "auth": "session_csrf",
    "path_template": "/auth/me/profile",
    "domain": "auth"
  },
  "get__auth_me_sessions": {
    "operation_id": "get__auth_me_sessions",
    "method": "GET",
    "path": "/auth/me/sessions",
    "public_path": "/api/auth/me/sessions",
    "auth": "session_csrf",
    "path_template": "/auth/me/sessions",
    "domain": "auth"
  },
  "post__auth_me_sessions_revoke": {
    "operation_id": "post__auth_me_sessions_revoke",
    "method": "POST",
    "path": "/auth/me/sessions/revoke",
    "public_path": "/api/auth/me/sessions/revoke",
    "auth": "session_csrf",
    "path_template": "/auth/me/sessions/revoke",
    "domain": "auth"
  },
  "post__auth_me_verify-ota-unlock": {
    "operation_id": "post__auth_me_verify-ota-unlock",
    "method": "POST",
    "path": "/auth/me/verify-ota-unlock",
    "public_path": "/api/auth/me/verify-ota-unlock",
    "auth": "session_csrf",
    "path_template": "/auth/me/verify-ota-unlock",
    "domain": "auth"
  },
  "post__auth_me_verify-password": {
    "operation_id": "post__auth_me_verify-password",
    "method": "POST",
    "path": "/auth/me/verify-password",
    "public_path": "/api/auth/me/verify-password",
    "auth": "session_csrf",
    "path_template": "/auth/me/verify-password",
    "domain": "auth"
  },
  "post__auth_resend-verification": {
    "operation_id": "post__auth_resend-verification",
    "method": "POST",
    "path": "/auth/resend-verification",
    "public_path": "/api/auth/resend-verification",
    "auth": "session_csrf",
    "path_template": "/auth/resend-verification",
    "domain": "auth"
  },
  "post__auth_signup": {
    "operation_id": "post__auth_signup",
    "method": "POST",
    "path": "/auth/signup",
    "public_path": "/api/auth/signup",
    "auth": "session_csrf",
    "path_template": "/auth/signup",
    "domain": "auth"
  },
  "post__auth_signup_approve_p": {
    "operation_id": "post__auth_signup_approve_p",
    "method": "POST",
    "path": "/auth/signup/approve/{username}",
    "public_path": "/api/auth/signup/approve/{username}",
    "auth": "session_csrf",
    "path_template": "/auth/signup/approve/{param}",
    "domain": "auth"
  },
  "get__auth_signup_pending": {
    "operation_id": "get__auth_signup_pending",
    "method": "GET",
    "path": "/auth/signup/pending",
    "public_path": "/api/auth/signup/pending",
    "auth": "session_csrf",
    "path_template": "/auth/signup/pending",
    "domain": "auth"
  },
  "post__auth_signup_reject_p": {
    "operation_id": "post__auth_signup_reject_p",
    "method": "POST",
    "path": "/auth/signup/reject/{username}",
    "public_path": "/api/auth/signup/reject/{username}",
    "auth": "session_csrf",
    "path_template": "/auth/signup/reject/{param}",
    "domain": "auth"
  },
  "post__auth_signup_start": {
    "operation_id": "post__auth_signup_start",
    "method": "POST",
    "path": "/auth/signup/start",
    "public_path": "/api/auth/signup/start",
    "auth": "none",
    "path_template": "/auth/signup/start",
    "domain": "auth"
  },
  "post__auth_signup_verify": {
    "operation_id": "post__auth_signup_verify",
    "method": "POST",
    "path": "/auth/signup/verify",
    "public_path": "/api/auth/signup/verify",
    "auth": "none",
    "path_template": "/auth/signup/verify",
    "domain": "auth"
  },
  "get__auth_users": {
    "operation_id": "get__auth_users",
    "method": "GET",
    "path": "/auth/users",
    "public_path": "/api/auth/users",
    "auth": "session_csrf",
    "path_template": "/auth/users",
    "domain": "auth"
  },
  "post__auth_users": {
    "operation_id": "post__auth_users",
    "method": "POST",
    "path": "/auth/users",
    "public_path": "/api/auth/users",
    "auth": "session_csrf",
    "path_template": "/auth/users",
    "domain": "auth"
  },
  "delete__auth_users_p": {
    "operation_id": "delete__auth_users_p",
    "method": "DELETE",
    "path": "/auth/users/{username}",
    "public_path": "/api/auth/users/{username}",
    "auth": "session_csrf",
    "path_template": "/auth/users/{param}",
    "domain": "auth"
  },
  "get__auth_users_p_policy": {
    "operation_id": "get__auth_users_p_policy",
    "method": "GET",
    "path": "/auth/users/{username}/policy",
    "public_path": "/api/auth/users/{username}/policy",
    "auth": "session_csrf",
    "path_template": "/auth/users/{param}/policy",
    "domain": "auth"
  },
  "put__auth_users_p_policy": {
    "operation_id": "put__auth_users_p_policy",
    "method": "PUT",
    "path": "/auth/users/{username}/policy",
    "public_path": "/api/auth/users/{username}/policy",
    "auth": "session_csrf",
    "path_template": "/auth/users/{param}/policy",
    "domain": "auth"
  },
  "post__auth_users_p_sessions_revoke": {
    "operation_id": "post__auth_users_p_sessions_revoke",
    "method": "POST",
    "path": "/auth/users/{username}/sessions/revoke",
    "public_path": "/api/auth/users/{username}/sessions/revoke",
    "auth": "session_csrf",
    "path_template": "/auth/users/{param}/sessions/revoke",
    "domain": "auth"
  },
  "post__auth_verify-email": {
    "operation_id": "post__auth_verify-email",
    "method": "POST",
    "path": "/auth/verify-email",
    "public_path": "/api/auth/verify-email",
    "auth": "session_csrf",
    "path_template": "/auth/verify-email",
    "domain": "auth"
  },
  "post__auth_verify-phone": {
    "operation_id": "post__auth_verify-phone",
    "method": "POST",
    "path": "/auth/verify-phone",
    "public_path": "/api/auth/verify-phone",
    "auth": "session_csrf",
    "path_template": "/auth/verify-phone",
    "domain": "auth"
  },
  "get__automations": {
    "operation_id": "get__automations",
    "method": "GET",
    "path": "/automations",
    "public_path": "/api/automations",
    "auth": "session_csrf",
    "path_template": "/automations",
    "domain": "automations"
  },
  "post__automations": {
    "operation_id": "post__automations",
    "method": "POST",
    "path": "/automations",
    "public_path": "/api/automations",
    "auth": "session_csrf",
    "path_template": "/automations",
    "domain": "automations"
  },
  "post__automations_domain_activations_p_hold": {
    "operation_id": "post__automations_domain_activations_p_hold",
    "method": "POST",
    "path": "/automations/domain/activations/{activation_id}/hold",
    "public_path": "/api/automations/domain/activations/{activation_id}/hold",
    "auth": "session_csrf",
    "path_template": "/automations/domain/activations/{param}/hold",
    "domain": "automations"
  },
  "post__automations_domain_activations_p_release": {
    "operation_id": "post__automations_domain_activations_p_release",
    "method": "POST",
    "path": "/automations/domain/activations/{activation_id}/release",
    "public_path": "/api/automations/domain/activations/{activation_id}/release",
    "auth": "session_csrf",
    "path_template": "/automations/domain/activations/{param}/release",
    "domain": "automations"
  },
  "post__automations_domain_define": {
    "operation_id": "post__automations_domain_define",
    "method": "POST",
    "path": "/automations/domain/define",
    "public_path": "/api/automations/domain/define",
    "auth": "session_csrf",
    "path_template": "/automations/domain/define",
    "domain": "automations"
  },
  "get__automations_domain_executors": {
    "operation_id": "get__automations_domain_executors",
    "method": "GET",
    "path": "/automations/domain/executors",
    "public_path": "/api/automations/domain/executors",
    "auth": "session_csrf",
    "path_template": "/automations/domain/executors",
    "domain": "automations"
  },
  "get__automations_domain_library": {
    "operation_id": "get__automations_domain_library",
    "method": "GET",
    "path": "/automations/domain/library",
    "public_path": "/api/automations/domain/library",
    "auth": "session_csrf",
    "path_template": "/automations/domain/library",
    "domain": "automations"
  },
  "post__automations_domain_runs_p_cancel": {
    "operation_id": "post__automations_domain_runs_p_cancel",
    "method": "POST",
    "path": "/automations/domain/runs/{run_id}/cancel",
    "public_path": "/api/automations/domain/runs/{run_id}/cancel",
    "auth": "session_csrf",
    "path_template": "/automations/domain/runs/{param}/cancel",
    "domain": "automations"
  },
  "post__automations_domain_p_activate": {
    "operation_id": "post__automations_domain_p_activate",
    "method": "POST",
    "path": "/automations/domain/{automation_id}/activate",
    "public_path": "/api/automations/domain/{automation_id}/activate",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/activate",
    "domain": "automations"
  },
  "get__automations_domain_p_activations": {
    "operation_id": "get__automations_domain_p_activations",
    "method": "GET",
    "path": "/automations/domain/{automation_id}/activations",
    "public_path": "/api/automations/domain/{automation_id}/activations",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/activations",
    "domain": "automations"
  },
  "post__automations_domain_p_publish": {
    "operation_id": "post__automations_domain_p_publish",
    "method": "POST",
    "path": "/automations/domain/{automation_id}/publish",
    "public_path": "/api/automations/domain/{automation_id}/publish",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/publish",
    "domain": "automations"
  },
  "get__automations_domain_p_runs": {
    "operation_id": "get__automations_domain_p_runs",
    "method": "GET",
    "path": "/automations/domain/{automation_id}/runs",
    "public_path": "/api/automations/domain/{automation_id}/runs",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/runs",
    "domain": "automations"
  },
  "post__automations_domain_p_simulate": {
    "operation_id": "post__automations_domain_p_simulate",
    "method": "POST",
    "path": "/automations/domain/{automation_id}/simulate",
    "public_path": "/api/automations/domain/{automation_id}/simulate",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/simulate",
    "domain": "automations"
  },
  "post__automations_domain_p_trigger": {
    "operation_id": "post__automations_domain_p_trigger",
    "method": "POST",
    "path": "/automations/domain/{automation_id}/trigger",
    "public_path": "/api/automations/domain/{automation_id}/trigger",
    "auth": "session_csrf",
    "path_template": "/automations/domain/{param}/trigger",
    "domain": "automations"
  },
  "get__automations_status": {
    "operation_id": "get__automations_status",
    "method": "GET",
    "path": "/automations/status",
    "public_path": "/api/automations/status",
    "auth": "session_csrf",
    "path_template": "/automations/status",
    "domain": "automations"
  },
  "patch__automations_p": {
    "operation_id": "patch__automations_p",
    "method": "PATCH",
    "path": "/automations/{automation_id}",
    "public_path": "/api/automations/{automation_id}",
    "auth": "session_csrf",
    "path_template": "/automations/{param}",
    "domain": "automations"
  },
  "get__automations_p_runs": {
    "operation_id": "get__automations_p_runs",
    "method": "GET",
    "path": "/automations/{automation_id}/runs",
    "public_path": "/api/automations/{automation_id}/runs",
    "auth": "session_csrf",
    "path_template": "/automations/{param}/runs",
    "domain": "automations"
  },
  "post__automations_p_trigger": {
    "operation_id": "post__automations_p_trigger",
    "method": "POST",
    "path": "/automations/{automation_id}/trigger",
    "public_path": "/api/automations/{automation_id}/trigger",
    "auth": "session_csrf",
    "path_template": "/automations/{param}/trigger",
    "domain": "automations"
  },
  "get__avatars_p": {
    "operation_id": "get__avatars_p",
    "method": "GET",
    "path": "/avatars/{name}",
    "public_path": "/api/avatars/{name}",
    "auth": "session_csrf",
    "path_template": "/avatars/{param}",
    "domain": "avatars"
  },
  "get__billing_invoices": {
    "operation_id": "get__billing_invoices",
    "method": "GET",
    "path": "/billing/invoices",
    "public_path": "/api/billing/invoices",
    "auth": "session_csrf",
    "path_template": "/billing/invoices",
    "domain": "billing"
  },
  "get__billing_status": {
    "operation_id": "get__billing_status",
    "method": "GET",
    "path": "/billing/status",
    "public_path": "/api/billing/status",
    "auth": "session_csrf",
    "path_template": "/billing/status",
    "domain": "billing"
  },
  "get__billing_usage": {
    "operation_id": "get__billing_usage",
    "method": "GET",
    "path": "/billing/usage",
    "public_path": "/api/billing/usage",
    "auth": "session_csrf",
    "path_template": "/billing/usage",
    "domain": "billing"
  },
  "post__billing_webhook_billplz": {
    "operation_id": "post__billing_webhook_billplz",
    "method": "POST",
    "path": "/billing/webhook/billplz",
    "public_path": "/api/billing/webhook/billplz",
    "auth": "webhook",
    "path_template": "/billing/webhook/billplz",
    "domain": "billing"
  },
  "get__cameras_registry": {
    "operation_id": "get__cameras_registry",
    "method": "GET",
    "path": "/cameras/registry",
    "public_path": "/api/cameras/registry",
    "auth": "session_csrf",
    "path_template": "/cameras/registry",
    "domain": "cameras"
  },
  "get__cameras_registry_p": {
    "operation_id": "get__cameras_registry_p",
    "method": "GET",
    "path": "/cameras/registry/{source_id}",
    "public_path": "/api/cameras/registry/{source_id}",
    "auth": "session_csrf",
    "path_template": "/cameras/registry/{param}",
    "domain": "cameras"
  },
  "get__cameras_signals": {
    "operation_id": "get__cameras_signals",
    "method": "GET",
    "path": "/cameras/signals",
    "public_path": "/api/cameras/signals",
    "auth": "session_csrf",
    "path_template": "/cameras/signals",
    "domain": "cameras"
  },
  "get__cameras_signals_stream": {
    "operation_id": "get__cameras_signals_stream",
    "method": "GET",
    "path": "/cameras/signals/stream",
    "public_path": "/api/cameras/signals/stream",
    "auth": "session_csrf",
    "path_template": "/cameras/signals/stream",
    "domain": "cameras"
  },
  "get__cameras_wall": {
    "operation_id": "get__cameras_wall",
    "method": "GET",
    "path": "/cameras/wall",
    "public_path": "/api/cameras/wall",
    "auth": "session_csrf",
    "path_template": "/cameras/wall",
    "domain": "cameras"
  },
  "post__commands_broadcast": {
    "operation_id": "post__commands_broadcast",
    "method": "POST",
    "path": "/commands/broadcast",
    "public_path": "/api/commands/broadcast",
    "auth": "session_csrf",
    "path_template": "/commands/broadcast",
    "domain": "commands"
  },
  "get__control_status": {
    "operation_id": "get__control_status",
    "method": "GET",
    "path": "/control/status",
    "public_path": "/api/control/status",
    "auth": "session_csrf",
    "path_template": "/control/status",
    "domain": "control"
  },
  "get__credential-fabric_receipts": {
    "operation_id": "get__credential-fabric_receipts",
    "method": "GET",
    "path": "/credential-fabric/receipts",
    "public_path": "/api/credential-fabric/receipts",
    "auth": "session_csrf",
    "path_template": "/credential-fabric/receipts",
    "domain": "credential-fabric"
  },
  "post__credential-fabric_rotation_preview": {
    "operation_id": "post__credential-fabric_rotation_preview",
    "method": "POST",
    "path": "/credential-fabric/rotation/preview",
    "public_path": "/api/credential-fabric/rotation/preview",
    "auth": "session_csrf",
    "path_template": "/credential-fabric/rotation/preview",
    "domain": "credential-fabric"
  },
  "get__credential-fabric_status": {
    "operation_id": "get__credential-fabric_status",
    "method": "GET",
    "path": "/credential-fabric/status",
    "public_path": "/api/credential-fabric/status",
    "auth": "session_csrf",
    "path_template": "/credential-fabric/status",
    "domain": "credential-fabric"
  },
  "get__dashboard": {
    "operation_id": "get__dashboard",
    "method": "GET",
    "path": "/dashboard",
    "public_path": "/api/dashboard",
    "auth": "session_csrf",
    "path_template": "/dashboard",
    "domain": "dashboard"
  },
  "get__dashboard_slash": {
    "operation_id": "get__dashboard_slash",
    "method": "GET",
    "path": "/dashboard/",
    "public_path": "/api/dashboard/",
    "auth": "session_csrf",
    "path_template": "/dashboard/",
    "domain": "dashboard"
  },
  "get__dashboard_overview": {
    "operation_id": "get__dashboard_overview",
    "method": "GET",
    "path": "/dashboard/overview",
    "public_path": "/api/dashboard/overview",
    "auth": "session_csrf",
    "path_template": "/dashboard/overview",
    "domain": "dashboard"
  },
  "post__device_board_report": {
    "operation_id": "post__device_board_report",
    "method": "POST",
    "path": "/device/board/report",
    "public_path": "/api/device/board/report",
    "auth": "device",
    "path_template": "/device/board/report",
    "domain": "device"
  },
  "post__device_boot-sync": {
    "operation_id": "post__device_boot-sync",
    "method": "POST",
    "path": "/device/boot-sync",
    "public_path": "/api/device/boot-sync",
    "auth": "device",
    "path_template": "/device/boot-sync",
    "domain": "device"
  },
  "post__device_commands_ack": {
    "operation_id": "post__device_commands_ack",
    "method": "POST",
    "path": "/device/commands/ack",
    "public_path": "/api/device/commands/ack",
    "auth": "device",
    "path_template": "/device/commands/ack",
    "domain": "device"
  },
  "post__device_commands_pending": {
    "operation_id": "post__device_commands_pending",
    "method": "POST",
    "path": "/device/commands/pending",
    "public_path": "/api/device/commands/pending",
    "auth": "device",
    "path_template": "/device/commands/pending",
    "domain": "device"
  },
  "post__device_events": {
    "operation_id": "post__device_events",
    "method": "POST",
    "path": "/device/events",
    "public_path": "/api/device/events",
    "auth": "device",
    "path_template": "/device/events",
    "domain": "device"
  },
  "post__device_live-sessions_bridge": {
    "operation_id": "post__device_live-sessions_bridge",
    "method": "POST",
    "path": "/device/live-sessions/bridge",
    "public_path": "/api/device/live-sessions/bridge",
    "auth": "device",
    "path_template": "/device/live-sessions/bridge",
    "domain": "device"
  },
  "post__device_live-sessions_report": {
    "operation_id": "post__device_live-sessions_report",
    "method": "POST",
    "path": "/device/live-sessions/report",
    "public_path": "/api/device/live-sessions/report",
    "auth": "device",
    "path_template": "/device/live-sessions/report",
    "domain": "device"
  },
  "post__device_ota_report": {
    "operation_id": "post__device_ota_report",
    "method": "POST",
    "path": "/device/ota/report",
    "public_path": "/api/device/ota/report",
    "auth": "device",
    "path_template": "/device/ota/report",
    "domain": "device"
  },
  "post__device_position_report": {
    "operation_id": "post__device_position_report",
    "method": "POST",
    "path": "/device/position/report",
    "public_path": "/api/device/position/report",
    "auth": "device",
    "path_template": "/device/position/report",
    "domain": "device"
  },
  "post__device_snapshot_upload": {
    "operation_id": "post__device_snapshot_upload",
    "method": "POST",
    "path": "/device/snapshot/upload",
    "public_path": "/api/device/snapshot/upload",
    "auth": "device",
    "path_template": "/device/snapshot/upload",
    "domain": "device"
  },
  "get__devices": {
    "operation_id": "get__devices",
    "method": "GET",
    "path": "/devices",
    "public_path": "/api/devices",
    "auth": "session_csrf",
    "path_template": "/devices",
    "domain": "devices"
  },
  "post__devices_bulk_profile": {
    "operation_id": "post__devices_bulk_profile",
    "method": "POST",
    "path": "/devices/bulk/profile",
    "public_path": "/api/devices/bulk/profile",
    "auth": "session_csrf",
    "path_template": "/devices/bulk/profile",
    "domain": "devices"
  },
  "get__devices_capabilities": {
    "operation_id": "get__devices_capabilities",
    "method": "GET",
    "path": "/devices/capabilities",
    "public_path": "/api/devices/capabilities",
    "auth": "session_csrf",
    "path_template": "/devices/capabilities",
    "domain": "devices"
  },
  "get__devices_firmware-hints": {
    "operation_id": "get__devices_firmware-hints",
    "method": "GET",
    "path": "/devices/firmware-hints",
    "public_path": "/api/devices/firmware-hints",
    "auth": "session_csrf",
    "path_template": "/devices/firmware-hints",
    "domain": "devices"
  },
  "post__devices_map-resolve": {
    "operation_id": "post__devices_map-resolve",
    "method": "POST",
    "path": "/devices/map-resolve",
    "public_path": "/api/devices/map-resolve",
    "auth": "session_csrf",
    "path_template": "/devices/map-resolve",
    "domain": "devices"
  },
  "get__devices_map-snapshot": {
    "operation_id": "get__devices_map-snapshot",
    "method": "GET",
    "path": "/devices/map-snapshot",
    "public_path": "/api/devices/map-snapshot",
    "auth": "session_csrf",
    "path_template": "/devices/map-snapshot",
    "domain": "devices"
  },
  "get__devices_revoked": {
    "operation_id": "get__devices_revoked",
    "method": "GET",
    "path": "/devices/revoked",
    "public_path": "/api/devices/revoked",
    "auth": "session_csrf",
    "path_template": "/devices/revoked",
    "domain": "devices"
  },
  "get__devices_p": {
    "operation_id": "get__devices_p",
    "method": "GET",
    "path": "/devices/{device_id}",
    "public_path": "/api/devices/{device_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}",
    "domain": "devices"
  },
  "get__devices_p_alarm-feed": {
    "operation_id": "get__devices_p_alarm-feed",
    "method": "GET",
    "path": "/devices/{device_id}/alarm-feed",
    "public_path": "/api/devices/{device_id}/alarm-feed",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/alarm-feed",
    "domain": "devices"
  },
  "post__devices_p_alert_off": {
    "operation_id": "post__devices_p_alert_off",
    "method": "POST",
    "path": "/devices/{device_id}/alert/off",
    "public_path": "/api/devices/{device_id}/alert/off",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/alert/off",
    "domain": "devices"
  },
  "post__devices_p_alert_on": {
    "operation_id": "post__devices_p_alert_on",
    "method": "POST",
    "path": "/devices/{device_id}/alert/on",
    "public_path": "/api/devices/{device_id}/alert/on",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/alert/on",
    "domain": "devices"
  },
  "get__devices_p_board-loop": {
    "operation_id": "get__devices_p_board-loop",
    "method": "GET",
    "path": "/devices/{device_id}/board-loop",
    "public_path": "/api/devices/{device_id}/board-loop",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/board-loop",
    "domain": "devices"
  },
  "get__devices_p_board-telemetry": {
    "operation_id": "get__devices_p_board-telemetry",
    "method": "GET",
    "path": "/devices/{device_id}/board-telemetry",
    "public_path": "/api/devices/{device_id}/board-telemetry",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/board-telemetry",
    "domain": "devices"
  },
  "post__devices_p_board_ask": {
    "operation_id": "post__devices_p_board_ask",
    "method": "POST",
    "path": "/devices/{device_id}/board/ask",
    "public_path": "/api/devices/{device_id}/board/ask",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/board/ask",
    "domain": "devices"
  },
  "get__devices_p_capabilities": {
    "operation_id": "get__devices_p_capabilities",
    "method": "GET",
    "path": "/devices/{device_id}/capabilities",
    "public_path": "/api/devices/{device_id}/capabilities",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/capabilities",
    "domain": "devices"
  },
  "post__devices_p_capabilities": {
    "operation_id": "post__devices_p_capabilities",
    "method": "POST",
    "path": "/devices/{device_id}/capabilities",
    "public_path": "/api/devices/{device_id}/capabilities",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/capabilities",
    "domain": "devices"
  },
  "post__devices_p_commands": {
    "operation_id": "post__devices_p_commands",
    "method": "POST",
    "path": "/devices/{device_id}/commands",
    "public_path": "/api/devices/{device_id}/commands",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/commands",
    "domain": "devices"
  },
  "get__devices_p_connections": {
    "operation_id": "get__devices_p_connections",
    "method": "GET",
    "path": "/devices/{device_id}/connections",
    "public_path": "/api/devices/{device_id}/connections",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/connections",
    "domain": "devices"
  },
  "post__devices_p_connections_p_dismiss": {
    "operation_id": "post__devices_p_connections_p_dismiss",
    "method": "POST",
    "path": "/devices/{device_id}/connections/{gpio}/dismiss",
    "public_path": "/api/devices/{device_id}/connections/{gpio}/dismiss",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/connections/{param}/dismiss",
    "domain": "devices"
  },
  "post__devices_p_delete-reset": {
    "operation_id": "post__devices_p_delete-reset",
    "method": "POST",
    "path": "/devices/{device_id}/delete-reset",
    "public_path": "/api/devices/{device_id}/delete-reset",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/delete-reset",
    "domain": "devices"
  },
  "patch__devices_p_display-label": {
    "operation_id": "patch__devices_p_display-label",
    "method": "PATCH",
    "path": "/devices/{device_id}/display-label",
    "public_path": "/api/devices/{device_id}/display-label",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/display-label",
    "domain": "devices"
  },
  "post__devices_p_factory-unregister": {
    "operation_id": "post__devices_p_factory-unregister",
    "method": "POST",
    "path": "/devices/{device_id}/factory-unregister",
    "public_path": "/api/devices/{device_id}/factory-unregister",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/factory-unregister",
    "domain": "devices"
  },
  "post__devices_p_forge_compose": {
    "operation_id": "post__devices_p_forge_compose",
    "method": "POST",
    "path": "/devices/{device_id}/forge/compose",
    "public_path": "/api/devices/{device_id}/forge/compose",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/forge/compose",
    "domain": "devices"
  },
  "get__devices_p_interfaces": {
    "operation_id": "get__devices_p_interfaces",
    "method": "GET",
    "path": "/devices/{device_id}/interfaces",
    "public_path": "/api/devices/{device_id}/interfaces",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/interfaces",
    "domain": "devices"
  },
  "post__devices_p_interfaces_scan": {
    "operation_id": "post__devices_p_interfaces_scan",
    "method": "POST",
    "path": "/devices/{device_id}/interfaces/scan",
    "public_path": "/api/devices/{device_id}/interfaces/scan",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/interfaces/scan",
    "domain": "devices"
  },
  "get__devices_p_live-sessions": {
    "operation_id": "get__devices_p_live-sessions",
    "method": "GET",
    "path": "/devices/{device_id}/live-sessions",
    "public_path": "/api/devices/{device_id}/live-sessions",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions",
    "domain": "devices"
  },
  "post__devices_p_live-sessions": {
    "operation_id": "post__devices_p_live-sessions",
    "method": "POST",
    "path": "/devices/{device_id}/live-sessions",
    "public_path": "/api/devices/{device_id}/live-sessions",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions",
    "domain": "devices"
  },
  "get__devices_p_live-sessions_p": {
    "operation_id": "get__devices_p_live-sessions_p",
    "method": "GET",
    "path": "/devices/{device_id}/live-sessions/{session_id}",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}",
    "domain": "devices"
  },
  "get__devices_p_live-sessions_p_bridge": {
    "operation_id": "get__devices_p_live-sessions_p_bridge",
    "method": "GET",
    "path": "/devices/{device_id}/live-sessions/{session_id}/bridge",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}/bridge",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}/bridge",
    "domain": "devices"
  },
  "post__devices_p_live-sessions_p_close": {
    "operation_id": "post__devices_p_live-sessions_p_close",
    "method": "POST",
    "path": "/devices/{device_id}/live-sessions/{session_id}/close",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}/close",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}/close",
    "domain": "devices"
  },
  "post__devices_p_live-sessions_p_renew": {
    "operation_id": "post__devices_p_live-sessions_p_renew",
    "method": "POST",
    "path": "/devices/{device_id}/live-sessions/{session_id}/renew",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}/renew",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}/renew",
    "domain": "devices"
  },
  "get__devices_p_live-sessions_p_view_aus": {
    "operation_id": "get__devices_p_live-sessions_p_view_aus",
    "method": "GET",
    "path": "/devices/{device_id}/live-sessions/{session_id}/view/aus",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}/view/aus",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}/view/aus",
    "domain": "devices"
  },
  "post__devices_p_live-sessions_p_whep-ticket": {
    "operation_id": "post__devices_p_live-sessions_p_whep-ticket",
    "method": "POST",
    "path": "/devices/{device_id}/live-sessions/{session_id}/whep-ticket",
    "public_path": "/api/devices/{device_id}/live-sessions/{session_id}/whep-ticket",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/live-sessions/{param}/whep-ticket",
    "domain": "devices"
  },
  "get__devices_p_messages": {
    "operation_id": "get__devices_p_messages",
    "method": "GET",
    "path": "/devices/{device_id}/messages",
    "public_path": "/api/devices/{device_id}/messages",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/messages",
    "domain": "devices"
  },
  "get__devices_p_pins": {
    "operation_id": "get__devices_p_pins",
    "method": "GET",
    "path": "/devices/{device_id}/pins",
    "public_path": "/api/devices/{device_id}/pins",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins",
    "domain": "devices"
  },
  "post__devices_p_pins_forget-all": {
    "operation_id": "post__devices_p_pins_forget-all",
    "method": "POST",
    "path": "/devices/{device_id}/pins/forget-all",
    "public_path": "/api/devices/{device_id}/pins/forget-all",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/forget-all",
    "domain": "devices"
  },
  "delete__devices_p_pins_p": {
    "operation_id": "delete__devices_p_pins_p",
    "method": "DELETE",
    "path": "/devices/{device_id}/pins/{seat_id}",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}",
    "domain": "devices"
  },
  "put__devices_p_pins_p": {
    "operation_id": "put__devices_p_pins_p",
    "method": "PUT",
    "path": "/devices/{device_id}/pins/{seat_id}",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}",
    "domain": "devices"
  },
  "post__devices_p_pins_p_confirm": {
    "operation_id": "post__devices_p_pins_p_confirm",
    "method": "POST",
    "path": "/devices/{device_id}/pins/{seat_id}/confirm",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}/confirm",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}/confirm",
    "domain": "devices"
  },
  "post__devices_p_pins_p_forget": {
    "operation_id": "post__devices_p_pins_p_forget",
    "method": "POST",
    "path": "/devices/{device_id}/pins/{seat_id}/forget",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}/forget",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}/forget",
    "domain": "devices"
  },
  "post__devices_p_pins_p_learn": {
    "operation_id": "post__devices_p_pins_p_learn",
    "method": "POST",
    "path": "/devices/{device_id}/pins/{seat_id}/learn",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}/learn",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}/learn",
    "domain": "devices"
  },
  "delete__devices_p_pins_p_override": {
    "operation_id": "delete__devices_p_pins_p_override",
    "method": "DELETE",
    "path": "/devices/{device_id}/pins/{seat_id}/override",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}/override",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}/override",
    "domain": "devices"
  },
  "post__devices_p_pins_p_override": {
    "operation_id": "post__devices_p_pins_p_override",
    "method": "POST",
    "path": "/devices/{device_id}/pins/{seat_id}/override",
    "public_path": "/api/devices/{device_id}/pins/{seat_id}/override",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/pins/{param}/override",
    "domain": "devices"
  },
  "get__devices_p_ports": {
    "operation_id": "get__devices_p_ports",
    "method": "GET",
    "path": "/devices/{device_id}/ports",
    "public_path": "/api/devices/{device_id}/ports",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/ports",
    "domain": "devices"
  },
  "get__devices_p_presence-diagnose": {
    "operation_id": "get__devices_p_presence-diagnose",
    "method": "GET",
    "path": "/devices/{device_id}/presence-diagnose",
    "public_path": "/api/devices/{device_id}/presence-diagnose",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/presence-diagnose",
    "domain": "devices"
  },
  "patch__devices_p_profile": {
    "operation_id": "patch__devices_p_profile",
    "method": "PATCH",
    "path": "/devices/{device_id}/profile",
    "public_path": "/api/devices/{device_id}/profile",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/profile",
    "domain": "devices"
  },
  "post__devices_p_provision_wifi-task": {
    "operation_id": "post__devices_p_provision_wifi-task",
    "method": "POST",
    "path": "/devices/{device_id}/provision/wifi-task",
    "public_path": "/api/devices/{device_id}/provision/wifi-task",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/provision/wifi-task",
    "domain": "devices"
  },
  "get__devices_p_provision_wifi-task_p": {
    "operation_id": "get__devices_p_provision_wifi-task_p",
    "method": "GET",
    "path": "/devices/{device_id}/provision/wifi-task/{task_id}",
    "public_path": "/api/devices/{device_id}/provision/wifi-task/{task_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/provision/wifi-task/{param}",
    "domain": "devices"
  },
  "post__devices_p_revoke": {
    "operation_id": "post__devices_p_revoke",
    "method": "POST",
    "path": "/devices/{device_id}/revoke",
    "public_path": "/api/devices/{device_id}/revoke",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/revoke",
    "domain": "devices"
  },
  "post__devices_p_schedule-reboot": {
    "operation_id": "post__devices_p_schedule-reboot",
    "method": "POST",
    "path": "/devices/{device_id}/schedule-reboot",
    "public_path": "/api/devices/{device_id}/schedule-reboot",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/schedule-reboot",
    "domain": "devices"
  },
  "get__devices_p_scheduled-jobs": {
    "operation_id": "get__devices_p_scheduled-jobs",
    "method": "GET",
    "path": "/devices/{device_id}/scheduled-jobs",
    "public_path": "/api/devices/{device_id}/scheduled-jobs",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/scheduled-jobs",
    "domain": "devices"
  },
  "post__devices_p_self-test": {
    "operation_id": "post__devices_p_self-test",
    "method": "POST",
    "path": "/devices/{device_id}/self-test",
    "public_path": "/api/devices/{device_id}/self-test",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/self-test",
    "domain": "devices"
  },
  "get__devices_p_siblings-preview": {
    "operation_id": "get__devices_p_siblings-preview",
    "method": "GET",
    "path": "/devices/{device_id}/siblings-preview",
    "public_path": "/api/devices/{device_id}/siblings-preview",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/siblings-preview",
    "domain": "devices"
  },
  "get__devices_p_storage_card": {
    "operation_id": "get__devices_p_storage_card",
    "method": "GET",
    "path": "/devices/{device_id}/storage/card",
    "public_path": "/api/devices/{device_id}/storage/card",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/storage/card",
    "domain": "devices"
  },
  "post__devices_p_storage_card_format": {
    "operation_id": "post__devices_p_storage_card_format",
    "method": "POST",
    "path": "/devices/{device_id}/storage/card/format",
    "public_path": "/api/devices/{device_id}/storage/card/format",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/storage/card/format",
    "domain": "devices"
  },
  "post__devices_p_storage_card_mount": {
    "operation_id": "post__devices_p_storage_card_mount",
    "method": "POST",
    "path": "/devices/{device_id}/storage/card/mount",
    "public_path": "/api/devices/{device_id}/storage/card/mount",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/storage/card/mount",
    "domain": "devices"
  },
  "post__devices_p_storage_card_unmount": {
    "operation_id": "post__devices_p_storage_card_unmount",
    "method": "POST",
    "path": "/devices/{device_id}/storage/card/unmount",
    "public_path": "/api/devices/{device_id}/storage/card/unmount",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/storage/card/unmount",
    "domain": "devices"
  },
  "get__devices_p_trigger-policy": {
    "operation_id": "get__devices_p_trigger-policy",
    "method": "GET",
    "path": "/devices/{device_id}/trigger-policy",
    "public_path": "/api/devices/{device_id}/trigger-policy",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/trigger-policy",
    "domain": "devices"
  },
  "put__devices_p_trigger-policy": {
    "operation_id": "put__devices_p_trigger-policy",
    "method": "PUT",
    "path": "/devices/{device_id}/trigger-policy",
    "public_path": "/api/devices/{device_id}/trigger-policy",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/trigger-policy",
    "domain": "devices"
  },
  "post__devices_p_unrevoke": {
    "operation_id": "post__devices_p_unrevoke",
    "method": "POST",
    "path": "/devices/{device_id}/unrevoke",
    "public_path": "/api/devices/{device_id}/unrevoke",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/unrevoke",
    "domain": "devices"
  },
  "post__devices_p_wifi-ops_clear": {
    "operation_id": "post__devices_p_wifi-ops_clear",
    "method": "POST",
    "path": "/devices/{device_id}/wifi-ops/clear",
    "public_path": "/api/devices/{device_id}/wifi-ops/clear",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/clear",
    "domain": "devices"
  },
  "get__devices_p_wifi-ops_jobs_p": {
    "operation_id": "get__devices_p_wifi-ops_jobs_p",
    "method": "GET",
    "path": "/devices/{device_id}/wifi-ops/jobs/{job_id}",
    "public_path": "/api/devices/{device_id}/wifi-ops/jobs/{job_id}",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/jobs/{param}",
    "domain": "devices"
  },
  "post__devices_p_wifi-ops_scan": {
    "operation_id": "post__devices_p_wifi-ops_scan",
    "method": "POST",
    "path": "/devices/{device_id}/wifi-ops/scan",
    "public_path": "/api/devices/{device_id}/wifi-ops/scan",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/scan",
    "domain": "devices"
  },
  "post__devices_p_wifi-ops_stage": {
    "operation_id": "post__devices_p_wifi-ops_stage",
    "method": "POST",
    "path": "/devices/{device_id}/wifi-ops/stage",
    "public_path": "/api/devices/{device_id}/wifi-ops/stage",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/stage",
    "domain": "devices"
  },
  "get__devices_p_wifi-ops_status": {
    "operation_id": "get__devices_p_wifi-ops_status",
    "method": "GET",
    "path": "/devices/{device_id}/wifi-ops/status",
    "public_path": "/api/devices/{device_id}/wifi-ops/status",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/status",
    "domain": "devices"
  },
  "post__devices_p_wifi-ops_switch": {
    "operation_id": "post__devices_p_wifi-ops_switch",
    "method": "POST",
    "path": "/devices/{device_id}/wifi-ops/switch",
    "public_path": "/api/devices/{device_id}/wifi-ops/switch",
    "auth": "session_csrf",
    "path_template": "/devices/{param}/wifi-ops/switch",
    "domain": "devices"
  },
  "get__diag_db-ping": {
    "operation_id": "get__diag_db-ping",
    "method": "GET",
    "path": "/diag/db-ping",
    "public_path": "/api/diag/db-ping",
    "auth": "session_csrf",
    "path_template": "/diag/db-ping",
    "domain": "diag"
  },
  "get__dispatch-rules": {
    "operation_id": "get__dispatch-rules",
    "method": "GET",
    "path": "/dispatch-rules",
    "public_path": "/api/dispatch-rules",
    "auth": "session_csrf",
    "path_template": "/dispatch-rules",
    "domain": "dispatch-rules"
  },
  "post__dispatch-rules_import": {
    "operation_id": "post__dispatch-rules_import",
    "method": "POST",
    "path": "/dispatch-rules/import",
    "public_path": "/api/dispatch-rules/import",
    "auth": "session_csrf",
    "path_template": "/dispatch-rules/import",
    "domain": "dispatch-rules"
  },
  "patch__dispatch-rules_p": {
    "operation_id": "patch__dispatch-rules_p",
    "method": "PATCH",
    "path": "/dispatch-rules/{rule_id}",
    "public_path": "/api/dispatch-rules/{rule_id}",
    "auth": "session_csrf",
    "path_template": "/dispatch-rules/{param}",
    "domain": "dispatch-rules"
  },
  "post__dispatch-rules_p_certify": {
    "operation_id": "post__dispatch-rules_p_certify",
    "method": "POST",
    "path": "/dispatch-rules/{rule_id}/certify",
    "public_path": "/api/dispatch-rules/{rule_id}/certify",
    "auth": "session_csrf",
    "path_template": "/dispatch-rules/{param}/certify",
    "domain": "dispatch-rules"
  },
  "post__dispatch-rules_p_compare": {
    "operation_id": "post__dispatch-rules_p_compare",
    "method": "POST",
    "path": "/dispatch-rules/{rule_id}/compare",
    "public_path": "/api/dispatch-rules/{rule_id}/compare",
    "auth": "session_csrf",
    "path_template": "/dispatch-rules/{param}/compare",
    "domain": "dispatch-rules"
  },
  "get__docs": {
    "operation_id": "get__docs",
    "method": "GET",
    "path": "/docs",
    "public_path": "/api/docs",
    "auth": "none",
    "path_template": "/docs",
    "domain": "docs"
  },
  "head__docs": {
    "operation_id": "head__docs",
    "method": "HEAD",
    "path": "/docs",
    "public_path": "/api/docs",
    "auth": "none",
    "path_template": "/docs",
    "domain": "docs"
  },
  "get__docs_oauth2-redirect": {
    "operation_id": "get__docs_oauth2-redirect",
    "method": "GET",
    "path": "/docs/oauth2-redirect",
    "public_path": "/api/docs/oauth2-redirect",
    "auth": "session_csrf",
    "path_template": "/docs/oauth2-redirect",
    "domain": "docs"
  },
  "head__docs_oauth2-redirect": {
    "operation_id": "head__docs_oauth2-redirect",
    "method": "HEAD",
    "path": "/docs/oauth2-redirect",
    "public_path": "/api/docs/oauth2-redirect",
    "auth": "session_csrf",
    "path_template": "/docs/oauth2-redirect",
    "domain": "docs"
  },
  "get__edge_skills_catalog": {
    "operation_id": "get__edge_skills_catalog",
    "method": "GET",
    "path": "/edge/skills/catalog",
    "public_path": "/api/edge/skills/catalog",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog",
    "domain": "edge"
  },
  "post__edge_skills_catalog": {
    "operation_id": "post__edge_skills_catalog",
    "method": "POST",
    "path": "/edge/skills/catalog",
    "public_path": "/api/edge/skills/catalog",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog",
    "domain": "edge"
  },
  "get__edge_skills_catalog_status": {
    "operation_id": "get__edge_skills_catalog_status",
    "method": "GET",
    "path": "/edge/skills/catalog/status",
    "public_path": "/api/edge/skills/catalog/status",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog/status",
    "domain": "edge"
  },
  "get__edge_skills_catalog_p": {
    "operation_id": "get__edge_skills_catalog_p",
    "method": "GET",
    "path": "/edge/skills/catalog/{skill_id}",
    "public_path": "/api/edge/skills/catalog/{skill_id}",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog/{param}",
    "domain": "edge"
  },
  "put__edge_skills_catalog_p": {
    "operation_id": "put__edge_skills_catalog_p",
    "method": "PUT",
    "path": "/edge/skills/catalog/{skill_id}",
    "public_path": "/api/edge/skills/catalog/{skill_id}",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog/{param}",
    "domain": "edge"
  },
  "post__edge_skills_catalog_p_deprecate": {
    "operation_id": "post__edge_skills_catalog_p_deprecate",
    "method": "POST",
    "path": "/edge/skills/catalog/{skill_id}/deprecate",
    "public_path": "/api/edge/skills/catalog/{skill_id}/deprecate",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog/{param}/deprecate",
    "domain": "edge"
  },
  "post__edge_skills_catalog_p_publish": {
    "operation_id": "post__edge_skills_catalog_p_publish",
    "method": "POST",
    "path": "/edge/skills/catalog/{skill_id}/publish",
    "public_path": "/api/edge/skills/catalog/{skill_id}/publish",
    "auth": "session_csrf",
    "path_template": "/edge/skills/catalog/{param}/publish",
    "domain": "edge"
  },
  "get__edge_skills_runtime_artifacts": {
    "operation_id": "get__edge_skills_runtime_artifacts",
    "method": "GET",
    "path": "/edge/skills/runtime/artifacts",
    "public_path": "/api/edge/skills/runtime/artifacts",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/artifacts",
    "domain": "edge"
  },
  "post__edge_skills_runtime_artifacts": {
    "operation_id": "post__edge_skills_runtime_artifacts",
    "method": "POST",
    "path": "/edge/skills/runtime/artifacts",
    "public_path": "/api/edge/skills/runtime/artifacts",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/artifacts",
    "domain": "edge"
  },
  "post__edge_skills_runtime_artifacts_p_disable": {
    "operation_id": "post__edge_skills_runtime_artifacts_p_disable",
    "method": "POST",
    "path": "/edge/skills/runtime/artifacts/{artifact_id}/disable",
    "public_path": "/api/edge/skills/runtime/artifacts/{artifact_id}/disable",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/artifacts/{param}/disable",
    "domain": "edge"
  },
  "get__edge_skills_runtime_artifacts_p_download": {
    "operation_id": "get__edge_skills_runtime_artifacts_p_download",
    "method": "GET",
    "path": "/edge/skills/runtime/artifacts/{artifact_id}/download",
    "public_path": "/api/edge/skills/runtime/artifacts/{artifact_id}/download",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/artifacts/{param}/download",
    "domain": "edge"
  },
  "post__edge_skills_runtime_artifacts_p_enable": {
    "operation_id": "post__edge_skills_runtime_artifacts_p_enable",
    "method": "POST",
    "path": "/edge/skills/runtime/artifacts/{artifact_id}/enable",
    "public_path": "/api/edge/skills/runtime/artifacts/{artifact_id}/enable",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/artifacts/{param}/enable",
    "domain": "edge"
  },
  "get__edge_skills_runtime_devices_p": {
    "operation_id": "get__edge_skills_runtime_devices_p",
    "method": "GET",
    "path": "/edge/skills/runtime/devices/{device_id}",
    "public_path": "/api/edge/skills/runtime/devices/{device_id}",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/devices/{param}",
    "domain": "edge"
  },
  "post__edge_skills_runtime_devices_p_activate": {
    "operation_id": "post__edge_skills_runtime_devices_p_activate",
    "method": "POST",
    "path": "/edge/skills/runtime/devices/{device_id}/activate",
    "public_path": "/api/edge/skills/runtime/devices/{device_id}/activate",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/devices/{param}/activate",
    "domain": "edge"
  },
  "post__edge_skills_runtime_devices_p_install": {
    "operation_id": "post__edge_skills_runtime_devices_p_install",
    "method": "POST",
    "path": "/edge/skills/runtime/devices/{device_id}/install",
    "public_path": "/api/edge/skills/runtime/devices/{device_id}/install",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/devices/{param}/install",
    "domain": "edge"
  },
  "get__edge_skills_runtime_devices_p_jobs": {
    "operation_id": "get__edge_skills_runtime_devices_p_jobs",
    "method": "GET",
    "path": "/edge/skills/runtime/devices/{device_id}/jobs",
    "public_path": "/api/edge/skills/runtime/devices/{device_id}/jobs",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/devices/{param}/jobs",
    "domain": "edge"
  },
  "post__edge_skills_runtime_devices_p_remove": {
    "operation_id": "post__edge_skills_runtime_devices_p_remove",
    "method": "POST",
    "path": "/edge/skills/runtime/devices/{device_id}/remove",
    "public_path": "/api/edge/skills/runtime/devices/{device_id}/remove",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/devices/{param}/remove",
    "domain": "edge"
  },
  "get__edge_skills_runtime_status": {
    "operation_id": "get__edge_skills_runtime_status",
    "method": "GET",
    "path": "/edge/skills/runtime/status",
    "public_path": "/api/edge/skills/runtime/status",
    "auth": "session_csrf",
    "path_template": "/edge/skills/runtime/status",
    "domain": "edge"
  },
  "get__edge_status": {
    "operation_id": "get__edge_status",
    "method": "GET",
    "path": "/edge/status",
    "public_path": "/api/edge/status",
    "auth": "session_csrf",
    "path_template": "/edge/status",
    "domain": "edge"
  },
  "get__events": {
    "operation_id": "get__events",
    "method": "GET",
    "path": "/events",
    "public_path": "/api/events",
    "auth": "session_csrf",
    "path_template": "/events",
    "domain": "events"
  },
  "post__events": {
    "operation_id": "post__events",
    "method": "POST",
    "path": "/events",
    "public_path": "/api/events",
    "auth": "session_csrf",
    "path_template": "/events",
    "domain": "events"
  },
  "get__events_categories": {
    "operation_id": "get__events_categories",
    "method": "GET",
    "path": "/events/categories",
    "public_path": "/api/events/categories",
    "auth": "session_csrf",
    "path_template": "/events/categories",
    "domain": "events"
  },
  "post__events_export-async.csv": {
    "operation_id": "post__events_export-async.csv",
    "method": "POST",
    "path": "/events/export-async.csv",
    "public_path": "/api/events/export-async.csv",
    "auth": "session_csrf",
    "path_template": "/events/export-async.csv",
    "domain": "events"
  },
  "get__events_export-async_p": {
    "operation_id": "get__events_export-async_p",
    "method": "GET",
    "path": "/events/export-async/{job_id}",
    "public_path": "/api/events/export-async/{job_id}",
    "auth": "session_csrf",
    "path_template": "/events/export-async/{param}",
    "domain": "events"
  },
  "get__events_export-async_p_result.csv": {
    "operation_id": "get__events_export-async_p_result.csv",
    "method": "GET",
    "path": "/events/export-async/{job_id}/result.csv",
    "public_path": "/api/events/export-async/{job_id}/result.csv",
    "auth": "session_csrf",
    "path_template": "/events/export-async/{param}/result.csv",
    "domain": "events"
  },
  "get__events_export-cover.pdf": {
    "operation_id": "get__events_export-cover.pdf",
    "method": "GET",
    "path": "/events/export-cover.pdf",
    "public_path": "/api/events/export-cover.pdf",
    "auth": "session_csrf",
    "path_template": "/events/export-cover.pdf",
    "domain": "events"
  },
  "get__events_export-rows.pdf": {
    "operation_id": "get__events_export-rows.pdf",
    "method": "GET",
    "path": "/events/export-rows.pdf",
    "public_path": "/api/events/export-rows.pdf",
    "auth": "session_csrf",
    "path_template": "/events/export-rows.pdf",
    "domain": "events"
  },
  "get__events_export.csv": {
    "operation_id": "get__events_export.csv",
    "method": "GET",
    "path": "/events/export.csv",
    "public_path": "/api/events/export.csv",
    "auth": "session_csrf",
    "path_template": "/events/export.csv",
    "domain": "events"
  },
  "get__events_stats_by-device": {
    "operation_id": "get__events_stats_by-device",
    "method": "GET",
    "path": "/events/stats/by-device",
    "public_path": "/api/events/stats/by-device",
    "auth": "session_csrf",
    "path_template": "/events/stats/by-device",
    "domain": "events"
  },
  "get__events_stream": {
    "operation_id": "get__events_stream",
    "method": "GET",
    "path": "/events/stream",
    "public_path": "/api/events/stream",
    "auth": "session_csrf",
    "path_template": "/events/stream",
    "domain": "events"
  },
  "get__events_stream_v2": {
    "operation_id": "get__events_stream_v2",
    "method": "GET",
    "path": "/events/stream/v2",
    "public_path": "/api/events/stream/v2",
    "auth": "session_csrf",
    "path_template": "/events/stream/v2",
    "domain": "events"
  },
  "ws__events_ws": {
    "operation_id": "ws__events_ws",
    "method": "WS",
    "path": "/events/ws",
    "public_path": "/api/events/ws",
    "auth": "session_csrf",
    "path_template": "/events/ws",
    "domain": "events"
  },
  "get__events_p": {
    "operation_id": "get__events_p",
    "method": "GET",
    "path": "/events/{event_id}",
    "public_path": "/api/events/{event_id}",
    "auth": "session_csrf",
    "path_template": "/events/{param}",
    "domain": "events"
  },
  "get__events_p_snapshot_image": {
    "operation_id": "get__events_p_snapshot_image",
    "method": "GET",
    "path": "/events/{event_id}/snapshot/image",
    "public_path": "/api/events/{event_id}/snapshot/image",
    "auth": "session_csrf",
    "path_template": "/events/{param}/snapshot/image",
    "domain": "events"
  },
  "post__export-control_jobs": {
    "operation_id": "post__export-control_jobs",
    "method": "POST",
    "path": "/export-control/jobs",
    "public_path": "/api/export-control/jobs",
    "auth": "session_csrf",
    "path_template": "/export-control/jobs",
    "domain": "export-control"
  },
  "get__export-control_jobs_p": {
    "operation_id": "get__export-control_jobs_p",
    "method": "GET",
    "path": "/export-control/jobs/{job_id}",
    "public_path": "/api/export-control/jobs/{job_id}",
    "auth": "session_csrf",
    "path_template": "/export-control/jobs/{param}",
    "domain": "export-control"
  },
  "get__export-control_jobs_p_download": {
    "operation_id": "get__export-control_jobs_p_download",
    "method": "GET",
    "path": "/export-control/jobs/{job_id}/download",
    "public_path": "/api/export-control/jobs/{job_id}/download",
    "auth": "session_csrf",
    "path_template": "/export-control/jobs/{param}/download",
    "domain": "export-control"
  },
  "get__export-control_jobs_p_download-presigned": {
    "operation_id": "get__export-control_jobs_p_download-presigned",
    "method": "GET",
    "path": "/export-control/jobs/{job_id}/download-presigned",
    "public_path": "/api/export-control/jobs/{job_id}/download-presigned",
    "auth": "session_csrf",
    "path_template": "/export-control/jobs/{param}/download-presigned",
    "domain": "export-control"
  },
  "post__export-control_jobs_p_download-token": {
    "operation_id": "post__export-control_jobs_p_download-token",
    "method": "POST",
    "path": "/export-control/jobs/{job_id}/download-token",
    "public_path": "/api/export-control/jobs/{job_id}/download-token",
    "auth": "session_csrf",
    "path_template": "/export-control/jobs/{param}/download-token",
    "domain": "export-control"
  },
  "get__external-robots_bridge-adapters": {
    "operation_id": "get__external-robots_bridge-adapters",
    "method": "GET",
    "path": "/external-robots/bridge-adapters",
    "public_path": "/api/external-robots/bridge-adapters",
    "auth": "session_csrf",
    "path_template": "/external-robots/bridge-adapters",
    "domain": "external-robots"
  },
  "get__external-robots_bridges": {
    "operation_id": "get__external-robots_bridges",
    "method": "GET",
    "path": "/external-robots/bridges",
    "public_path": "/api/external-robots/bridges",
    "auth": "session_csrf",
    "path_template": "/external-robots/bridges",
    "domain": "external-robots"
  },
  "post__external-robots_bridges": {
    "operation_id": "post__external-robots_bridges",
    "method": "POST",
    "path": "/external-robots/bridges",
    "public_path": "/api/external-robots/bridges",
    "auth": "session_csrf",
    "path_template": "/external-robots/bridges",
    "domain": "external-robots"
  },
  "get__external-robots_catalog": {
    "operation_id": "get__external-robots_catalog",
    "method": "GET",
    "path": "/external-robots/catalog",
    "public_path": "/api/external-robots/catalog",
    "auth": "session_csrf",
    "path_template": "/external-robots/catalog",
    "domain": "external-robots"
  },
  "get__external-robots_commands": {
    "operation_id": "get__external-robots_commands",
    "method": "GET",
    "path": "/external-robots/commands",
    "public_path": "/api/external-robots/commands",
    "auth": "session_csrf",
    "path_template": "/external-robots/commands",
    "domain": "external-robots"
  },
  "get__external-robots_executions": {
    "operation_id": "get__external-robots_executions",
    "method": "GET",
    "path": "/external-robots/executions",
    "public_path": "/api/external-robots/executions",
    "auth": "session_csrf",
    "path_template": "/external-robots/executions",
    "domain": "external-robots"
  },
  "post__external-robots_ingest_bridge_heartbeat": {
    "operation_id": "post__external-robots_ingest_bridge_heartbeat",
    "method": "POST",
    "path": "/external-robots/ingest/bridge/heartbeat",
    "public_path": "/api/external-robots/ingest/bridge/heartbeat",
    "auth": "session_csrf",
    "path_template": "/external-robots/ingest/bridge/heartbeat",
    "domain": "external-robots"
  },
  "post__external-robots_ingest_intents_ack": {
    "operation_id": "post__external-robots_ingest_intents_ack",
    "method": "POST",
    "path": "/external-robots/ingest/intents/ack",
    "public_path": "/api/external-robots/ingest/intents/ack",
    "auth": "session_csrf",
    "path_template": "/external-robots/ingest/intents/ack",
    "domain": "external-robots"
  },
  "post__external-robots_ingest_intents_claim": {
    "operation_id": "post__external-robots_ingest_intents_claim",
    "method": "POST",
    "path": "/external-robots/ingest/intents/claim",
    "public_path": "/api/external-robots/ingest/intents/claim",
    "auth": "session_csrf",
    "path_template": "/external-robots/ingest/intents/claim",
    "domain": "external-robots"
  },
  "post__external-robots_ingest_intents_progress": {
    "operation_id": "post__external-robots_ingest_intents_progress",
    "method": "POST",
    "path": "/external-robots/ingest/intents/progress",
    "public_path": "/api/external-robots/ingest/intents/progress",
    "auth": "session_csrf",
    "path_template": "/external-robots/ingest/intents/progress",
    "domain": "external-robots"
  },
  "post__external-robots_ingest_telemetry": {
    "operation_id": "post__external-robots_ingest_telemetry",
    "method": "POST",
    "path": "/external-robots/ingest/telemetry",
    "public_path": "/api/external-robots/ingest/telemetry",
    "auth": "session_csrf",
    "path_template": "/external-robots/ingest/telemetry",
    "domain": "external-robots"
  },
  "get__external-robots_integrations": {
    "operation_id": "get__external-robots_integrations",
    "method": "GET",
    "path": "/external-robots/integrations",
    "public_path": "/api/external-robots/integrations",
    "auth": "session_csrf",
    "path_template": "/external-robots/integrations",
    "domain": "external-robots"
  },
  "post__external-robots_integrations": {
    "operation_id": "post__external-robots_integrations",
    "method": "POST",
    "path": "/external-robots/integrations",
    "public_path": "/api/external-robots/integrations",
    "auth": "session_csrf",
    "path_template": "/external-robots/integrations",
    "domain": "external-robots"
  },
  "get__external-robots_intents": {
    "operation_id": "get__external-robots_intents",
    "method": "GET",
    "path": "/external-robots/intents",
    "public_path": "/api/external-robots/intents",
    "auth": "session_csrf",
    "path_template": "/external-robots/intents",
    "domain": "external-robots"
  },
  "post__external-robots_intents": {
    "operation_id": "post__external-robots_intents",
    "method": "POST",
    "path": "/external-robots/intents",
    "public_path": "/api/external-robots/intents",
    "auth": "session_csrf",
    "path_template": "/external-robots/intents",
    "domain": "external-robots"
  },
  "post__external-robots_intents_plan": {
    "operation_id": "post__external-robots_intents_plan",
    "method": "POST",
    "path": "/external-robots/intents/plan",
    "public_path": "/api/external-robots/intents/plan",
    "auth": "session_csrf",
    "path_template": "/external-robots/intents/plan",
    "domain": "external-robots"
  },
  "post__external-robots_intents_p_cancel": {
    "operation_id": "post__external-robots_intents_p_cancel",
    "method": "POST",
    "path": "/external-robots/intents/{intent_id}/cancel",
    "public_path": "/api/external-robots/intents/{intent_id}/cancel",
    "auth": "session_csrf",
    "path_template": "/external-robots/intents/{param}/cancel",
    "domain": "external-robots"
  },
  "get__external-robots_status": {
    "operation_id": "get__external-robots_status",
    "method": "GET",
    "path": "/external-robots/status",
    "public_path": "/api/external-robots/status",
    "auth": "session_csrf",
    "path_template": "/external-robots/status",
    "domain": "external-robots"
  },
  "get__external-robots_units": {
    "operation_id": "get__external-robots_units",
    "method": "GET",
    "path": "/external-robots/units",
    "public_path": "/api/external-robots/units",
    "auth": "session_csrf",
    "path_template": "/external-robots/units",
    "domain": "external-robots"
  },
  "post__external-robots_units": {
    "operation_id": "post__external-robots_units",
    "method": "POST",
    "path": "/external-robots/units",
    "public_path": "/api/external-robots/units",
    "auth": "session_csrf",
    "path_template": "/external-robots/units",
    "domain": "external-robots"
  },
  "put__external-robots_units_p_companion": {
    "operation_id": "put__external-robots_units_p_companion",
    "method": "PUT",
    "path": "/external-robots/units/{unit_id}/companion",
    "public_path": "/api/external-robots/units/{unit_id}/companion",
    "auth": "session_csrf",
    "path_template": "/external-robots/units/{param}/companion",
    "domain": "external-robots"
  },
  "get__factory_devices": {
    "operation_id": "get__factory_devices",
    "method": "GET",
    "path": "/factory/devices",
    "public_path": "/api/factory/devices",
    "auth": "factory",
    "path_template": "/factory/devices",
    "domain": "factory"
  },
  "post__factory_devices": {
    "operation_id": "post__factory_devices",
    "method": "POST",
    "path": "/factory/devices",
    "public_path": "/api/factory/devices",
    "auth": "factory",
    "path_template": "/factory/devices",
    "domain": "factory"
  },
  "post__factory_devices_p_block": {
    "operation_id": "post__factory_devices_p_block",
    "method": "POST",
    "path": "/factory/devices/{serial}/block",
    "public_path": "/api/factory/devices/{serial}/block",
    "auth": "factory",
    "path_template": "/factory/devices/{param}/block",
    "domain": "factory"
  },
  "get__factory_ping": {
    "operation_id": "get__factory_ping",
    "method": "GET",
    "path": "/factory/ping",
    "public_path": "/api/factory/ping",
    "auth": "factory",
    "path_template": "/factory/ping",
    "domain": "factory"
  },
  "get__factory_status": {
    "operation_id": "get__factory_status",
    "method": "GET",
    "path": "/factory/status",
    "public_path": "/api/factory/status",
    "auth": "factory",
    "path_template": "/factory/status",
    "domain": "factory"
  },
  "post__federation_consent": {
    "operation_id": "post__federation_consent",
    "method": "POST",
    "path": "/federation/consent",
    "public_path": "/api/federation/consent",
    "auth": "session_csrf",
    "path_template": "/federation/consent",
    "domain": "federation"
  },
  "get__federation_metrics": {
    "operation_id": "get__federation_metrics",
    "method": "GET",
    "path": "/federation/metrics",
    "public_path": "/api/federation/metrics",
    "auth": "session_csrf",
    "path_template": "/federation/metrics",
    "domain": "federation"
  },
  "get__federation_tenants": {
    "operation_id": "get__federation_tenants",
    "method": "GET",
    "path": "/federation/tenants",
    "public_path": "/api/federation/tenants",
    "auth": "session_csrf",
    "path_template": "/federation/tenants",
    "domain": "federation"
  },
  "get__fleet_device_status": {
    "operation_id": "get__fleet_device_status",
    "method": "GET",
    "path": "/fleet/device/status",
    "public_path": "/api/fleet/device/status",
    "auth": "session_csrf",
    "path_template": "/fleet/device/status",
    "domain": "fleet"
  },
  "get__fleet_diagnose_status": {
    "operation_id": "get__fleet_diagnose_status",
    "method": "GET",
    "path": "/fleet/diagnose/status",
    "public_path": "/api/fleet/diagnose/status",
    "auth": "session_csrf",
    "path_template": "/fleet/diagnose/status",
    "domain": "fleet"
  },
  "get__fleet_group_status": {
    "operation_id": "get__fleet_group_status",
    "method": "GET",
    "path": "/fleet/group/status",
    "public_path": "/api/fleet/group/status",
    "auth": "session_csrf",
    "path_template": "/fleet/group/status",
    "domain": "fleet"
  },
  "get__fleet_groups_status": {
    "operation_id": "get__fleet_groups_status",
    "method": "GET",
    "path": "/fleet/groups/status",
    "public_path": "/api/fleet/groups/status",
    "auth": "session_csrf",
    "path_template": "/fleet/groups/status",
    "domain": "fleet"
  },
  "get__fleet_health_status": {
    "operation_id": "get__fleet_health_status",
    "method": "GET",
    "path": "/fleet/health/status",
    "public_path": "/api/fleet/health/status",
    "auth": "session_csrf",
    "path_template": "/fleet/health/status",
    "domain": "fleet"
  },
  "get__fleet_status": {
    "operation_id": "get__fleet_status",
    "method": "GET",
    "path": "/fleet/status",
    "public_path": "/api/fleet/status",
    "auth": "session_csrf",
    "path_template": "/fleet/status",
    "domain": "fleet"
  },
  "get__fleet_zones_status": {
    "operation_id": "get__fleet_zones_status",
    "method": "GET",
    "path": "/fleet/zones/status",
    "public_path": "/api/fleet/zones/status",
    "auth": "session_csrf",
    "path_template": "/fleet/zones/status",
    "domain": "fleet"
  },
  "get__group-cards_capabilities": {
    "operation_id": "get__group-cards_capabilities",
    "method": "GET",
    "path": "/group-cards/capabilities",
    "public_path": "/api/group-cards/capabilities",
    "auth": "session_csrf",
    "path_template": "/group-cards/capabilities",
    "domain": "group-cards"
  },
  "get__group-cards_settings": {
    "operation_id": "get__group-cards_settings",
    "method": "GET",
    "path": "/group-cards/settings",
    "public_path": "/api/group-cards/settings",
    "auth": "session_csrf",
    "path_template": "/group-cards/settings",
    "domain": "group-cards"
  },
  "delete__group-cards_p": {
    "operation_id": "delete__group-cards_p",
    "method": "DELETE",
    "path": "/group-cards/{group_key}",
    "public_path": "/api/group-cards/{group_key}",
    "auth": "session_csrf",
    "path_template": "/group-cards/{param}",
    "domain": "group-cards"
  },
  "post__group-cards_p_apply": {
    "operation_id": "post__group-cards_p_apply",
    "method": "POST",
    "path": "/group-cards/{group_key}/apply",
    "public_path": "/api/group-cards/{group_key}/apply",
    "auth": "session_csrf",
    "path_template": "/group-cards/{param}/apply",
    "domain": "group-cards"
  },
  "post__group-cards_p_delete": {
    "operation_id": "post__group-cards_p_delete",
    "method": "POST",
    "path": "/group-cards/{group_key}/delete",
    "public_path": "/api/group-cards/{group_key}/delete",
    "auth": "session_csrf",
    "path_template": "/group-cards/{param}/delete",
    "domain": "group-cards"
  },
  "get__group-cards_p_settings": {
    "operation_id": "get__group-cards_p_settings",
    "method": "GET",
    "path": "/group-cards/{group_key}/settings",
    "public_path": "/api/group-cards/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/group-cards/{param}/settings",
    "domain": "group-cards"
  },
  "put__group-cards_p_settings": {
    "operation_id": "put__group-cards_p_settings",
    "method": "PUT",
    "path": "/group-cards/{group_key}/settings",
    "public_path": "/api/group-cards/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/group-cards/{param}/settings",
    "domain": "group-cards"
  },
  "get__groups_v1_shares": {
    "operation_id": "get__groups_v1_shares",
    "method": "GET",
    "path": "/groups/v1/shares",
    "public_path": "/api/groups/v1/shares",
    "auth": "session_csrf",
    "path_template": "/groups/v1/shares",
    "domain": "groups"
  },
  "put__groups_v1_shares": {
    "operation_id": "put__groups_v1_shares",
    "method": "PUT",
    "path": "/groups/v1/shares",
    "public_path": "/api/groups/v1/shares",
    "auth": "session_csrf",
    "path_template": "/groups/v1/shares",
    "domain": "groups"
  },
  "post__groups_v1_shares_bulk-revoke": {
    "operation_id": "post__groups_v1_shares_bulk-revoke",
    "method": "POST",
    "path": "/groups/v1/shares/bulk-revoke",
    "public_path": "/api/groups/v1/shares/bulk-revoke",
    "auth": "session_csrf",
    "path_template": "/groups/v1/shares/bulk-revoke",
    "domain": "groups"
  },
  "delete__groups_v1_p": {
    "operation_id": "delete__groups_v1_p",
    "method": "DELETE",
    "path": "/groups/v1/{group_key}",
    "public_path": "/api/groups/v1/{group_key}",
    "auth": "session_csrf",
    "path_template": "/groups/v1/{param}",
    "domain": "groups"
  },
  "post__groups_v1_p_apply": {
    "operation_id": "post__groups_v1_p_apply",
    "method": "POST",
    "path": "/groups/v1/{group_key}/apply",
    "public_path": "/api/groups/v1/{group_key}/apply",
    "auth": "session_csrf",
    "path_template": "/groups/v1/{param}/apply",
    "domain": "groups"
  },
  "get__groups_v1_p_settings": {
    "operation_id": "get__groups_v1_p_settings",
    "method": "GET",
    "path": "/groups/v1/{group_key}/settings",
    "public_path": "/api/groups/v1/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/groups/v1/{param}/settings",
    "domain": "groups"
  },
  "put__groups_v1_p_settings": {
    "operation_id": "put__groups_v1_p_settings",
    "method": "PUT",
    "path": "/groups/v1/{group_key}/settings",
    "public_path": "/api/groups/v1/{group_key}/settings",
    "auth": "session_csrf",
    "path_template": "/groups/v1/{param}/settings",
    "domain": "groups"
  },
  "get__health": {
    "operation_id": "get__health",
    "method": "GET",
    "path": "/health",
    "public_path": "/api/health",
    "auth": "none",
    "path_template": "/health",
    "domain": "health"
  },
  "get__health_alerts": {
    "operation_id": "get__health_alerts",
    "method": "GET",
    "path": "/health/alerts",
    "public_path": "/api/health/alerts",
    "auth": "session_csrf",
    "path_template": "/health/alerts",
    "domain": "health"
  },
  "get__health_status": {
    "operation_id": "get__health_status",
    "method": "GET",
    "path": "/health/status",
    "public_path": "/api/health/status",
    "auth": "session_csrf",
    "path_template": "/health/status",
    "domain": "health"
  },
  "get__incidents": {
    "operation_id": "get__incidents",
    "method": "GET",
    "path": "/incidents",
    "public_path": "/api/incidents",
    "auth": "session_csrf",
    "path_template": "/incidents",
    "domain": "incidents"
  },
  "get__incidents_p": {
    "operation_id": "get__incidents_p",
    "method": "GET",
    "path": "/incidents/{incident_id}",
    "public_path": "/api/incidents/{incident_id}",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}",
    "domain": "incidents"
  },
  "get__incidents_p_cell": {
    "operation_id": "get__incidents_p_cell",
    "method": "GET",
    "path": "/incidents/{incident_id}/cell",
    "public_path": "/api/incidents/{incident_id}/cell",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cell",
    "domain": "incidents"
  },
  "post__incidents_p_cell_activate": {
    "operation_id": "post__incidents_p_cell_activate",
    "method": "POST",
    "path": "/incidents/{incident_id}/cell/activate",
    "public_path": "/api/incidents/{incident_id}/cell/activate",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cell/activate",
    "domain": "incidents"
  },
  "post__incidents_p_cell_resolve": {
    "operation_id": "post__incidents_p_cell_resolve",
    "method": "POST",
    "path": "/incidents/{incident_id}/cell/resolve",
    "public_path": "/api/incidents/{incident_id}/cell/resolve",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cell/resolve",
    "domain": "incidents"
  },
  "get__incidents_p_cluster": {
    "operation_id": "get__incidents_p_cluster",
    "method": "GET",
    "path": "/incidents/{incident_id}/cluster",
    "public_path": "/api/incidents/{incident_id}/cluster",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster",
    "domain": "incidents"
  },
  "get__incidents_p_cluster_affinity": {
    "operation_id": "get__incidents_p_cluster_affinity",
    "method": "GET",
    "path": "/incidents/{incident_id}/cluster/affinity",
    "public_path": "/api/incidents/{incident_id}/cluster/affinity",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster/affinity",
    "domain": "incidents"
  },
  "post__incidents_p_cluster_join": {
    "operation_id": "post__incidents_p_cluster_join",
    "method": "POST",
    "path": "/incidents/{incident_id}/cluster/join",
    "public_path": "/api/incidents/{incident_id}/cluster/join",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster/join",
    "domain": "incidents"
  },
  "post__incidents_p_cluster_leave": {
    "operation_id": "post__incidents_p_cluster_leave",
    "method": "POST",
    "path": "/incidents/{incident_id}/cluster/leave",
    "public_path": "/api/incidents/{incident_id}/cluster/leave",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster/leave",
    "domain": "incidents"
  },
  "patch__incidents_p_cluster_priority": {
    "operation_id": "patch__incidents_p_cluster_priority",
    "method": "PATCH",
    "path": "/incidents/{incident_id}/cluster/priority",
    "public_path": "/api/incidents/{incident_id}/cluster/priority",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster/priority",
    "domain": "incidents"
  },
  "post__incidents_p_cluster_reallocate": {
    "operation_id": "post__incidents_p_cluster_reallocate",
    "method": "POST",
    "path": "/incidents/{incident_id}/cluster/reallocate",
    "public_path": "/api/incidents/{incident_id}/cluster/reallocate",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/cluster/reallocate",
    "domain": "incidents"
  },
  "post__incidents_p_command_assign": {
    "operation_id": "post__incidents_p_command_assign",
    "method": "POST",
    "path": "/incidents/{incident_id}/command/assign",
    "public_path": "/api/incidents/{incident_id}/command/assign",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/command/assign",
    "domain": "incidents"
  },
  "post__incidents_p_command_handoff": {
    "operation_id": "post__incidents_p_command_handoff",
    "method": "POST",
    "path": "/incidents/{incident_id}/command/handoff",
    "public_path": "/api/incidents/{incident_id}/command/handoff",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/command/handoff",
    "domain": "incidents"
  },
  "post__incidents_p_command_override": {
    "operation_id": "post__incidents_p_command_override",
    "method": "POST",
    "path": "/incidents/{incident_id}/command/override",
    "public_path": "/api/incidents/{incident_id}/command/override",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/command/override",
    "domain": "incidents"
  },
  "get__incidents_p_evidence": {
    "operation_id": "get__incidents_p_evidence",
    "method": "GET",
    "path": "/incidents/{incident_id}/evidence",
    "public_path": "/api/incidents/{incident_id}/evidence",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence",
    "domain": "incidents"
  },
  "post__incidents_p_evidence": {
    "operation_id": "post__incidents_p_evidence",
    "method": "POST",
    "path": "/incidents/{incident_id}/evidence",
    "public_path": "/api/incidents/{incident_id}/evidence",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence",
    "domain": "incidents"
  },
  "post__incidents_p_evidence_hold": {
    "operation_id": "post__incidents_p_evidence_hold",
    "method": "POST",
    "path": "/incidents/{incident_id}/evidence/hold",
    "public_path": "/api/incidents/{incident_id}/evidence/hold",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence/hold",
    "domain": "incidents"
  },
  "get__incidents_p_evidence_index": {
    "operation_id": "get__incidents_p_evidence_index",
    "method": "GET",
    "path": "/incidents/{incident_id}/evidence/index",
    "public_path": "/api/incidents/{incident_id}/evidence/index",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence/index",
    "domain": "incidents"
  },
  "post__incidents_p_evidence_local-export": {
    "operation_id": "post__incidents_p_evidence_local-export",
    "method": "POST",
    "path": "/incidents/{incident_id}/evidence/local-export",
    "public_path": "/api/incidents/{incident_id}/evidence/local-export",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence/local-export",
    "domain": "incidents"
  },
  "post__incidents_p_evidence_release": {
    "operation_id": "post__incidents_p_evidence_release",
    "method": "POST",
    "path": "/incidents/{incident_id}/evidence/release",
    "public_path": "/api/incidents/{incident_id}/evidence/release",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/evidence/release",
    "domain": "incidents"
  },
  "get__incidents_p_proof-of-response": {
    "operation_id": "get__incidents_p_proof-of-response",
    "method": "GET",
    "path": "/incidents/{incident_id}/proof-of-response",
    "public_path": "/api/incidents/{incident_id}/proof-of-response",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/proof-of-response",
    "domain": "incidents"
  },
  "get__incidents_p_review": {
    "operation_id": "get__incidents_p_review",
    "method": "GET",
    "path": "/incidents/{incident_id}/review",
    "public_path": "/api/incidents/{incident_id}/review",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/review",
    "domain": "incidents"
  },
  "put__incidents_p_review": {
    "operation_id": "put__incidents_p_review",
    "method": "PUT",
    "path": "/incidents/{incident_id}/review",
    "public_path": "/api/incidents/{incident_id}/review",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/review",
    "domain": "incidents"
  },
  "get__incidents_p_sla": {
    "operation_id": "get__incidents_p_sla",
    "method": "GET",
    "path": "/incidents/{incident_id}/sla",
    "public_path": "/api/incidents/{incident_id}/sla",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/sla",
    "domain": "incidents"
  },
  "get__incidents_p_stigmergy": {
    "operation_id": "get__incidents_p_stigmergy",
    "method": "GET",
    "path": "/incidents/{incident_id}/stigmergy",
    "public_path": "/api/incidents/{incident_id}/stigmergy",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/stigmergy",
    "domain": "incidents"
  },
  "post__incidents_p_stigmergy": {
    "operation_id": "post__incidents_p_stigmergy",
    "method": "POST",
    "path": "/incidents/{incident_id}/stigmergy",
    "public_path": "/api/incidents/{incident_id}/stigmergy",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/stigmergy",
    "domain": "incidents"
  },
  "get__incidents_p_swarm-audit": {
    "operation_id": "get__incidents_p_swarm-audit",
    "method": "GET",
    "path": "/incidents/{incident_id}/swarm-audit",
    "public_path": "/api/incidents/{incident_id}/swarm-audit",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/swarm-audit",
    "domain": "incidents"
  },
  "get__incidents_p_timeline": {
    "operation_id": "get__incidents_p_timeline",
    "method": "GET",
    "path": "/incidents/{incident_id}/timeline",
    "public_path": "/api/incidents/{incident_id}/timeline",
    "auth": "session_csrf",
    "path_template": "/incidents/{param}/timeline",
    "domain": "incidents"
  },
  "post__integrations_telegram_webhook": {
    "operation_id": "post__integrations_telegram_webhook",
    "method": "POST",
    "path": "/integrations/telegram/webhook",
    "public_path": "/api/integrations/telegram/webhook",
    "auth": "session_csrf",
    "path_template": "/integrations/telegram/webhook",
    "domain": "integrations"
  },
  "get__intel_status": {
    "operation_id": "get__intel_status",
    "method": "GET",
    "path": "/intel/status",
    "public_path": "/api/intel/status",
    "auth": "session_csrf",
    "path_template": "/intel/status",
    "domain": "intel"
  },
  "post__internal_udock_mtx-auth": {
    "operation_id": "post__internal_udock_mtx-auth",
    "method": "POST",
    "path": "/internal/udock/mtx-auth",
    "public_path": "/api/internal/udock/mtx-auth",
    "auth": "session_csrf",
    "path_template": "/internal/udock/mtx-auth",
    "domain": "internal"
  },
  "get__live-quota_me": {
    "operation_id": "get__live-quota_me",
    "method": "GET",
    "path": "/live-quota/me",
    "public_path": "/api/live-quota/me",
    "auth": "session_csrf",
    "path_template": "/live-quota/me",
    "domain": "live-quota"
  },
  "post__locations_batch": {
    "operation_id": "post__locations_batch",
    "method": "POST",
    "path": "/locations/batch",
    "public_path": "/api/locations/batch",
    "auth": "session_csrf",
    "path_template": "/locations/batch",
    "domain": "locations"
  },
  "delete__locations_consent": {
    "operation_id": "delete__locations_consent",
    "method": "DELETE",
    "path": "/locations/consent",
    "public_path": "/api/locations/consent",
    "auth": "session_csrf",
    "path_template": "/locations/consent",
    "domain": "locations"
  },
  "post__locations_consent": {
    "operation_id": "post__locations_consent",
    "method": "POST",
    "path": "/locations/consent",
    "public_path": "/api/locations/consent",
    "auth": "session_csrf",
    "path_template": "/locations/consent",
    "domain": "locations"
  },
  "get__locations_consents": {
    "operation_id": "get__locations_consents",
    "method": "GET",
    "path": "/locations/consents",
    "public_path": "/api/locations/consents",
    "auth": "session_csrf",
    "path_template": "/locations/consents",
    "domain": "locations"
  },
  "get__locations_history": {
    "operation_id": "get__locations_history",
    "method": "GET",
    "path": "/locations/history",
    "public_path": "/api/locations/history",
    "auth": "session_csrf",
    "path_template": "/locations/history",
    "domain": "locations"
  },
  "get__locations_latest": {
    "operation_id": "get__locations_latest",
    "method": "GET",
    "path": "/locations/latest",
    "public_path": "/api/locations/latest",
    "auth": "session_csrf",
    "path_template": "/locations/latest",
    "domain": "locations"
  },
  "delete__locations_me": {
    "operation_id": "delete__locations_me",
    "method": "DELETE",
    "path": "/locations/me",
    "public_path": "/api/locations/me",
    "auth": "session_csrf",
    "path_template": "/locations/me",
    "domain": "locations"
  },
  "get__locations_on-call": {
    "operation_id": "get__locations_on-call",
    "method": "GET",
    "path": "/locations/on-call",
    "public_path": "/api/locations/on-call",
    "auth": "session_csrf",
    "path_template": "/locations/on-call",
    "domain": "locations"
  },
  "put__locations_on-call": {
    "operation_id": "put__locations_on-call",
    "method": "PUT",
    "path": "/locations/on-call",
    "public_path": "/api/locations/on-call",
    "auth": "session_csrf",
    "path_template": "/locations/on-call",
    "domain": "locations"
  },
  "get__locations_stream": {
    "operation_id": "get__locations_stream",
    "method": "GET",
    "path": "/locations/stream",
    "public_path": "/api/locations/stream",
    "auth": "session_csrf",
    "path_template": "/locations/stream",
    "domain": "locations"
  },
  "get__logs_file": {
    "operation_id": "get__logs_file",
    "method": "GET",
    "path": "/logs/file",
    "public_path": "/api/logs/file",
    "auth": "session_csrf",
    "path_template": "/logs/file",
    "domain": "logs"
  },
  "get__logs_messages": {
    "operation_id": "get__logs_messages",
    "method": "GET",
    "path": "/logs/messages",
    "public_path": "/api/logs/messages",
    "auth": "session_csrf",
    "path_template": "/logs/messages",
    "domain": "logs"
  },
  "get__machine_status": {
    "operation_id": "get__machine_status",
    "method": "GET",
    "path": "/machine/status",
    "public_path": "/api/machine/status",
    "auth": "session_csrf",
    "path_template": "/machine/status",
    "domain": "machine"
  },
  "post__map_preview-subscriptions": {
    "operation_id": "post__map_preview-subscriptions",
    "method": "POST",
    "path": "/map/preview-subscriptions",
    "public_path": "/api/map/preview-subscriptions",
    "auth": "session_csrf",
    "path_template": "/map/preview-subscriptions",
    "domain": "map"
  },
  "delete__map_preview-subscriptions_p": {
    "operation_id": "delete__map_preview-subscriptions_p",
    "method": "DELETE",
    "path": "/map/preview-subscriptions/{sub_id}",
    "public_path": "/api/map/preview-subscriptions/{sub_id}",
    "auth": "session_csrf",
    "path_template": "/map/preview-subscriptions/{param}",
    "domain": "map"
  },
  "get__metrics": {
    "operation_id": "get__metrics",
    "method": "GET",
    "path": "/metrics",
    "public_path": "/api/metrics",
    "auth": "bearer_optional",
    "path_template": "/metrics",
    "domain": "metrics"
  },
  "delete__notification-groups_p": {
    "operation_id": "delete__notification-groups_p",
    "method": "DELETE",
    "path": "/notification-groups/{group_key}",
    "public_path": "/api/notification-groups/{group_key}",
    "auth": "session_csrf",
    "path_template": "/notification-groups/{param}",
    "domain": "notification-groups"
  },
  "post__notification-groups_p_delete": {
    "operation_id": "post__notification-groups_p_delete",
    "method": "POST",
    "path": "/notification-groups/{group_key}/delete",
    "public_path": "/api/notification-groups/{group_key}/delete",
    "auth": "session_csrf",
    "path_template": "/notification-groups/{param}/delete",
    "domain": "notification-groups"
  },
  "get__openapi.json": {
    "operation_id": "get__openapi.json",
    "method": "GET",
    "path": "/openapi.json",
    "public_path": "/api/openapi.json",
    "auth": "none",
    "path_template": "/openapi.json",
    "domain": "openapi.json"
  },
  "head__openapi.json": {
    "operation_id": "head__openapi.json",
    "method": "HEAD",
    "path": "/openapi.json",
    "public_path": "/api/openapi.json",
    "auth": "none",
    "path_template": "/openapi.json",
    "domain": "openapi.json"
  },
  "get__ops_ai_status": {
    "operation_id": "get__ops_ai_status",
    "method": "GET",
    "path": "/ops/ai/status",
    "public_path": "/api/ops/ai/status",
    "auth": "session_csrf",
    "path_template": "/ops/ai/status",
    "domain": "ops"
  },
  "get__ops_alarms_status": {
    "operation_id": "get__ops_alarms_status",
    "method": "GET",
    "path": "/ops/alarms/status",
    "public_path": "/api/ops/alarms/status",
    "auth": "session_csrf",
    "path_template": "/ops/alarms/status",
    "domain": "ops"
  },
  "get__ops_cameras_frames": {
    "operation_id": "get__ops_cameras_frames",
    "method": "GET",
    "path": "/ops/cameras/frames",
    "public_path": "/api/ops/cameras/frames",
    "auth": "session_csrf",
    "path_template": "/ops/cameras/frames",
    "domain": "ops"
  },
  "get__ops_cameras_frames_p_image": {
    "operation_id": "get__ops_cameras_frames_p_image",
    "method": "GET",
    "path": "/ops/cameras/frames/{snapshot_id}/image",
    "public_path": "/api/ops/cameras/frames/{snapshot_id}/image",
    "auth": "session_csrf",
    "path_template": "/ops/cameras/frames/{param}/image",
    "domain": "ops"
  },
  "get__ops_cameras_status": {
    "operation_id": "get__ops_cameras_status",
    "method": "GET",
    "path": "/ops/cameras/status",
    "public_path": "/api/ops/cameras/status",
    "auth": "session_csrf",
    "path_template": "/ops/cameras/status",
    "domain": "ops"
  },
  "get__ops_devices_status": {
    "operation_id": "get__ops_devices_status",
    "method": "GET",
    "path": "/ops/devices/status",
    "public_path": "/api/ops/devices/status",
    "auth": "session_csrf",
    "path_template": "/ops/devices/status",
    "domain": "ops"
  },
  "get__ops_dispatch_status": {
    "operation_id": "get__ops_dispatch_status",
    "method": "GET",
    "path": "/ops/dispatch/status",
    "public_path": "/api/ops/dispatch/status",
    "auth": "session_csrf",
    "path_template": "/ops/dispatch/status",
    "domain": "ops"
  },
  "get__ops_hw_status": {
    "operation_id": "get__ops_hw_status",
    "method": "GET",
    "path": "/ops/hw/status",
    "public_path": "/api/ops/hw/status",
    "auth": "session_csrf",
    "path_template": "/ops/hw/status",
    "domain": "ops"
  },
  "get__ops_map_status": {
    "operation_id": "get__ops_map_status",
    "method": "GET",
    "path": "/ops/map/status",
    "public_path": "/api/ops/map/status",
    "auth": "session_csrf",
    "path_template": "/ops/map/status",
    "domain": "ops"
  },
  "get__ops_overview_status": {
    "operation_id": "get__ops_overview_status",
    "method": "GET",
    "path": "/ops/overview/status",
    "public_path": "/api/ops/overview/status",
    "auth": "session_csrf",
    "path_template": "/ops/overview/status",
    "domain": "ops"
  },
  "get__ops_person_status": {
    "operation_id": "get__ops_person_status",
    "method": "GET",
    "path": "/ops/person/status",
    "public_path": "/api/ops/person/status",
    "auth": "session_csrf",
    "path_template": "/ops/person/status",
    "domain": "ops"
  },
  "post__ops_reproduction_canary_start": {
    "operation_id": "post__ops_reproduction_canary_start",
    "method": "POST",
    "path": "/ops/reproduction/canary/start",
    "public_path": "/api/ops/reproduction/canary/start",
    "auth": "session_csrf",
    "path_template": "/ops/reproduction/canary/start",
    "domain": "ops"
  },
  "post__ops_reproduction_probes_isolation": {
    "operation_id": "post__ops_reproduction_probes_isolation",
    "method": "POST",
    "path": "/ops/reproduction/probes/isolation",
    "public_path": "/api/ops/reproduction/probes/isolation",
    "auth": "session_csrf",
    "path_template": "/ops/reproduction/probes/isolation",
    "domain": "ops"
  },
  "post__ops_reproduction_probes_r3-sim-observation": {
    "operation_id": "post__ops_reproduction_probes_r3-sim-observation",
    "method": "POST",
    "path": "/ops/reproduction/probes/r3-sim-observation",
    "public_path": "/api/ops/reproduction/probes/r3-sim-observation",
    "auth": "session_csrf",
    "path_template": "/ops/reproduction/probes/r3-sim-observation",
    "domain": "ops"
  },
  "post__ops_reproduction_probes_replica-parity": {
    "operation_id": "post__ops_reproduction_probes_replica-parity",
    "method": "POST",
    "path": "/ops/reproduction/probes/replica-parity",
    "public_path": "/api/ops/reproduction/probes/replica-parity",
    "auth": "session_csrf",
    "path_template": "/ops/reproduction/probes/replica-parity",
    "domain": "ops"
  },
  "get__ops_reproduction_status": {
    "operation_id": "get__ops_reproduction_status",
    "method": "GET",
    "path": "/ops/reproduction/status",
    "public_path": "/api/ops/reproduction/status",
    "auth": "session_csrf",
    "path_template": "/ops/reproduction/status",
    "domain": "ops"
  },
  "get__ops_resource-ontology": {
    "operation_id": "get__ops_resource-ontology",
    "method": "GET",
    "path": "/ops/resource-ontology",
    "public_path": "/api/ops/resource-ontology",
    "auth": "session_csrf",
    "path_template": "/ops/resource-ontology",
    "domain": "ops"
  },
  "post__ops_resource-ontology_soak_ping": {
    "operation_id": "post__ops_resource-ontology_soak_ping",
    "method": "POST",
    "path": "/ops/resource-ontology/soak/ping",
    "public_path": "/api/ops/resource-ontology/soak/ping",
    "auth": "session_csrf",
    "path_template": "/ops/resource-ontology/soak/ping",
    "domain": "ops"
  },
  "get__ops_resource-ontology_status": {
    "operation_id": "get__ops_resource-ontology_status",
    "method": "GET",
    "path": "/ops/resource-ontology/status",
    "public_path": "/api/ops/resource-ontology/status",
    "auth": "session_csrf",
    "path_template": "/ops/resource-ontology/status",
    "domain": "ops"
  },
  "get__ops_workbench_status": {
    "operation_id": "get__ops_workbench_status",
    "method": "GET",
    "path": "/ops/workbench/status",
    "public_path": "/api/ops/workbench/status",
    "auth": "session_csrf",
    "path_template": "/ops/workbench/status",
    "domain": "ops"
  },
  "get__ops_zones_status": {
    "operation_id": "get__ops_zones_status",
    "method": "GET",
    "path": "/ops/zones/status",
    "public_path": "/api/ops/zones/status",
    "auth": "session_csrf",
    "path_template": "/ops/zones/status",
    "domain": "ops"
  },
  "post__ota_broadcast": {
    "operation_id": "post__ota_broadcast",
    "method": "POST",
    "path": "/ota/broadcast",
    "public_path": "/api/ota/broadcast",
    "auth": "session_csrf",
    "path_template": "/ota/broadcast",
    "domain": "ota"
  },
  "get__ota_campaigns": {
    "operation_id": "get__ota_campaigns",
    "method": "GET",
    "path": "/ota/campaigns",
    "public_path": "/api/ota/campaigns",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns",
    "domain": "ota"
  },
  "post__ota_campaigns": {
    "operation_id": "post__ota_campaigns",
    "method": "POST",
    "path": "/ota/campaigns",
    "public_path": "/api/ota/campaigns",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns",
    "domain": "ota"
  },
  "post__ota_campaigns_from-stored": {
    "operation_id": "post__ota_campaigns_from-stored",
    "method": "POST",
    "path": "/ota/campaigns/from-stored",
    "public_path": "/api/ota/campaigns/from-stored",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/from-stored",
    "domain": "ota"
  },
  "post__ota_campaigns_from-upload": {
    "operation_id": "post__ota_campaigns_from-upload",
    "method": "POST",
    "path": "/ota/campaigns/from-upload",
    "public_path": "/api/ota/campaigns/from-upload",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/from-upload",
    "domain": "ota"
  },
  "get__ota_campaigns_p": {
    "operation_id": "get__ota_campaigns_p",
    "method": "GET",
    "path": "/ota/campaigns/{campaign_id}",
    "public_path": "/api/ota/campaigns/{campaign_id}",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/{param}",
    "domain": "ota"
  },
  "post__ota_campaigns_p_accept": {
    "operation_id": "post__ota_campaigns_p_accept",
    "method": "POST",
    "path": "/ota/campaigns/{campaign_id}/accept",
    "public_path": "/api/ota/campaigns/{campaign_id}/accept",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/{param}/accept",
    "domain": "ota"
  },
  "post__ota_campaigns_p_cancel": {
    "operation_id": "post__ota_campaigns_p_cancel",
    "method": "POST",
    "path": "/ota/campaigns/{campaign_id}/cancel",
    "public_path": "/api/ota/campaigns/{campaign_id}/cancel",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/{param}/cancel",
    "domain": "ota"
  },
  "post__ota_campaigns_p_decline": {
    "operation_id": "post__ota_campaigns_p_decline",
    "method": "POST",
    "path": "/ota/campaigns/{campaign_id}/decline",
    "public_path": "/api/ota/campaigns/{campaign_id}/decline",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/{param}/decline",
    "domain": "ota"
  },
  "post__ota_campaigns_p_rollback": {
    "operation_id": "post__ota_campaigns_p_rollback",
    "method": "POST",
    "path": "/ota/campaigns/{campaign_id}/rollback",
    "public_path": "/api/ota/campaigns/{campaign_id}/rollback",
    "auth": "session_csrf",
    "path_template": "/ota/campaigns/{param}/rollback",
    "domain": "ota"
  },
  "get__ota_cap-campaigns": {
    "operation_id": "get__ota_cap-campaigns",
    "method": "GET",
    "path": "/ota/cap-campaigns",
    "public_path": "/api/ota/cap-campaigns",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns",
    "domain": "ota"
  },
  "post__ota_cap-campaigns": {
    "operation_id": "post__ota_cap-campaigns",
    "method": "POST",
    "path": "/ota/cap-campaigns",
    "public_path": "/api/ota/cap-campaigns",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns",
    "domain": "ota"
  },
  "get__ota_cap-campaigns_status": {
    "operation_id": "get__ota_cap-campaigns_status",
    "method": "GET",
    "path": "/ota/cap-campaigns/status",
    "public_path": "/api/ota/cap-campaigns/status",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns/status",
    "domain": "ota"
  },
  "get__ota_cap-campaigns_p": {
    "operation_id": "get__ota_cap-campaigns_p",
    "method": "GET",
    "path": "/ota/cap-campaigns/{campaign_id}",
    "public_path": "/api/ota/cap-campaigns/{campaign_id}",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns/{param}",
    "domain": "ota"
  },
  "post__ota_cap-campaigns_p_execute-wave": {
    "operation_id": "post__ota_cap-campaigns_p_execute-wave",
    "method": "POST",
    "path": "/ota/cap-campaigns/{campaign_id}/execute-wave",
    "public_path": "/api/ota/cap-campaigns/{campaign_id}/execute-wave",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns/{param}/execute-wave",
    "domain": "ota"
  },
  "post__ota_cap-campaigns_p_transition": {
    "operation_id": "post__ota_cap-campaigns_p_transition",
    "method": "POST",
    "path": "/ota/cap-campaigns/{campaign_id}/transition",
    "public_path": "/api/ota/cap-campaigns/{campaign_id}/transition",
    "auth": "session_csrf",
    "path_template": "/ota/cap-campaigns/{param}/transition",
    "domain": "ota"
  },
  "get__ota_firmware-reachability": {
    "operation_id": "get__ota_firmware-reachability",
    "method": "GET",
    "path": "/ota/firmware-reachability",
    "public_path": "/api/ota/firmware-reachability",
    "auth": "session_csrf",
    "path_template": "/ota/firmware-reachability",
    "domain": "ota"
  },
  "get__ota_firmware-verify": {
    "operation_id": "get__ota_firmware-verify",
    "method": "GET",
    "path": "/ota/firmware-verify",
    "public_path": "/api/ota/firmware-verify",
    "auth": "session_csrf",
    "path_template": "/ota/firmware-verify",
    "domain": "ota"
  },
  "post__ota_firmware_upload": {
    "operation_id": "post__ota_firmware_upload",
    "method": "POST",
    "path": "/ota/firmware/upload",
    "public_path": "/api/ota/firmware/upload",
    "auth": "session_csrf",
    "path_template": "/ota/firmware/upload",
    "domain": "ota"
  },
  "get__ota_firmwares": {
    "operation_id": "get__ota_firmwares",
    "method": "GET",
    "path": "/ota/firmwares",
    "public_path": "/api/ota/firmwares",
    "auth": "session_csrf",
    "path_template": "/ota/firmwares",
    "domain": "ota"
  },
  "get__ota_policy": {
    "operation_id": "get__ota_policy",
    "method": "GET",
    "path": "/ota/policy",
    "public_path": "/api/ota/policy",
    "auth": "session_csrf",
    "path_template": "/ota/policy",
    "domain": "ota"
  },
  "get__ota_service-check": {
    "operation_id": "get__ota_service-check",
    "method": "GET",
    "path": "/ota/service-check",
    "public_path": "/api/ota/service-check",
    "auth": "session_csrf",
    "path_template": "/ota/service-check",
    "domain": "ota"
  },
  "get__ota_status": {
    "operation_id": "get__ota_status",
    "method": "GET",
    "path": "/ota/status",
    "public_path": "/api/ota/status",
    "auth": "session_csrf",
    "path_template": "/ota/status",
    "domain": "ota"
  },
  "get__personnel": {
    "operation_id": "get__personnel",
    "method": "GET",
    "path": "/personnel",
    "public_path": "/api/personnel",
    "auth": "session_csrf",
    "path_template": "/personnel",
    "domain": "personnel"
  },
  "get__personnel_policy": {
    "operation_id": "get__personnel_policy",
    "method": "GET",
    "path": "/personnel/policy",
    "public_path": "/api/personnel/policy",
    "auth": "session_csrf",
    "path_template": "/personnel/policy",
    "domain": "personnel"
  },
  "patch__personnel_p_crew": {
    "operation_id": "patch__personnel_p_crew",
    "method": "PATCH",
    "path": "/personnel/{username}/crew",
    "public_path": "/api/personnel/{username}/crew",
    "auth": "session_csrf",
    "path_template": "/personnel/{param}/crew",
    "domain": "personnel"
  },
  "patch__personnel_p_profile": {
    "operation_id": "patch__personnel_p_profile",
    "method": "PATCH",
    "path": "/personnel/{username}/profile",
    "public_path": "/api/personnel/{username}/profile",
    "auth": "session_csrf",
    "path_template": "/personnel/{param}/profile",
    "domain": "personnel"
  },
  "get__personnel_p_track": {
    "operation_id": "get__personnel_p_track",
    "method": "GET",
    "path": "/personnel/{username}/track",
    "public_path": "/api/personnel/{username}/track",
    "auth": "session_csrf",
    "path_template": "/personnel/{param}/track",
    "domain": "personnel"
  },
  "get__predictive_maintenance": {
    "operation_id": "get__predictive_maintenance",
    "method": "GET",
    "path": "/predictive/maintenance",
    "public_path": "/api/predictive/maintenance",
    "auth": "session_csrf",
    "path_template": "/predictive/maintenance",
    "domain": "predictive"
  },
  "post__provision_challenge_request": {
    "operation_id": "post__provision_challenge_request",
    "method": "POST",
    "path": "/provision/challenge/request",
    "public_path": "/api/provision/challenge/request",
    "auth": "session_csrf",
    "path_template": "/provision/challenge/request",
    "domain": "provision"
  },
  "post__provision_challenge_verify": {
    "operation_id": "post__provision_challenge_verify",
    "method": "POST",
    "path": "/provision/challenge/verify",
    "public_path": "/api/provision/challenge/verify",
    "auth": "session_csrf",
    "path_template": "/provision/challenge/verify",
    "domain": "provision"
  },
  "post__provision_claim": {
    "operation_id": "post__provision_claim",
    "method": "POST",
    "path": "/provision/claim",
    "public_path": "/api/provision/claim",
    "auth": "session_csrf",
    "path_template": "/provision/claim",
    "domain": "provision"
  },
  "post__provision_identify": {
    "operation_id": "post__provision_identify",
    "method": "POST",
    "path": "/provision/identify",
    "public_path": "/api/provision/identify",
    "auth": "session_csrf",
    "path_template": "/provision/identify",
    "domain": "provision"
  },
  "get__provision_pending": {
    "operation_id": "get__provision_pending",
    "method": "GET",
    "path": "/provision/pending",
    "public_path": "/api/provision/pending",
    "auth": "session_csrf",
    "path_template": "/provision/pending",
    "domain": "provision"
  },
  "get__readiness_gaps": {
    "operation_id": "get__readiness_gaps",
    "method": "GET",
    "path": "/readiness/gaps",
    "public_path": "/api/readiness/gaps",
    "auth": "session_csrf",
    "path_template": "/readiness/gaps",
    "domain": "readiness"
  },
  "get__readiness_score": {
    "operation_id": "get__readiness_score",
    "method": "GET",
    "path": "/readiness/score",
    "public_path": "/api/readiness/score",
    "auth": "session_csrf",
    "path_template": "/readiness/score",
    "domain": "readiness"
  },
  "get__readiness_sites_p_posture": {
    "operation_id": "get__readiness_sites_p_posture",
    "method": "GET",
    "path": "/readiness/sites/{site_id}/posture",
    "public_path": "/api/readiness/sites/{site_id}/posture",
    "auth": "session_csrf",
    "path_template": "/readiness/sites/{param}/posture",
    "domain": "readiness"
  },
  "get__redoc": {
    "operation_id": "get__redoc",
    "method": "GET",
    "path": "/redoc",
    "public_path": "/api/redoc",
    "auth": "none",
    "path_template": "/redoc",
    "domain": "redoc"
  },
  "head__redoc": {
    "operation_id": "head__redoc",
    "method": "HEAD",
    "path": "/redoc",
    "public_path": "/api/redoc",
    "auth": "none",
    "path_template": "/redoc",
    "domain": "redoc"
  },
  "put__resource-fabric_edges_p": {
    "operation_id": "put__resource-fabric_edges_p",
    "method": "PUT",
    "path": "/resource-fabric/edges/{edge_id}",
    "public_path": "/api/resource-fabric/edges/{edge_id}",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/edges/{param}",
    "domain": "resource-fabric"
  },
  "patch__resource-fabric_edges_p_override": {
    "operation_id": "patch__resource-fabric_edges_p_override",
    "method": "PATCH",
    "path": "/resource-fabric/edges/{edge_id}/override",
    "public_path": "/api/resource-fabric/edges/{edge_id}/override",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/edges/{param}/override",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_incidents_p_action-intents": {
    "operation_id": "get__resource-fabric_incidents_p_action-intents",
    "method": "GET",
    "path": "/resource-fabric/incidents/{incident_event_id}/action-intents",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/action-intents",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/action-intents",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_incidents_p_action-intents": {
    "operation_id": "post__resource-fabric_incidents_p_action-intents",
    "method": "POST",
    "path": "/resource-fabric/incidents/{incident_event_id}/action-intents",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/action-intents",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/action-intents",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_incidents_p_action-intents_p_seal": {
    "operation_id": "post__resource-fabric_incidents_p_action-intents_p_seal",
    "method": "POST",
    "path": "/resource-fabric/incidents/{incident_event_id}/action-intents/{intent_id}/seal",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/action-intents/{intent_id}/seal",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/action-intents/{param}/seal",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_incidents_p_actuation-approvals": {
    "operation_id": "post__resource-fabric_incidents_p_actuation-approvals",
    "method": "POST",
    "path": "/resource-fabric/incidents/{incident_event_id}/actuation-approvals",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/actuation-approvals",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/actuation-approvals",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_incidents_p_actuation-gate": {
    "operation_id": "get__resource-fabric_incidents_p_actuation-gate",
    "method": "GET",
    "path": "/resource-fabric/incidents/{incident_event_id}/actuation-gate",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/actuation-gate",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/actuation-gate",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_incidents_p_command-envelopes_p_physical-delivery": {
    "operation_id": "post__resource-fabric_incidents_p_command-envelopes_p_physical-delivery",
    "method": "POST",
    "path": "/resource-fabric/incidents/{incident_event_id}/command-envelopes/{envelope_id}/physical-delivery",
    "public_path": "/api/resource-fabric/incidents/{incident_event_id}/command-envelopes/{envelope_id}/physical-delivery",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/incidents/{param}/command-envelopes/{param}/physical-delivery",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_machines_p_home-site": {
    "operation_id": "post__resource-fabric_machines_p_home-site",
    "method": "POST",
    "path": "/resource-fabric/machines/{device_id}/home-site",
    "public_path": "/api/resource-fabric/machines/{device_id}/home-site",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/machines/{param}/home-site",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_portals_p": {
    "operation_id": "put__resource-fabric_portals_p",
    "method": "PUT",
    "path": "/resource-fabric/portals/{portal_id}",
    "public_path": "/api/resource-fabric/portals/{portal_id}",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/portals/{param}",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_projection": {
    "operation_id": "post__resource-fabric_projection",
    "method": "POST",
    "path": "/resource-fabric/projection",
    "public_path": "/api/resource-fabric/projection",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/projection",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_resources_p_camera-coverage": {
    "operation_id": "put__resource-fabric_resources_p_camera-coverage",
    "method": "PUT",
    "path": "/resource-fabric/resources/{resource_id}/camera-coverage",
    "public_path": "/api/resource-fabric/resources/{resource_id}/camera-coverage",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/resources/{param}/camera-coverage",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_resources_p_capability-commissions": {
    "operation_id": "post__resource-fabric_resources_p_capability-commissions",
    "method": "POST",
    "path": "/resource-fabric/resources/{resource_id}/capability-commissions",
    "public_path": "/api/resource-fabric/resources/{resource_id}/capability-commissions",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/resources/{param}/capability-commissions",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_site-authority_status": {
    "operation_id": "get__resource-fabric_site-authority_status",
    "method": "GET",
    "path": "/resource-fabric/site-authority/status",
    "public_path": "/api/resource-fabric/site-authority/status",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/site-authority/status",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_sites": {
    "operation_id": "get__resource-fabric_sites",
    "method": "GET",
    "path": "/resource-fabric/sites",
    "public_path": "/api/resource-fabric/sites",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites": {
    "operation_id": "post__resource-fabric_sites",
    "method": "POST",
    "path": "/resource-fabric/sites",
    "public_path": "/api/resource-fabric/sites",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_bootstrap": {
    "operation_id": "post__resource-fabric_sites_bootstrap",
    "method": "POST",
    "path": "/resource-fabric/sites/bootstrap",
    "public_path": "/api/resource-fabric/sites/bootstrap",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/bootstrap",
    "domain": "resource-fabric"
  },
  "delete__resource-fabric_sites_p_ai-watches": {
    "operation_id": "delete__resource-fabric_sites_p_ai-watches",
    "method": "DELETE",
    "path": "/resource-fabric/sites/{site_id}/ai-watches",
    "public_path": "/api/resource-fabric/sites/{site_id}/ai-watches",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/ai-watches",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_sites_p_ai-watches": {
    "operation_id": "get__resource-fabric_sites_p_ai-watches",
    "method": "GET",
    "path": "/resource-fabric/sites/{site_id}/ai-watches",
    "public_path": "/api/resource-fabric/sites/{site_id}/ai-watches",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/ai-watches",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_sites_p_ai-watches": {
    "operation_id": "put__resource-fabric_sites_p_ai-watches",
    "method": "PUT",
    "path": "/resource-fabric/sites/{site_id}/ai-watches",
    "public_path": "/api/resource-fabric/sites/{site_id}/ai-watches",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/ai-watches",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_p_default": {
    "operation_id": "post__resource-fabric_sites_p_default",
    "method": "POST",
    "path": "/resource-fabric/sites/{site_id}/default",
    "public_path": "/api/resource-fabric/sites/{site_id}/default",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/default",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_sites_p_dispatch-policy": {
    "operation_id": "get__resource-fabric_sites_p_dispatch-policy",
    "method": "GET",
    "path": "/resource-fabric/sites/{site_id}/dispatch-policy",
    "public_path": "/api/resource-fabric/sites/{site_id}/dispatch-policy",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/dispatch-policy",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_sites_p_dispatch-policy": {
    "operation_id": "put__resource-fabric_sites_p_dispatch-policy",
    "method": "PUT",
    "path": "/resource-fabric/sites/{site_id}/dispatch-policy",
    "public_path": "/api/resource-fabric/sites/{site_id}/dispatch-policy",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/dispatch-policy",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_p_label": {
    "operation_id": "post__resource-fabric_sites_p_label",
    "method": "POST",
    "path": "/resource-fabric/sites/{site_id}/label",
    "public_path": "/api/resource-fabric/sites/{site_id}/label",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/label",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_sites_p_memberships": {
    "operation_id": "get__resource-fabric_sites_p_memberships",
    "method": "GET",
    "path": "/resource-fabric/sites/{site_id}/memberships",
    "public_path": "/api/resource-fabric/sites/{site_id}/memberships",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/memberships",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_p_memberships": {
    "operation_id": "post__resource-fabric_sites_p_memberships",
    "method": "POST",
    "path": "/resource-fabric/sites/{site_id}/memberships",
    "public_path": "/api/resource-fabric/sites/{site_id}/memberships",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/memberships",
    "domain": "resource-fabric"
  },
  "delete__resource-fabric_sites_p_memberships_p": {
    "operation_id": "delete__resource-fabric_sites_p_memberships_p",
    "method": "DELETE",
    "path": "/resource-fabric/sites/{site_id}/memberships/{principal_username}",
    "public_path": "/api/resource-fabric/sites/{site_id}/memberships/{principal_username}",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/memberships/{param}",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_p_reactivate": {
    "operation_id": "post__resource-fabric_sites_p_reactivate",
    "method": "POST",
    "path": "/resource-fabric/sites/{site_id}/reactivate",
    "public_path": "/api/resource-fabric/sites/{site_id}/reactivate",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/reactivate",
    "domain": "resource-fabric"
  },
  "post__resource-fabric_sites_p_retire": {
    "operation_id": "post__resource-fabric_sites_p_retire",
    "method": "POST",
    "path": "/resource-fabric/sites/{site_id}/retire",
    "public_path": "/api/resource-fabric/sites/{site_id}/retire",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/sites/{param}/retire",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_spaces": {
    "operation_id": "get__resource-fabric_spaces",
    "method": "GET",
    "path": "/resource-fabric/spaces",
    "public_path": "/api/resource-fabric/spaces",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/spaces",
    "domain": "resource-fabric"
  },
  "delete__resource-fabric_spaces_p": {
    "operation_id": "delete__resource-fabric_spaces_p",
    "method": "DELETE",
    "path": "/resource-fabric/spaces/{space_id}",
    "public_path": "/api/resource-fabric/spaces/{space_id}",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/spaces/{param}",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_spaces_p": {
    "operation_id": "put__resource-fabric_spaces_p",
    "method": "PUT",
    "path": "/resource-fabric/spaces/{space_id}",
    "public_path": "/api/resource-fabric/spaces/{space_id}",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/spaces/{param}",
    "domain": "resource-fabric"
  },
  "get__resource-fabric_zones_p_dispatch-policy": {
    "operation_id": "get__resource-fabric_zones_p_dispatch-policy",
    "method": "GET",
    "path": "/resource-fabric/zones/{zone_id}/dispatch-policy",
    "public_path": "/api/resource-fabric/zones/{zone_id}/dispatch-policy",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/zones/{param}/dispatch-policy",
    "domain": "resource-fabric"
  },
  "put__resource-fabric_zones_p_dispatch-policy": {
    "operation_id": "put__resource-fabric_zones_p_dispatch-policy",
    "method": "PUT",
    "path": "/resource-fabric/zones/{zone_id}/dispatch-policy",
    "public_path": "/api/resource-fabric/zones/{zone_id}/dispatch-policy",
    "auth": "session_csrf",
    "path_template": "/resource-fabric/zones/{param}/dispatch-policy",
    "domain": "resource-fabric"
  },
  "get__responder-dispatches": {
    "operation_id": "get__responder-dispatches",
    "method": "GET",
    "path": "/responder-dispatches",
    "public_path": "/api/responder-dispatches",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches",
    "domain": "responder-dispatches"
  },
  "post__responder-dispatches": {
    "operation_id": "post__responder-dispatches",
    "method": "POST",
    "path": "/responder-dispatches",
    "public_path": "/api/responder-dispatches",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches",
    "domain": "responder-dispatches"
  },
  "post__responder-dispatches_auto": {
    "operation_id": "post__responder-dispatches_auto",
    "method": "POST",
    "path": "/responder-dispatches/auto",
    "public_path": "/api/responder-dispatches/auto",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/auto",
    "domain": "responder-dispatches"
  },
  "get__responder-dispatches_mine": {
    "operation_id": "get__responder-dispatches_mine",
    "method": "GET",
    "path": "/responder-dispatches/mine",
    "public_path": "/api/responder-dispatches/mine",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/mine",
    "domain": "responder-dispatches"
  },
  "get__responder-dispatches_mine_p": {
    "operation_id": "get__responder-dispatches_mine_p",
    "method": "GET",
    "path": "/responder-dispatches/mine/{dispatch_id}",
    "public_path": "/api/responder-dispatches/mine/{dispatch_id}",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/mine/{param}",
    "domain": "responder-dispatches"
  },
  "post__responder-dispatches_mine_p_transition": {
    "operation_id": "post__responder-dispatches_mine_p_transition",
    "method": "POST",
    "path": "/responder-dispatches/mine/{dispatch_id}/transition",
    "public_path": "/api/responder-dispatches/mine/{dispatch_id}/transition",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/mine/{param}/transition",
    "domain": "responder-dispatches"
  },
  "post__responder-dispatches_preview": {
    "operation_id": "post__responder-dispatches_preview",
    "method": "POST",
    "path": "/responder-dispatches/preview",
    "public_path": "/api/responder-dispatches/preview",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/preview",
    "domain": "responder-dispatches"
  },
  "get__responder-dispatches_p": {
    "operation_id": "get__responder-dispatches_p",
    "method": "GET",
    "path": "/responder-dispatches/{dispatch_id}",
    "public_path": "/api/responder-dispatches/{dispatch_id}",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/{param}",
    "domain": "responder-dispatches"
  },
  "post__responder-dispatches_p_transition": {
    "operation_id": "post__responder-dispatches_p_transition",
    "method": "POST",
    "path": "/responder-dispatches/{dispatch_id}/transition",
    "public_path": "/api/responder-dispatches/{dispatch_id}/transition",
    "auth": "session_csrf",
    "path_template": "/responder-dispatches/{param}/transition",
    "domain": "responder-dispatches"
  },
  "delete__responder-media_consent": {
    "operation_id": "delete__responder-media_consent",
    "method": "DELETE",
    "path": "/responder-media/consent",
    "public_path": "/api/responder-media/consent",
    "auth": "session_csrf",
    "path_template": "/responder-media/consent",
    "domain": "responder-media"
  },
  "post__responder-media_consent": {
    "operation_id": "post__responder-media_consent",
    "method": "POST",
    "path": "/responder-media/consent",
    "public_path": "/api/responder-media/consent",
    "auth": "session_csrf",
    "path_template": "/responder-media/consent",
    "domain": "responder-media"
  },
  "post__responder-media_sessions": {
    "operation_id": "post__responder-media_sessions",
    "method": "POST",
    "path": "/responder-media/sessions",
    "public_path": "/api/responder-media/sessions",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions",
    "domain": "responder-media"
  },
  "get__responder-media_sessions_mine": {
    "operation_id": "get__responder-media_sessions_mine",
    "method": "GET",
    "path": "/responder-media/sessions/mine",
    "public_path": "/api/responder-media/sessions/mine",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions/mine",
    "domain": "responder-media"
  },
  "get__responder-media_sessions_p": {
    "operation_id": "get__responder-media_sessions_p",
    "method": "GET",
    "path": "/responder-media/sessions/{session_id}",
    "public_path": "/api/responder-media/sessions/{session_id}",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions/{param}",
    "domain": "responder-media"
  },
  "post__responder-media_sessions_p_close": {
    "operation_id": "post__responder-media_sessions_p_close",
    "method": "POST",
    "path": "/responder-media/sessions/{session_id}/close",
    "public_path": "/api/responder-media/sessions/{session_id}/close",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions/{param}/close",
    "domain": "responder-media"
  },
  "post__responder-media_sessions_p_heartbeat": {
    "operation_id": "post__responder-media_sessions_p_heartbeat",
    "method": "POST",
    "path": "/responder-media/sessions/{session_id}/heartbeat",
    "public_path": "/api/responder-media/sessions/{session_id}/heartbeat",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions/{param}/heartbeat",
    "domain": "responder-media"
  },
  "post__responder-media_sessions_p_view-ticket": {
    "operation_id": "post__responder-media_sessions_p_view-ticket",
    "method": "POST",
    "path": "/responder-media/sessions/{session_id}/view-ticket",
    "public_path": "/api/responder-media/sessions/{session_id}/view-ticket",
    "auth": "session_csrf",
    "path_template": "/responder-media/sessions/{param}/view-ticket",
    "domain": "responder-media"
  },
  "get__response_assign_status": {
    "operation_id": "get__response_assign_status",
    "method": "GET",
    "path": "/response/assign/status",
    "public_path": "/api/response/assign/status",
    "auth": "session_csrf",
    "path_template": "/response/assign/status",
    "domain": "response"
  },
  "get__response_automations_status": {
    "operation_id": "get__response_automations_status",
    "method": "GET",
    "path": "/response/automations/status",
    "public_path": "/api/response/automations/status",
    "auth": "session_csrf",
    "path_template": "/response/automations/status",
    "domain": "response"
  },
  "get__response_board_status": {
    "operation_id": "get__response_board_status",
    "method": "GET",
    "path": "/response/board/status",
    "public_path": "/api/response/board/status",
    "auth": "session_csrf",
    "path_template": "/response/board/status",
    "domain": "response"
  },
  "get__response_cases_status": {
    "operation_id": "get__response_cases_status",
    "method": "GET",
    "path": "/response/cases/status",
    "public_path": "/api/response/cases/status",
    "auth": "session_csrf",
    "path_template": "/response/cases/status",
    "domain": "response"
  },
  "get__response_cell_status": {
    "operation_id": "get__response_cell_status",
    "method": "GET",
    "path": "/response/cell/status",
    "public_path": "/api/response/cell/status",
    "auth": "session_csrf",
    "path_template": "/response/cell/status",
    "domain": "response"
  },
  "get__response_drill_status": {
    "operation_id": "get__response_drill_status",
    "method": "GET",
    "path": "/response/drill/status",
    "public_path": "/api/response/drill/status",
    "auth": "session_csrf",
    "path_template": "/response/drill/status",
    "domain": "response"
  },
  "get__response_equipment_status": {
    "operation_id": "get__response_equipment_status",
    "method": "GET",
    "path": "/response/equipment/status",
    "public_path": "/api/response/equipment/status",
    "auth": "session_csrf",
    "path_template": "/response/equipment/status",
    "domain": "response"
  },
  "post__response_hybrid_runs": {
    "operation_id": "post__response_hybrid_runs",
    "method": "POST",
    "path": "/response/hybrid/runs",
    "public_path": "/api/response/hybrid/runs",
    "auth": "session_csrf",
    "path_template": "/response/hybrid/runs",
    "domain": "response"
  },
  "get__response_hybrid_runs_p": {
    "operation_id": "get__response_hybrid_runs_p",
    "method": "GET",
    "path": "/response/hybrid/runs/{run_id}",
    "public_path": "/api/response/hybrid/runs/{run_id}",
    "auth": "session_csrf",
    "path_template": "/response/hybrid/runs/{param}",
    "domain": "response"
  },
  "post__response_hybrid_runs_p_approval": {
    "operation_id": "post__response_hybrid_runs_p_approval",
    "method": "POST",
    "path": "/response/hybrid/runs/{run_id}/approval",
    "public_path": "/api/response/hybrid/runs/{run_id}/approval",
    "auth": "session_csrf",
    "path_template": "/response/hybrid/runs/{param}/approval",
    "domain": "response"
  },
  "post__response_hybrid_runs_p_cancel": {
    "operation_id": "post__response_hybrid_runs_p_cancel",
    "method": "POST",
    "path": "/response/hybrid/runs/{run_id}/cancel",
    "public_path": "/api/response/hybrid/runs/{run_id}/cancel",
    "auth": "session_csrf",
    "path_template": "/response/hybrid/runs/{param}/cancel",
    "domain": "response"
  },
  "get__response_playbook_status": {
    "operation_id": "get__response_playbook_status",
    "method": "GET",
    "path": "/response/playbook/status",
    "public_path": "/api/response/playbook/status",
    "auth": "session_csrf",
    "path_template": "/response/playbook/status",
    "domain": "response"
  },
  "get__response_readiness_status": {
    "operation_id": "get__response_readiness_status",
    "method": "GET",
    "path": "/response/readiness/status",
    "public_path": "/api/response/readiness/status",
    "auth": "session_csrf",
    "path_template": "/response/readiness/status",
    "domain": "response"
  },
  "get__response_robots_status": {
    "operation_id": "get__response_robots_status",
    "method": "GET",
    "path": "/response/robots/status",
    "public_path": "/api/response/robots/status",
    "auth": "session_csrf",
    "path_template": "/response/robots/status",
    "domain": "response"
  },
  "get__response_roster_status": {
    "operation_id": "get__response_roster_status",
    "method": "GET",
    "path": "/response/roster/status",
    "public_path": "/api/response/roster/status",
    "auth": "session_csrf",
    "path_template": "/response/roster/status",
    "domain": "response"
  },
  "get__response_rules_status": {
    "operation_id": "get__response_rules_status",
    "method": "GET",
    "path": "/response/rules/status",
    "public_path": "/api/response/rules/status",
    "auth": "session_csrf",
    "path_template": "/response/rules/status",
    "domain": "response"
  },
  "get__response_status": {
    "operation_id": "get__response_status",
    "method": "GET",
    "path": "/response/status",
    "public_path": "/api/response/status",
    "auth": "session_csrf",
    "path_template": "/response/status",
    "domain": "response"
  },
  "get__root": {
    "operation_id": "get__root",
    "method": "GET",
    "path": "/",
    "public_path": "/api/",
    "auth": "none",
    "path_template": "/",
    "domain": "root"
  },
  "get__sa_ai-tools_status": {
    "operation_id": "get__sa_ai-tools_status",
    "method": "GET",
    "path": "/sa/ai-tools/status",
    "public_path": "/api/sa/ai-tools/status",
    "auth": "sa",
    "path_template": "/sa/ai-tools/status",
    "domain": "sa"
  },
  "get__sa_ai_actuators": {
    "operation_id": "get__sa_ai_actuators",
    "method": "GET",
    "path": "/sa/ai/actuators",
    "public_path": "/api/sa/ai/actuators",
    "auth": "sa",
    "path_template": "/sa/ai/actuators",
    "domain": "sa"
  },
  "put__sa_ai_actuators": {
    "operation_id": "put__sa_ai_actuators",
    "method": "PUT",
    "path": "/sa/ai/actuators",
    "public_path": "/api/sa/ai/actuators",
    "auth": "sa",
    "path_template": "/sa/ai/actuators",
    "domain": "sa"
  },
  "get__sa_ai_egress-hosts": {
    "operation_id": "get__sa_ai_egress-hosts",
    "method": "GET",
    "path": "/sa/ai/egress-hosts",
    "public_path": "/api/sa/ai/egress-hosts",
    "auth": "sa",
    "path_template": "/sa/ai/egress-hosts",
    "domain": "sa"
  },
  "put__sa_ai_egress-hosts": {
    "operation_id": "put__sa_ai_egress-hosts",
    "method": "PUT",
    "path": "/sa/ai/egress-hosts",
    "public_path": "/api/sa/ai/egress-hosts",
    "auth": "sa",
    "path_template": "/sa/ai/egress-hosts",
    "domain": "sa"
  },
  "get__sa_ai_eval-gate": {
    "operation_id": "get__sa_ai_eval-gate",
    "method": "GET",
    "path": "/sa/ai/eval-gate",
    "public_path": "/api/sa/ai/eval-gate",
    "auth": "sa",
    "path_template": "/sa/ai/eval-gate",
    "domain": "sa"
  },
  "put__sa_ai_eval-gate": {
    "operation_id": "put__sa_ai_eval-gate",
    "method": "PUT",
    "path": "/sa/ai/eval-gate",
    "public_path": "/api/sa/ai/eval-gate",
    "auth": "sa",
    "path_template": "/sa/ai/eval-gate",
    "domain": "sa"
  },
  "get__sa_ai_live-tenants": {
    "operation_id": "get__sa_ai_live-tenants",
    "method": "GET",
    "path": "/sa/ai/live-tenants",
    "public_path": "/api/sa/ai/live-tenants",
    "auth": "sa",
    "path_template": "/sa/ai/live-tenants",
    "domain": "sa"
  },
  "put__sa_ai_live-tenants": {
    "operation_id": "put__sa_ai_live-tenants",
    "method": "PUT",
    "path": "/sa/ai/live-tenants",
    "public_path": "/api/sa/ai/live-tenants",
    "auth": "sa",
    "path_template": "/sa/ai/live-tenants",
    "domain": "sa"
  },
  "get__sa_ai_vault-refs": {
    "operation_id": "get__sa_ai_vault-refs",
    "method": "GET",
    "path": "/sa/ai/vault-refs",
    "public_path": "/api/sa/ai/vault-refs",
    "auth": "sa",
    "path_template": "/sa/ai/vault-refs",
    "domain": "sa"
  },
  "put__sa_ai_vault-refs": {
    "operation_id": "put__sa_ai_vault-refs",
    "method": "PUT",
    "path": "/sa/ai/vault-refs",
    "public_path": "/api/sa/ai/vault-refs",
    "auth": "sa",
    "path_template": "/sa/ai/vault-refs",
    "domain": "sa"
  },
  "get__sa_audit_status": {
    "operation_id": "get__sa_audit_status",
    "method": "GET",
    "path": "/sa/audit/status",
    "public_path": "/api/sa/audit/status",
    "auth": "sa",
    "path_template": "/sa/audit/status",
    "domain": "sa"
  },
  "get__sa_caps_status": {
    "operation_id": "get__sa_caps_status",
    "method": "GET",
    "path": "/sa/caps/status",
    "public_path": "/api/sa/caps/status",
    "auth": "sa",
    "path_template": "/sa/caps/status",
    "domain": "sa"
  },
  "get__sa_catalog": {
    "operation_id": "get__sa_catalog",
    "method": "GET",
    "path": "/sa/catalog",
    "public_path": "/api/sa/catalog",
    "auth": "sa",
    "path_template": "/sa/catalog",
    "domain": "sa"
  },
  "get__sa_custody_status": {
    "operation_id": "get__sa_custody_status",
    "method": "GET",
    "path": "/sa/custody/status",
    "public_path": "/api/sa/custody/status",
    "auth": "sa",
    "path_template": "/sa/custody/status",
    "domain": "sa"
  },
  "post__sa_devices_custody": {
    "operation_id": "post__sa_devices_custody",
    "method": "POST",
    "path": "/sa/devices/custody",
    "public_path": "/api/sa/devices/custody",
    "auth": "sa",
    "path_template": "/sa/devices/custody",
    "domain": "sa"
  },
  "get__sa_models_status": {
    "operation_id": "get__sa_models_status",
    "method": "GET",
    "path": "/sa/models/status",
    "public_path": "/api/sa/models/status",
    "auth": "sa",
    "path_template": "/sa/models/status",
    "domain": "sa"
  },
  "get__sa_notification-groups_shares": {
    "operation_id": "get__sa_notification-groups_shares",
    "method": "GET",
    "path": "/sa/notification-groups/shares",
    "public_path": "/api/sa/notification-groups/shares",
    "auth": "sa",
    "path_template": "/sa/notification-groups/shares",
    "domain": "sa"
  },
  "get__sa_platform_domains": {
    "operation_id": "get__sa_platform_domains",
    "method": "GET",
    "path": "/sa/platform/domains",
    "public_path": "/api/sa/platform/domains",
    "auth": "sa",
    "path_template": "/sa/platform/domains",
    "domain": "sa"
  },
  "get__sa_resource-fabric_adapter-certifications": {
    "operation_id": "get__sa_resource-fabric_adapter-certifications",
    "method": "GET",
    "path": "/sa/resource-fabric/adapter-certifications",
    "public_path": "/api/sa/resource-fabric/adapter-certifications",
    "auth": "sa",
    "path_template": "/sa/resource-fabric/adapter-certifications",
    "domain": "sa"
  },
  "post__sa_resource-fabric_adapter-certifications": {
    "operation_id": "post__sa_resource-fabric_adapter-certifications",
    "method": "POST",
    "path": "/sa/resource-fabric/adapter-certifications",
    "public_path": "/api/sa/resource-fabric/adapter-certifications",
    "auth": "sa",
    "path_template": "/sa/resource-fabric/adapter-certifications",
    "domain": "sa"
  },
  "post__sa_resource-fabric_adapter-certifications_p_decisions": {
    "operation_id": "post__sa_resource-fabric_adapter-certifications_p_decisions",
    "method": "POST",
    "path": "/sa/resource-fabric/adapter-certifications/{certification_id}/decisions",
    "public_path": "/api/sa/resource-fabric/adapter-certifications/{certification_id}/decisions",
    "auth": "sa",
    "path_template": "/sa/resource-fabric/adapter-certifications/{param}/decisions",
    "domain": "sa"
  },
  "post__sa_resource-fabric_adapter-certifications_p_revoke": {
    "operation_id": "post__sa_resource-fabric_adapter-certifications_p_revoke",
    "method": "POST",
    "path": "/sa/resource-fabric/adapter-certifications/{certification_id}/revoke",
    "public_path": "/api/sa/resource-fabric/adapter-certifications/{certification_id}/revoke",
    "auth": "sa",
    "path_template": "/sa/resource-fabric/adapter-certifications/{param}/revoke",
    "domain": "sa"
  },
  "post__sa_security_device-mtls_mint": {
    "operation_id": "post__sa_security_device-mtls_mint",
    "method": "POST",
    "path": "/sa/security/device-mtls/mint",
    "public_path": "/api/sa/security/device-mtls/mint",
    "auth": "sa",
    "path_template": "/sa/security/device-mtls/mint",
    "domain": "sa"
  },
  "get__sa_security_device-mtls_readiness": {
    "operation_id": "get__sa_security_device-mtls_readiness",
    "method": "GET",
    "path": "/sa/security/device-mtls/readiness",
    "public_path": "/api/sa/security/device-mtls/readiness",
    "auth": "sa",
    "path_template": "/sa/security/device-mtls/readiness",
    "domain": "sa"
  },
  "get__sa_security_mac-drift": {
    "operation_id": "get__sa_security_mac-drift",
    "method": "GET",
    "path": "/sa/security/mac-drift",
    "public_path": "/api/sa/security/mac-drift",
    "auth": "sa",
    "path_template": "/sa/security/mac-drift",
    "domain": "sa"
  },
  "get__sa_security_status": {
    "operation_id": "get__sa_security_status",
    "method": "GET",
    "path": "/sa/security/status",
    "public_path": "/api/sa/security/status",
    "auth": "sa",
    "path_template": "/sa/security/status",
    "domain": "sa"
  },
  "get__sa_status": {
    "operation_id": "get__sa_status",
    "method": "GET",
    "path": "/sa/status",
    "public_path": "/api/sa/status",
    "auth": "sa",
    "path_template": "/sa/status",
    "domain": "sa"
  },
  "get__sa_team": {
    "operation_id": "get__sa_team",
    "method": "GET",
    "path": "/sa/team",
    "public_path": "/api/sa/team",
    "auth": "sa",
    "path_template": "/sa/team",
    "domain": "sa"
  },
  "post__sa_team_provision": {
    "operation_id": "post__sa_team_provision",
    "method": "POST",
    "path": "/sa/team/provision",
    "public_path": "/api/sa/team/provision",
    "auth": "sa",
    "path_template": "/sa/team/provision",
    "domain": "sa"
  },
  "get__sa_team_status": {
    "operation_id": "get__sa_team_status",
    "method": "GET",
    "path": "/sa/team/status",
    "public_path": "/api/sa/team/status",
    "auth": "sa",
    "path_template": "/sa/team/status",
    "domain": "sa"
  },
  "post__sa_team_p_ttl": {
    "operation_id": "post__sa_team_p_ttl",
    "method": "POST",
    "path": "/sa/team/{username}/ttl",
    "public_path": "/api/sa/team/{username}/ttl",
    "auth": "sa",
    "path_template": "/sa/team/{param}/ttl",
    "domain": "sa"
  },
  "get__sa_tenant_status": {
    "operation_id": "get__sa_tenant_status",
    "method": "GET",
    "path": "/sa/tenant/status",
    "public_path": "/api/sa/tenant/status",
    "auth": "sa",
    "path_template": "/sa/tenant/status",
    "domain": "sa"
  },
  "get__sa_v3_dlq_mqtt": {
    "operation_id": "get__sa_v3_dlq_mqtt",
    "method": "GET",
    "path": "/sa/v3/dlq/mqtt",
    "public_path": "/api/sa/v3/dlq/mqtt",
    "auth": "sa",
    "path_template": "/sa/v3/dlq/mqtt",
    "domain": "sa"
  },
  "post__sa_v3_dlq_mqtt_p_replay": {
    "operation_id": "post__sa_v3_dlq_mqtt_p_replay",
    "method": "POST",
    "path": "/sa/v3/dlq/mqtt/{mqtt_job_id}/replay",
    "public_path": "/api/sa/v3/dlq/mqtt/{mqtt_job_id}/replay",
    "auth": "sa",
    "path_template": "/sa/v3/dlq/mqtt/{param}/replay",
    "domain": "sa"
  },
  "get__settings_ai_status": {
    "operation_id": "get__settings_ai_status",
    "method": "GET",
    "path": "/settings/ai/status",
    "public_path": "/api/settings/ai/status",
    "auth": "session_csrf",
    "path_template": "/settings/ai/status",
    "domain": "settings"
  },
  "get__settings_alarm_status": {
    "operation_id": "get__settings_alarm_status",
    "method": "GET",
    "path": "/settings/alarm/status",
    "public_path": "/api/settings/alarm/status",
    "auth": "session_csrf",
    "path_template": "/settings/alarm/status",
    "domain": "settings"
  },
  "get__settings_audit_status": {
    "operation_id": "get__settings_audit_status",
    "method": "GET",
    "path": "/settings/audit/status",
    "public_path": "/api/settings/audit/status",
    "auth": "session_csrf",
    "path_template": "/settings/audit/status",
    "domain": "settings"
  },
  "get__settings_billing_status": {
    "operation_id": "get__settings_billing_status",
    "method": "GET",
    "path": "/settings/billing/status",
    "public_path": "/api/settings/billing/status",
    "auth": "session_csrf",
    "path_template": "/settings/billing/status",
    "domain": "settings"
  },
  "get__settings_cameras_status": {
    "operation_id": "get__settings_cameras_status",
    "method": "GET",
    "path": "/settings/cameras/status",
    "public_path": "/api/settings/cameras/status",
    "auth": "session_csrf",
    "path_template": "/settings/cameras/status",
    "domain": "settings"
  },
  "get__settings_danger_status": {
    "operation_id": "get__settings_danger_status",
    "method": "GET",
    "path": "/settings/danger/status",
    "public_path": "/api/settings/danger/status",
    "auth": "session_csrf",
    "path_template": "/settings/danger/status",
    "domain": "settings"
  },
  "get__settings_delegations_status": {
    "operation_id": "get__settings_delegations_status",
    "method": "GET",
    "path": "/settings/delegations/status",
    "public_path": "/api/settings/delegations/status",
    "auth": "session_csrf",
    "path_template": "/settings/delegations/status",
    "domain": "settings"
  },
  "get__settings_fabric_status": {
    "operation_id": "get__settings_fabric_status",
    "method": "GET",
    "path": "/settings/fabric/status",
    "public_path": "/api/settings/fabric/status",
    "auth": "session_csrf",
    "path_template": "/settings/fabric/status",
    "domain": "settings"
  },
  "get__settings_integrate_status": {
    "operation_id": "get__settings_integrate_status",
    "method": "GET",
    "path": "/settings/integrate/status",
    "public_path": "/api/settings/integrate/status",
    "auth": "session_csrf",
    "path_template": "/settings/integrate/status",
    "domain": "settings"
  },
  "get__settings_models_status": {
    "operation_id": "get__settings_models_status",
    "method": "GET",
    "path": "/settings/models/status",
    "public_path": "/api/settings/models/status",
    "auth": "session_csrf",
    "path_template": "/settings/models/status",
    "domain": "settings"
  },
  "get__settings_notify_status": {
    "operation_id": "get__settings_notify_status",
    "method": "GET",
    "path": "/settings/notify/status",
    "public_path": "/api/settings/notify/status",
    "auth": "session_csrf",
    "path_template": "/settings/notify/status",
    "domain": "settings"
  },
  "get__settings_ota_status": {
    "operation_id": "get__settings_ota_status",
    "method": "GET",
    "path": "/settings/ota/status",
    "public_path": "/api/settings/ota/status",
    "auth": "session_csrf",
    "path_template": "/settings/ota/status",
    "domain": "settings"
  },
  "get__settings_profile_status": {
    "operation_id": "get__settings_profile_status",
    "method": "GET",
    "path": "/settings/profile/status",
    "public_path": "/api/settings/profile/status",
    "auth": "session_csrf",
    "path_template": "/settings/profile/status",
    "domain": "settings"
  },
  "get__settings_security_status": {
    "operation_id": "get__settings_security_status",
    "method": "GET",
    "path": "/settings/security/status",
    "public_path": "/api/settings/security/status",
    "auth": "session_csrf",
    "path_template": "/settings/security/status",
    "domain": "settings"
  },
  "get__settings_sessions_status": {
    "operation_id": "get__settings_sessions_status",
    "method": "GET",
    "path": "/settings/sessions/status",
    "public_path": "/api/settings/sessions/status",
    "auth": "session_csrf",
    "path_template": "/settings/sessions/status",
    "domain": "settings"
  },
  "get__settings_sites_status": {
    "operation_id": "get__settings_sites_status",
    "method": "GET",
    "path": "/settings/sites/status",
    "public_path": "/api/settings/sites/status",
    "auth": "session_csrf",
    "path_template": "/settings/sites/status",
    "domain": "settings"
  },
  "get__settings_status": {
    "operation_id": "get__settings_status",
    "method": "GET",
    "path": "/settings/status",
    "public_path": "/api/settings/status",
    "auth": "session_csrf",
    "path_template": "/settings/status",
    "domain": "settings"
  },
  "get__settings_trigger_status": {
    "operation_id": "get__settings_trigger_status",
    "method": "GET",
    "path": "/settings/trigger/status",
    "public_path": "/api/settings/trigger/status",
    "auth": "session_csrf",
    "path_template": "/settings/trigger/status",
    "domain": "settings"
  },
  "get__shares": {
    "operation_id": "get__shares",
    "method": "GET",
    "path": "/shares",
    "public_path": "/api/shares",
    "auth": "session_csrf",
    "path_template": "/shares",
    "domain": "shares"
  },
  "post__shares_keys": {
    "operation_id": "post__shares_keys",
    "method": "POST",
    "path": "/shares/keys",
    "public_path": "/api/shares/keys",
    "auth": "session_csrf",
    "path_template": "/shares/keys",
    "domain": "shares"
  },
  "post__shares_redeem": {
    "operation_id": "post__shares_redeem",
    "method": "POST",
    "path": "/shares/redeem",
    "public_path": "/api/shares/redeem",
    "auth": "session_csrf",
    "path_template": "/shares/redeem",
    "domain": "shares"
  },
  "delete__shares_p": {
    "operation_id": "delete__shares_p",
    "method": "DELETE",
    "path": "/shares/{share_id}",
    "public_path": "/api/shares/{share_id}",
    "auth": "session_csrf",
    "path_template": "/shares/{param}",
    "domain": "shares"
  },
  "post__simulations": {
    "operation_id": "post__simulations",
    "method": "POST",
    "path": "/simulations",
    "public_path": "/api/simulations",
    "auth": "session_csrf",
    "path_template": "/simulations",
    "domain": "simulations"
  },
  "get__simulations_p": {
    "operation_id": "get__simulations_p",
    "method": "GET",
    "path": "/simulations/{simulation_id}",
    "public_path": "/api/simulations/{simulation_id}",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}",
    "domain": "simulations"
  },
  "get__simulations_p_audit": {
    "operation_id": "get__simulations_p_audit",
    "method": "GET",
    "path": "/simulations/{simulation_id}/audit",
    "public_path": "/api/simulations/{simulation_id}/audit",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/audit",
    "domain": "simulations"
  },
  "get__simulations_p_live-approval": {
    "operation_id": "get__simulations_p_live-approval",
    "method": "GET",
    "path": "/simulations/{simulation_id}/live-approval",
    "public_path": "/api/simulations/{simulation_id}/live-approval",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/live-approval",
    "domain": "simulations"
  },
  "post__simulations_p_live-approval_approve": {
    "operation_id": "post__simulations_p_live-approval_approve",
    "method": "POST",
    "path": "/simulations/{simulation_id}/live-approval/approve",
    "public_path": "/api/simulations/{simulation_id}/live-approval/approve",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/live-approval/approve",
    "domain": "simulations"
  },
  "post__simulations_p_live-approval_request": {
    "operation_id": "post__simulations_p_live-approval_request",
    "method": "POST",
    "path": "/simulations/{simulation_id}/live-approval/request",
    "public_path": "/api/simulations/{simulation_id}/live-approval/request",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/live-approval/request",
    "domain": "simulations"
  },
  "get__simulations_p_report": {
    "operation_id": "get__simulations_p_report",
    "method": "GET",
    "path": "/simulations/{simulation_id}/report",
    "public_path": "/api/simulations/{simulation_id}/report",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/report",
    "domain": "simulations"
  },
  "post__simulations_p_run": {
    "operation_id": "post__simulations_p_run",
    "method": "POST",
    "path": "/simulations/{simulation_id}/run",
    "public_path": "/api/simulations/{simulation_id}/run",
    "auth": "session_csrf",
    "path_template": "/simulations/{param}/run",
    "domain": "simulations"
  },
  "get__snapshots_p_image": {
    "operation_id": "get__snapshots_p_image",
    "method": "GET",
    "path": "/snapshots/{event_id}/image",
    "public_path": "/api/snapshots/{event_id}/image",
    "auth": "session_csrf",
    "path_template": "/snapshots/{param}/image",
    "domain": "snapshots"
  },
  "get__sop": {
    "operation_id": "get__sop",
    "method": "GET",
    "path": "/sop",
    "public_path": "/api/sop",
    "auth": "session_csrf",
    "path_template": "/sop",
    "domain": "sop"
  },
  "post__sop": {
    "operation_id": "post__sop",
    "method": "POST",
    "path": "/sop",
    "public_path": "/api/sop",
    "auth": "session_csrf",
    "path_template": "/sop",
    "domain": "sop"
  },
  "get__sop_recommendations": {
    "operation_id": "get__sop_recommendations",
    "method": "GET",
    "path": "/sop/recommendations",
    "public_path": "/api/sop/recommendations",
    "auth": "session_csrf",
    "path_template": "/sop/recommendations",
    "domain": "sop"
  },
  "post__sop_p_feedback": {
    "operation_id": "post__sop_p_feedback",
    "method": "POST",
    "path": "/sop/{sop_id}/feedback",
    "public_path": "/api/sop/{sop_id}/feedback",
    "auth": "session_csrf",
    "path_template": "/sop/{param}/feedback",
    "domain": "sop"
  },
  "get__support_avatar-ban-review": {
    "operation_id": "get__support_avatar-ban-review",
    "method": "GET",
    "path": "/support/avatar-ban-review",
    "public_path": "/api/support/avatar-ban-review",
    "auth": "session_csrf",
    "path_template": "/support/avatar-ban-review",
    "domain": "support"
  },
  "post__support_avatar-ban-review": {
    "operation_id": "post__support_avatar-ban-review",
    "method": "POST",
    "path": "/support/avatar-ban-review",
    "public_path": "/api/support/avatar-ban-review",
    "auth": "session_csrf",
    "path_template": "/support/avatar-ban-review",
    "domain": "support"
  },
  "get__swarm_status": {
    "operation_id": "get__swarm_status",
    "method": "GET",
    "path": "/swarm/status",
    "public_path": "/api/swarm/status",
    "auth": "session_csrf",
    "path_template": "/swarm/status",
    "domain": "swarm"
  },
  "post__telegram_link-token": {
    "operation_id": "post__telegram_link-token",
    "method": "POST",
    "path": "/telegram/link-token",
    "public_path": "/api/telegram/link-token",
    "auth": "session_csrf",
    "path_template": "/telegram/link-token",
    "domain": "telegram"
  },
  "post__twilio_voice_status": {
    "operation_id": "post__twilio_voice_status",
    "method": "POST",
    "path": "/twilio/voice/status",
    "public_path": "/api/twilio/voice/status",
    "auth": "session_csrf",
    "path_template": "/twilio/voice/status",
    "domain": "twilio"
  },
  "post__twilio_voice_twiml": {
    "operation_id": "post__twilio_voice_twiml",
    "method": "POST",
    "path": "/twilio/voice/twiml",
    "public_path": "/api/twilio/voice/twiml",
    "auth": "session_csrf",
    "path_template": "/twilio/voice/twiml",
    "domain": "twilio"
  },
  "post__twin-bridge_fabric_dispatch": {
    "operation_id": "post__twin-bridge_fabric_dispatch",
    "method": "POST",
    "path": "/twin-bridge/fabric/dispatch",
    "public_path": "/api/twin-bridge/fabric/dispatch",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/dispatch",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fabric_dispatch-multi": {
    "operation_id": "post__twin-bridge_fabric_dispatch-multi",
    "method": "POST",
    "path": "/twin-bridge/fabric/dispatch-multi",
    "public_path": "/api/twin-bridge/fabric/dispatch-multi",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/dispatch-multi",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_health": {
    "operation_id": "get__twin-bridge_fabric_health",
    "method": "GET",
    "path": "/twin-bridge/fabric/health",
    "public_path": "/api/twin-bridge/fabric/health",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/health",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_nodes": {
    "operation_id": "get__twin-bridge_fabric_nodes",
    "method": "GET",
    "path": "/twin-bridge/fabric/nodes",
    "public_path": "/api/twin-bridge/fabric/nodes",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/nodes",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fabric_nodes_p_quarantine": {
    "operation_id": "post__twin-bridge_fabric_nodes_p_quarantine",
    "method": "POST",
    "path": "/twin-bridge/fabric/nodes/{worker_id}/quarantine",
    "public_path": "/api/twin-bridge/fabric/nodes/{worker_id}/quarantine",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/nodes/{param}/quarantine",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_quarantine_rules": {
    "operation_id": "get__twin-bridge_fabric_quarantine_rules",
    "method": "GET",
    "path": "/twin-bridge/fabric/quarantine/rules",
    "public_path": "/api/twin-bridge/fabric/quarantine/rules",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/quarantine/rules",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_readiness": {
    "operation_id": "get__twin-bridge_fabric_readiness",
    "method": "GET",
    "path": "/twin-bridge/fabric/readiness",
    "public_path": "/api/twin-bridge/fabric/readiness",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/readiness",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_result-bindings": {
    "operation_id": "get__twin-bridge_fabric_result-bindings",
    "method": "GET",
    "path": "/twin-bridge/fabric/result-bindings",
    "public_path": "/api/twin-bridge/fabric/result-bindings",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/result-bindings",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fabric_result-bindings_verify": {
    "operation_id": "post__twin-bridge_fabric_result-bindings_verify",
    "method": "POST",
    "path": "/twin-bridge/fabric/result-bindings/verify",
    "public_path": "/api/twin-bridge/fabric/result-bindings/verify",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/result-bindings/verify",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_schedule": {
    "operation_id": "get__twin-bridge_fabric_schedule",
    "method": "GET",
    "path": "/twin-bridge/fabric/schedule",
    "public_path": "/api/twin-bridge/fabric/schedule",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/schedule",
    "domain": "twin-bridge"
  },
  "put__twin-bridge_fabric_schedule": {
    "operation_id": "put__twin-bridge_fabric_schedule",
    "method": "PUT",
    "path": "/twin-bridge/fabric/schedule",
    "public_path": "/api/twin-bridge/fabric/schedule",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/schedule",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_trust-posture": {
    "operation_id": "get__twin-bridge_fabric_trust-posture",
    "method": "GET",
    "path": "/twin-bridge/fabric/trust-posture",
    "public_path": "/api/twin-bridge/fabric/trust-posture",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/trust-posture",
    "domain": "twin-bridge"
  },
  "put__twin-bridge_fabric_trust-posture": {
    "operation_id": "put__twin-bridge_fabric_trust-posture",
    "method": "PUT",
    "path": "/twin-bridge/fabric/trust-posture",
    "public_path": "/api/twin-bridge/fabric/trust-posture",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/trust-posture",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fabric_trust-tiers": {
    "operation_id": "get__twin-bridge_fabric_trust-tiers",
    "method": "GET",
    "path": "/twin-bridge/fabric/trust-tiers",
    "public_path": "/api/twin-bridge/fabric/trust-tiers",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fabric/trust-tiers",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fde-invites": {
    "operation_id": "get__twin-bridge_fde-invites",
    "method": "GET",
    "path": "/twin-bridge/fde-invites",
    "public_path": "/api/twin-bridge/fde-invites",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-invites",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fde-invites": {
    "operation_id": "post__twin-bridge_fde-invites",
    "method": "POST",
    "path": "/twin-bridge/fde-invites",
    "public_path": "/api/twin-bridge/fde-invites",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-invites",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fde-invites_health": {
    "operation_id": "get__twin-bridge_fde-invites_health",
    "method": "GET",
    "path": "/twin-bridge/fde-invites/health",
    "public_path": "/api/twin-bridge/fde-invites/health",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-invites/health",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fde-invites_p_revoke": {
    "operation_id": "post__twin-bridge_fde-invites_p_revoke",
    "method": "POST",
    "path": "/twin-bridge/fde-invites/{invite_id}/revoke",
    "public_path": "/api/twin-bridge/fde-invites/{invite_id}/revoke",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-invites/{param}/revoke",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fde-provision-grants": {
    "operation_id": "get__twin-bridge_fde-provision-grants",
    "method": "GET",
    "path": "/twin-bridge/fde-provision-grants",
    "public_path": "/api/twin-bridge/fde-provision-grants",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fde-provision-grants": {
    "operation_id": "post__twin-bridge_fde-provision-grants",
    "method": "POST",
    "path": "/twin-bridge/fde-provision-grants",
    "public_path": "/api/twin-bridge/fde-provision-grants",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fde-provision-grants_health": {
    "operation_id": "get__twin-bridge_fde-provision-grants_health",
    "method": "GET",
    "path": "/twin-bridge/fde-provision-grants/health",
    "public_path": "/api/twin-bridge/fde-provision-grants/health",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants/health",
    "domain": "twin-bridge"
  },
  "get__twin-bridge_fde-provision-grants_preview": {
    "operation_id": "get__twin-bridge_fde-provision-grants_preview",
    "method": "GET",
    "path": "/twin-bridge/fde-provision-grants/preview",
    "public_path": "/api/twin-bridge/fde-provision-grants/preview",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants/preview",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fde-provision-grants_redeem": {
    "operation_id": "post__twin-bridge_fde-provision-grants_redeem",
    "method": "POST",
    "path": "/twin-bridge/fde-provision-grants/redeem",
    "public_path": "/api/twin-bridge/fde-provision-grants/redeem",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants/redeem",
    "domain": "twin-bridge"
  },
  "post__twin-bridge_fde-provision-grants_p_revoke": {
    "operation_id": "post__twin-bridge_fde-provision-grants_p_revoke",
    "method": "POST",
    "path": "/twin-bridge/fde-provision-grants/{grant_id}/revoke",
    "public_path": "/api/twin-bridge/fde-provision-grants/{grant_id}/revoke",
    "auth": "session_csrf",
    "path_template": "/twin-bridge/fde-provision-grants/{param}/revoke",
    "domain": "twin-bridge"
  },
  "get__udock_status": {
    "operation_id": "get__udock_status",
    "method": "GET",
    "path": "/udock/status",
    "public_path": "/api/udock/status",
    "auth": "session_csrf",
    "path_template": "/udock/status",
    "domain": "udock"
  },
  "delete__udock_whep-sentry_p": {
    "operation_id": "delete__udock_whep-sentry_p",
    "method": "DELETE",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "get__udock_whep-sentry_p": {
    "operation_id": "get__udock_whep-sentry_p",
    "method": "GET",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "head__udock_whep-sentry_p": {
    "operation_id": "head__udock_whep-sentry_p",
    "method": "HEAD",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "options__udock_whep-sentry_p": {
    "operation_id": "options__udock_whep-sentry_p",
    "method": "OPTIONS",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "patch__udock_whep-sentry_p": {
    "operation_id": "patch__udock_whep-sentry_p",
    "method": "PATCH",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "post__udock_whep-sentry_p": {
    "operation_id": "post__udock_whep-sentry_p",
    "method": "POST",
    "path": "/udock/whep-sentry/{ticket_id}",
    "public_path": "/api/udock/whep-sentry/{ticket_id}",
    "auth": "session_csrf",
    "path_template": "/udock/whep-sentry/{param}",
    "domain": "udock"
  },
  "get__ui": {
    "operation_id": "get__ui",
    "method": "GET",
    "path": "/ui",
    "public_path": "/api/ui",
    "auth": "session_csrf",
    "path_template": "/ui",
    "domain": "ui"
  },
  "get__ui_slash": {
    "operation_id": "get__ui_slash",
    "method": "GET",
    "path": "/ui/",
    "public_path": "/api/ui/",
    "auth": "session_csrf",
    "path_template": "/ui/",
    "domain": "ui"
  },
  "get__ui_p": {
    "operation_id": "get__ui_p",
    "method": "GET",
    "path": "/ui/{path:path}",
    "public_path": "/api/ui/{path:path}",
    "auth": "session_csrf",
    "path_template": "/ui/{param}",
    "domain": "ui"
  },
  "delete__unified_devices_p": {
    "operation_id": "delete__unified_devices_p",
    "method": "DELETE",
    "path": "/unified/devices/{device_id}",
    "public_path": "/api/unified/devices/{device_id}",
    "auth": "session_csrf",
    "path_template": "/unified/devices/{param}",
    "domain": "unified"
  },
  "post__unified_devices_p_share": {
    "operation_id": "post__unified_devices_p_share",
    "method": "POST",
    "path": "/unified/devices/{device_id}/share",
    "public_path": "/api/unified/devices/{device_id}/share",
    "auth": "session_csrf",
    "path_template": "/unified/devices/{param}/share",
    "domain": "unified"
  },
  "delete__unified_groups_p": {
    "operation_id": "delete__unified_groups_p",
    "method": "DELETE",
    "path": "/unified/groups/{group_key}",
    "public_path": "/api/unified/groups/{group_key}",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}",
    "domain": "unified"
  },
  "get__unified_groups_p_devices": {
    "operation_id": "get__unified_groups_p_devices",
    "method": "GET",
    "path": "/unified/groups/{group_key}/devices",
    "public_path": "/api/unified/groups/{group_key}/devices",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/devices",
    "domain": "unified"
  },
  "delete__unified_groups_p_grants": {
    "operation_id": "delete__unified_groups_p_grants",
    "method": "DELETE",
    "path": "/unified/groups/{group_key}/grants",
    "public_path": "/api/unified/groups/{group_key}/grants",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/grants",
    "domain": "unified"
  },
  "get__unified_groups_p_grants": {
    "operation_id": "get__unified_groups_p_grants",
    "method": "GET",
    "path": "/unified/groups/{group_key}/grants",
    "public_path": "/api/unified/groups/{group_key}/grants",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/grants",
    "domain": "unified"
  },
  "post__unified_groups_p_grants": {
    "operation_id": "post__unified_groups_p_grants",
    "method": "POST",
    "path": "/unified/groups/{group_key}/grants",
    "public_path": "/api/unified/groups/{group_key}/grants",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/grants",
    "domain": "unified"
  },
  "delete__unified_groups_p_members": {
    "operation_id": "delete__unified_groups_p_members",
    "method": "DELETE",
    "path": "/unified/groups/{group_key}/members",
    "public_path": "/api/unified/groups/{group_key}/members",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/members",
    "domain": "unified"
  },
  "post__unified_groups_p_members": {
    "operation_id": "post__unified_groups_p_members",
    "method": "POST",
    "path": "/unified/groups/{group_key}/members",
    "public_path": "/api/unified/groups/{group_key}/members",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/members",
    "domain": "unified"
  },
  "post__unified_groups_p_share": {
    "operation_id": "post__unified_groups_p_share",
    "method": "POST",
    "path": "/unified/groups/{group_key}/share",
    "public_path": "/api/unified/groups/{group_key}/share",
    "auth": "session_csrf",
    "path_template": "/unified/groups/{param}/share",
    "domain": "unified"
  },
  "post__v3_commands": {
    "operation_id": "post__v3_commands",
    "method": "POST",
    "path": "/v3/commands",
    "public_path": "/api/v3/commands",
    "auth": "session_csrf",
    "path_template": "/v3/commands",
    "domain": "v3"
  },
  "get__v3_jobs_p": {
    "operation_id": "get__v3_jobs_p",
    "method": "GET",
    "path": "/v3/jobs/{job_id}",
    "public_path": "/api/v3/jobs/{job_id}",
    "auth": "session_csrf",
    "path_template": "/v3/jobs/{param}",
    "domain": "v3"
  },
  "post__webhook_ai-orchestrator": {
    "operation_id": "post__webhook_ai-orchestrator",
    "method": "POST",
    "path": "/webhook/ai-orchestrator",
    "public_path": "/api/webhook/ai-orchestrator",
    "auth": "session_csrf",
    "path_template": "/webhook/ai-orchestrator",
    "domain": "webhook"
  },
  "get__zones": {
    "operation_id": "get__zones",
    "method": "GET",
    "path": "/zones",
    "public_path": "/api/zones",
    "auth": "session_csrf",
    "path_template": "/zones",
    "domain": "zones"
  }
};

/** @type {import("./contract-client.js").ContractOperation[]} */
export const CONTRACT_OPERATIONS = Object.values(CONTRACT_BY_ID);
